/* ========= Bug 83 BidetKing — Announcement bar "Join the VIP Bidet Club" disclosure ============================================= 

   BidetKing — Announcement bar "Join the VIP Bidet Club" disclosure
   Panel: #announcement-bar-newsletter   Theme: Warehouse v4

   Fixes three defects in one place:

   (1) The Close (X) button can never be reached by forward Tab.
       Warehouse traps focus inside the open panel, but its wrap is
       off by one: Tab from "Subscribe" returns to the email field
       instead of to the first control, so keyboard and screen-reader
       users cycle email <-> Subscribe forever and never meet Close.
       (Shift+Tab reaches Close once, then wraps back to email.)
       -> Replaced with a correct cycle that includes Close.

   (2) Opening the panel drops focus straight into the email field,
       mid-region, with no announcement of what opened.
       -> Focus is parked on the labelled region instead, so the
          heading is announced and Close is the first Tab stop.

   (3) Bug 83 - closing the panel (Escape or X) discards focus to
       <body>; it never returns to the trigger.
       -> Focus is returned to the trigger on every close path.

   WCAG 2.2 - 2.4.3 Focus Order (A), 2.1.1 Keyboard (A),
              2.1.2 No Keyboard Trap (A), supports 2.4.7 Focus Visible
   Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  // Set to 'close' to land on the X button instead of the region.
  var FOCUS_ON_OPEN = 'region';   // 'region' | 'close'

  var TRIGGER   = '.announcement-bar__button[data-action="toggle-newsletter"]';
  var PANEL_ID  = 'announcement-bar-newsletter';
  var TITLE_ID  = 'announcement-bar-newsletter-title';
  var CLAIM_MS  = 900;            // window for overriding the theme's autofocus

  var FOCUSABLE = 'a[href], button:not([disabled]), ' +
                  'input:not([disabled]):not([type="hidden"]), ' +
                  'select:not([disabled]), textarea:not([disabled]), ' +
                  '[tabindex]:not([tabindex="-1"])';

  function init() {
    var $trigger = $(TRIGGER).first();
    var $panel   = $('#' + PANEL_ID);
    if (!$trigger.length || !$panel.length) { return; }

    var trigger = $trigger[0];
    var panel   = $panel[0];

    /* --- Markup: name the region, make it programmatically focusable */
    var $title = $panel.find('h2').first();
    if ($title.length && !$title.attr('id')) { $title.attr('id', TITLE_ID); }

    $panel.attr('tabindex', '-1');
    if ($title.length) {
      $panel.attr({ 'role': 'region', 'aria-labelledby': $title.attr('id') });
    }

    $panel.find('.announcement-bar__close')
      .attr('type', 'button')
      .find('svg').attr({ 'aria-hidden': 'true', 'focusable': 'false' });

    /* --- Helpers --------------------------------------------------- */
    function isOpen() {
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    function isVisible(el) {
      return !!(el && el.offsetParent !== null && el.getClientRects().length);
    }

    function focusables() {
      return $.grep($panel.find(FOCUSABLE).toArray(), isVisible);
    }

    /* --- (1) Correct focus cycle -----------------------------------
       Bound on window in the capture phase so it runs before the
       theme's own trap, which is then stopped for this keystroke.   */
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' && e.keyCode !== 9) { return; }
      if (!isOpen()) { return; }

      var items = focusables();
      if (!items.length) { return; }

      var i = $.inArray(document.activeElement, items);
      var next;

      if (i === -1) {                       // focus is on the region itself
        next = e.shiftKey ? items[items.length - 1] : items[0];
      } else {
        next = e.shiftKey ? items[(i - 1 + items.length) % items.length]
                          : items[(i + 1) % items.length];
      }

      // Warehouse sets .is-tabbing on <body> from its own keydown handler;
      // we are stopping that handler, so keep focus styles working.
      document.body.classList.add('is-tabbing');

      e.preventDefault();
      e.stopImmediatePropagation();
      next.focus();
    }, true);

    /* --- (2) Where focus goes on open ------------------------------ */
    var claimUntil = 0;

    function focusOnOpenTarget() {
      if (!isOpen()) { return; }
      if (FOCUS_ON_OPEN === 'close') {
        var close = $panel.find('.announcement-bar__close')[0];
        if (isVisible(close)) { close.focus(); return; }
      }
      panel.focus();
    }

    function onOpen() {
      claimUntil = Date.now() + CLAIM_MS;
      focusOnOpenTarget();
      // The theme re-focuses the email field on transitionend (~500ms).
      window.setTimeout(function () {
        if (claimUntil && Date.now() <= claimUntil + 50) { focusOnOpenTarget(); }
      }, 560);
    }

    // Catch the theme's autofocus the moment it lands and redirect once.
    panel.addEventListener('focusin', function (e) {
      if (!claimUntil || Date.now() > claimUntil) { return; }  // user-initiated
      if (e.target === panel) { return; }
      if (!$(e.target).is('input.form__field')) { return; }
      claimUntil = 0;                                          // redirect once only
      window.setTimeout(focusOnOpenTarget, 0);
    });

    /* --- (3) Focus return on close --------------------------------- */
    function restoreFocus() {
      var active = document.activeElement;

      // Only step in when focus was actually lost to the collapsing panel.
      var focusLost = !active ||
                      active === document.body ||
                      active === document.documentElement ||
                      active === panel ||
                      panel.contains(active);
      if (!focusLost) { return; }

      var target = trigger;

      // Trigger is .hidden-phone: it disappears at the mobile breakpoint,
      // which is also where 400% zoom lands. Fall back to the bar itself.
      if (!isVisible(target)) {
        target = document.querySelector('.announcement-bar');
        if (!target) { return; }
        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }
      }

      target.focus();
    }

    function onClose() {
      claimUntil = 0;
      restoreFocus();
      // Panel transitions height + visibility over 500ms; re-assert once
      // afterwards in case the visibility flip drops focus to <body>.
      window.setTimeout(restoreFocus, 550);
    }

    /* --- Watch the disclosure state --------------------------------
       Observing aria-expanded rather than re-binding the theme's own
       toggle covers every path with one handler: Escape, the X button,
       and a second click on the trigger.                             */
    var wasExpanded = isOpen();

    new MutationObserver(function () {
      var expanded = isOpen();
      if (expanded !== wasExpanded) {
        wasExpanded = expanded;
        if (expanded) { onOpen(); } else { onClose(); }
      }
    }).observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
  }

  $(init);
}(jQuery));


/* =========== BidetKing — Bug 85: header cart toggle (a.header__cart-toggle)=======================================================
   

   Defects addressed:
   (1) No accessible name below 1280px. The visible word "Cart" is in
       a <span class="hidden-pocket hidden-lap"> that computes to
       display:none from 0-1279px, so it is excluded from the name.
       The only remaining text is the count -> "0, button, collapsed,
       has popup dialog".
       NOTE: the log says <= 1024px; the theme's own rules are
       .hidden-pocket  @media (max-width: 999px)
       .hidden-lap     @media (min-width: 1000px) and (max-width: 1279px)
       so the control is unnamed everywhere below 1280px.
   (2) Stale duplicate aria-expanded="false" on the inner
       div.header__cart-icon.icon-state. It is never updated (it stays
       "false" while the drawer is open) and no CSS or theme JS reads
       it.
   (3) The control is <a href="/cart" role="button"> with no Space
       handler: Enter opens the mini cart, Space scrolls the page.
       The announced role promises button behaviour that isn't there.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A), 2.1.1 Keyboard (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var TOGGLE = '.header__cart-toggle';
  var COUNT  = '.header__cart-count';
  var ICON   = '.header__cart-icon';

  function labelFor(count) {
    return 'Cart, ' + count + (count === 1 ? ' item' : ' items');
  }

  function readCount($toggle) {
    var raw = $toggle.find(COUNT).first().text();
    var n = parseInt(String(raw).replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  // Idempotent: safe to run again after any DOM replacement.
  function apply() {
    $(TOGGLE).each(function () {
      var $toggle = $(this);
      var label = labelFor(readCount($toggle));

      if ($toggle.attr('aria-label') !== label) {
        $toggle.attr('aria-label', label);
      }

      // (2) drop the stale duplicate state from the inner icon wrapper
      $toggle.find(ICON + '[aria-expanded]').removeAttr('aria-expanded');
    });
  }

  function init() {
    var $toggle = $(TOGGLE).first();
    if (!$toggle.length) { return; }

    apply();

    /* --- Keep the label in step with the cart count ----------------
       The count is re-rendered by AJAX add-to-cart and by the mini
       cart, so watch the toggle's container rather than the count
       node, which can be replaced wholesale.                        */
    var scope = $toggle.closest('.header__action-item')[0] ||
                $toggle.parent()[0];

    if (scope && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; apply(); }, 50);
      }).observe(scope, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Belt and braces for themes/apps that re-render the header section.
    $(document).on('shopify:section:load cart:updated ajaxCart:afterCartLoad', apply);

    /* --- (3) Space parity for the role="button" anchor -------------
       Native buttons activate on Space keyup; anchors don't, so the
       page scrolls instead. Delegated, so it survives re-renders.   */
    function isSpace(e) {
      return e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32;
    }

    $(document)
      .on('keydown', TOGGLE, function (e) {
        if (isSpace(e)) { e.preventDefault(); }   // stop the page scroll
      })
      .on('keyup', TOGGLE, function (e) {
        if (isSpace(e)) { e.preventDefault(); this.click(); }
      });
  }

  $(init);
}(jQuery));


/* =========== BidetKing — Bug 88: navigation landmark labelling==============================================
   

   Measured on the preview build:
   - nav.header__mobile-nav  is display:block only BELOW 1000px
   - nav.nav-bar             is display:block only AT/ABOVE 1000px
   They swap cleanly at 1000px with no overlap, so a screen reader
   never sees two "navigation" landmarks at the same time. The
   landmark list shows ONE unlabelled navigation at any viewport.
   Labelling is still correct practice (ARIA APG) and future-proofs
   the header, but the "two identical entries" evidence in the log
   does not reproduce - see notes in the reply.

   Also handled: aside.footer__aside is an unlabelled COMPLEMENTARY
   landmark that holds only the copyright, social links and payment
   icons. That content belongs to contentinfo, not to a complementary
   region, so the landmark is removed rather than named.

   WCAG 2.2 - 1.3.1 Info and Relationships (A) / ARIA APG landmarks
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  // Labels omit the word "navigation" - the role is already announced.
  var LABELS = [
    { selector: 'nav.nav-bar',             label: 'Main' },
    { selector: 'nav.header__mobile-nav',  label: 'Mobile' }
  ];

  function apply() {
    $.each(LABELS, function (i, item) {
      $(item.selector).each(function () {
        if (!this.getAttribute('aria-label') && !this.getAttribute('aria-labelledby')) {
          this.setAttribute('aria-label', item.label);
        }
      });
    });

    // Drop the meaningless complementary landmark in the footer.
    // role="presentation" removes the landmark; its links and images
    // stay exposed, since presentation is not inherited by children.
    $('aside.footer__aside').each(function () {
      if (!this.getAttribute('role')) {
        this.setAttribute('role', 'presentation');
      }
    });
  }

  function init() {
    apply();
    // Header and footer are Shopify sections and can be re-rendered.
    $(document).on('shopify:section:load', apply);
  }

  $(init);
}(jQuery));


/* ========= BidetKing — Bug 86: unnamed brand logo links in the Brands =========================================================
   
   mega-menu (#tmenu-submenu-5)

   Each tile is <a href="/collections/..."><img alt="" title=""></a>
   with no text, no aria-label and no usable title, so all eleven
   announce as bare "link". The image filenames are content-hashed
   (6b9b8412....jpeg), so the only reliable name source in the markup
   is the collection handle in the href.

   This labels the LINK (aria-label) and leaves the logo decorative
   (alt=""), so the name survives the menu app re-rendering its
   images and nothing is announced twice.

   Scoped by shape - image-only collection links inside the tmenu app
   with no accessible name - rather than by the #tmenu-submenu-5 id,
   so it also covers the mobile menu and any brand added later.

   WCAG 2.2 - 1.1.1 Non-text Content (A), 2.4.4 Link Purpose (A),
              4.1.2 Name, Role, Value (A)
   Theme: Warehouse v4 + qikify Smart Menu ("tmenu")
   Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var SUFFIX = ' products';          // "Alpha Bidet products, link"

  // collection handle -> brand name. Anything not listed falls back to
  // a title-cased handle, so a new brand is still named, just less
  // precisely - add it here when one is introduced.
  var BRANDS = {
    'alpha-bidet':               'Alpha Bidet',
    'the-bidetking-collection':  'BidetKing',
    'bio-bidet':                 'Bio Bidet',
    'brondell':                  'Brondell',
    'clean-sense':               'CleanSense',
    'toto':                      'TOTO',
    'kohler':                    'Kohler',
    'fluidmaster':               'Fluidmaster',
    'gobidet':                   'GoBidet',
    'blooming':                  'Blooming',
    'nova-bidet':                'Nova Bidet'
  };

  function handleFrom(href) {
    var m = /\/collections\/([^/?#]+)/.exec(href || '');
    return m ? m[1].toLowerCase() : '';
  }

  function titleCase(handle) {
    return handle.replace(/-+/g, ' ').replace(/\b[a-z]/g, function (c) {
      return c.toUpperCase();
    });
  }

  function hasName(el) {
    if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) { return true; }
    if ($(el).text().trim()) { return true; }
    var named = false;
    $(el).find('img').each(function () {
      if ($.trim(this.getAttribute('alt') || '')) { named = true; }
    });
    return named;
  }

  function apply() {
    $('.tmenu_app a[href*="/collections/"]').each(function () {
      var $a = $(this);

      if (!$a.find('img').length) { return; }   // not an image tile
      if (hasName(this)) { return; }            // already named

      var handle = handleFrom($a.attr('href'));
      if (!handle) { return; }

      var brand = BRANDS[handle] || titleCase(handle);
      $a.attr('aria-label', brand + SUFFIX);

      // Empty title="" on the link and the image carries no meaning and
      // trips validators; the logo stays decorative via alt="".
      if ($a.attr('title') === '') { $a.removeAttr('title'); }
      $a.find('img').each(function () {
        if (this.getAttribute('title') === '') { this.removeAttribute('title'); }
        if (this.getAttribute('alt') === null) { this.setAttribute('alt', ''); }
      });
    });
  }

  function init() {
    apply();

    // The menu app renders lazily and can re-render its panels.
    var scope = document.querySelector('.tmenu_app') ||
                document.querySelector('.nav-bar');

    if (scope && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; apply(); }, 100);
      }).observe(scope, { childList: true, subtree: true });
    }

    $(document).on('shopify:section:load', apply);
  }

  $(init);
}(jQuery));


/* ============== BidetKing — Bug 90: mega-menu group titles have no heading====================================================
  
   semantics ("By Category", "By Brand", "Featured Products", ...)

   What the markup actually is:

     <li class="tmenu_item_level_1">
       <a class="tmenu_item_link" href="javascript:;">     <- dead link
         <span class="tmenu_item_text">By Category</span>
       </a>
       <ul> ... the group's real links ... </ul>
     </li>

   So there are two defects, not one:
   (a) no heading semantics anywhere in the panel (0 of h1-h6), and
   (b) the group title is a focusable <a href="javascript:;"> that
       navigates nowhere and does nothing on Enter - the FIRST Tab
       stop inside every mega-menu is a dead link.

   Both are fixed by exposing the title as a heading and taking it
   out of the tab order. Because the href is void, no destination is
   lost by dropping the link role.

   Deliberately attribute-only: no element is replaced and no class
   or href is removed, so the Smart Menu app's own CSS and JS (served
   cross-origin, so its rules cannot be audited from the page) keep
   matching exactly what they matched before.

   Scoped to .tmenu_submenu--desktop. The mobile drawer uses
   different markup where the title may be the expand control, and
   is tracked separately.

   WCAG 2.2 - 1.3.1 Info and Relationships (A);
              also 2.4.4 Link Purpose (A) / 4.1.2 (A) for the dead link
   Theme: Warehouse v4 + qikify Smart Menu ("tmenu")
   Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  // h1 on this page is the site title in the banner. Level 3 marks the
  // titles as sub-groups without claiming page-section structure.
  var LEVEL = '3';

  var TITLES = '.tmenu_submenu--desktop li.tmenu_item_level_1 > a.tmenu_item_link';

  function apply() {
    $(TITLES).each(function () {
      var $a = $(this);

      // The masonry placeholder is a measuring clone (visibility:hidden,
      // height:1px) and is not exposed to AT - leave it alone.
      if ($a.closest('.tmenu_masonry_placeholder').length) { return; }

      // Only convert titles that actually head a group of links.
      if (!$a.siblings('ul').find('a').length) { return; }

      // Only convert dead links. A title that really navigates keeps its
      // link role - that case needs a wrapping heading, not this.
      if (!/^javascript:/i.test($a.attr('href') || '')) { return; }

      if ($a.attr('role') === 'heading') { return; }        // already done

      $a.attr({
        'role': 'heading',
        'aria-level': LEVEL,
        'tabindex': '-1'      // drop the dead tab stop
      });
    });
  }

  function init() {
    apply();

    var scope = document.querySelector('.tmenu_app') ||
                document.querySelector('.nav-bar');

    if (scope && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; apply(); }, 100);
      }).observe(scope, { childList: true, subtree: true });
    }

    $(document).on('shopify:section:load', apply);
  }

  $(init);
}(jQuery));

/* ================= BidetKing — Bug 91: product-card image link announces two image=================================================
   
   descriptions concatenated (a.product-item__image-wrapper)

   Measured on the homepage: 45 product cards.
     39 cards wrap TWO images in the image link, e.g.
       "White bidet toilet seat front view with control panel and
        included remote."                            (primary)
       "White bidet toilet seat on a toilet, side view with
        integrated side control."                    (secondary/hover)
     -> the link's accessible name is both strings joined.
      6 cards wrap ONE image and still take that long alt as their
        entire link name, which is the same problem in shorter form.

   Card structure (already partly remediated):
     a.product-item__image-wrapper   tabindex="-1"   same href as title
     a.product-item__vendor          tabindex="-1"
     a.product-item__title           tabbable        "Alpha JX2 Bidet Toilet Seat"

   So keyboard users already get one tab stop per card, but in BROWSE
   mode a screen reader still meets the image link and reads the full
   concatenated description before reaching the title.

   Fix: the photo is decorative next to the card's own title, so both
   images become alt="" (the hover image also aria-hidden, as logged)
   and the link takes the product title as its accessible name. The
   original alt text is preserved in data-a11y-original-alt so nothing
   is lost and the client can restore it if the images are ever used
   outside a titled card.

   WCAG 2.2 - 2.4.4 Link Purpose (In Context) (A), 4.1.2 (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  /* Option B - set to true to drop the image link from the
     accessibility tree entirely instead of naming it, so each card
     exposes ONE product link rather than two with the same name.
     It is valid here (the link is already tabindex="-1"), but axe's
     aria-hidden-focus rule flags programmatically focusable elements
     inside aria-hidden, so it is off by default to keep automated
     scans of the audit clean. */
  var HIDE_IMAGE_LINK = false;

  var LINK  = 'a.product-item__image-wrapper';
  var TITLE = '.product-item__title';
  var CARD  = '.product-item';

  function titleFor($a) {
    var $card = $a.closest(CARD);
    if (!$card.length) { $card = $a.parent(); }
    return $.trim($card.find(TITLE).first().text().replace(/\s+/g, ' '));
  }

  function apply() {
    $(LINK).each(function () {
      var $a = $(this);
      if ($a.data('a11yCardLink')) { return; }        // already handled

      var title = titleFor($a);
      if (!title) { return; }                          // no name source - leave as is

      $a.find('img').each(function (i) {
        var alt = this.getAttribute('alt');
        if (alt && !this.getAttribute('data-a11y-original-alt')) {
          this.setAttribute('data-a11y-original-alt', alt);   // keep the copy
        }
        this.setAttribute('alt', '');
        if (i > 0) { this.setAttribute('aria-hidden', 'true'); }  // hover duplicate
      });

      if (HIDE_IMAGE_LINK) {
        $a.attr('aria-hidden', 'true').removeAttr('aria-label');
      } else {
        $a.attr('aria-label', title).removeAttr('aria-hidden');
      }

      $a.data('a11yCardLink', true);
    });
  }

  function init() {
    apply();

    // Carousels render lazily, quick view injects cards, and collection
    // pages append more on scroll.
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; apply(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }

    $(document).on('shopify:section:load', apply);
  }

  $(init);
}(jQuery));


/* ============ BidetKing — Bug 92: header search combobox keyboard pattern ======================================================
   BidetKing — Bug 92: header search combobox keyboard pattern
   input.search-bar__input[role="combobox"] -> #search-bar-results

   What is already right:
     role="combobox", aria-expanded, aria-controls="search-bar-results",
     aria-autocomplete="list", aria-haspopup="listbox", aria-label,
     listbox with aria-label="Search results", live status region.

   What is wrong (measured with the query "bidet seat", 13 results):
     - no aria-activedescendant on the input, ever
     - ArrowDown / ArrowUp do nothing at all: focus stays on the input
       and no selection moves
     - every result is tabindex=0, so Tab pulls REAL DOM focus into the
       popup - the one thing a combobox must not do
     - only 9 of the 13 results carry role="option". The three product
       rows (a.search-bar__result-item) have no role, and "View all
       results" is a <button type="submit"> sitting inside the listbox.
       A listbox may only contain options and groups, so the popup is
       invalid as structure, not just in its keyboard behaviour. This
       part is not in the bug log.

   Fix: the standard APG combobox. DOM focus never leaves the input;
   every result becomes a real option with an id and tabindex="-1";
   Up/Down move aria-activedescendant (with a visible highlight);
   Enter activates the referenced option; Escape and closing clear it.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A), 2.1.1 Keyboard (A),
              supports 1.4.11 Non-text Contrast for the highlight
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var INPUT_SEL  = 'input.search-bar__input[role="combobox"]';
  var LISTBOX_ID = 'search-bar-results';
  // Every activatable result in the popup. That includes the
  // "View all results" control, which the theme renders as a
  // <button type="submit"> INSIDE the listbox - invalid as a listbox
  // child, and a stray tab stop. Folding it in as the last option
  // keeps the popup valid and reachable; activating it still submits
  // the form, exactly as clicking it does.
  var OPTION_SEL = 'a[href], button:not([disabled])';
  var ACTIVE_CLS = 'a11y-combobox-option--active';
  var ID_PREFIX  = 'search-bar-option-';

  /* --- Highlight for the virtually-selected option ------------------
     Move this to a11y.css if you would rather not inject styles.
     Outline + background so it does not rely on colour alone, and
     clears 3:1 against the popup's white ground.                    */
  var CSS =
    '#' + LISTBOX_ID + ' .' + ACTIVE_CLS + '{' +
      'background-color:#eef1f6;' +
      'outline:2px solid #354561;' +
      'outline-offset:-2px;' +
    '}';

  function injectCss() {
    if (document.getElementById('a11y-combobox-css')) { return; }
    var s = document.createElement('style');
    s.id = 'a11y-combobox-css';
    s.appendChild(document.createTextNode(CSS));
    document.head.appendChild(s);
  }

  function init() {
    var input   = document.querySelector(INPUT_SEL);
    var listbox = document.getElementById(LISTBOX_ID);
    if (!input || !listbox) { return; }

    injectCss();

    var options = [];
    var active  = -1;

    function isOpen() {
      return input.getAttribute('aria-expanded') === 'true';
    }

    function visible(el) {
      return el.offsetParent !== null && el.getClientRects().length > 0;
    }

    // Re-read the popup after every AJAX render and normalise it.
    function collect() {
      options = $(listbox).find(OPTION_SEL).filter(function () {
        return visible(this);
      }).toArray();

      $.each(options, function (i, el) {
        // Only mint an id if there isn't one, or if it is ours.
        if (!el.id || el.id.indexOf(ID_PREFIX) === 0) {
          el.id = ID_PREFIX + i;
        }
        el.setAttribute('role', 'option');    // covers result-item / view-all
        el.setAttribute('tabindex', '-1');    // options are never tab stops
      });
    }

    function clearActive() {
      $.each(options, function (i, el) {
        el.removeAttribute('aria-selected');  // absent, not "false" - NVDA
        $(el).removeClass(ACTIVE_CLS);        // would say "not selected"
      });
      active = -1;
      input.removeAttribute('aria-activedescendant');
    }

    function setActive(i) {
      if (!options.length) { return; }

      // wrap around both ends
      if (i < 0) { i = options.length - 1; }
      if (i > options.length - 1) { i = 0; }

      $.each(options, function (n, el) {
        el.removeAttribute('aria-selected');
        $(el).removeClass(ACTIVE_CLS);
      });

      var el = options[i];
      el.setAttribute('aria-selected', 'true');
      $(el).addClass(ACTIVE_CLS);
      input.setAttribute('aria-activedescendant', el.id);
      active = i;

      // The popup scrolls (max-height 434px); keep the option in view
      // without yanking the page around.
      if (el.scrollIntoView) { el.scrollIntoView({ block: 'nearest' }); }
    }

    /* --- Keyboard ------------------------------------------------
       Capture phase so Arrow keys are claimed before the theme's own
       handlers, and Enter can be stopped from submitting the form. */
    input.addEventListener('keydown', function (e) {
      var key = e.key;

      if (key === 'ArrowDown' || key === 'Down') {
        if (!isOpen()) { return; }
        e.preventDefault();
        collect();
        setActive(active + 1);
        return;
      }

      if (key === 'ArrowUp' || key === 'Up') {
        if (!isOpen()) { return; }
        e.preventDefault();
        collect();
        setActive(active - 1);
        return;
      }

      if (key === 'Enter') {
        // No virtual selection -> let the form submit as normal.
        if (!isOpen() || active < 0 || !options[active]) { return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        options[active].click();
        return;
      }

      if (key === 'Escape' || key === 'Esc') {
        clearActive();        // let the theme close the popup itself
        return;
      }

      if (key === 'Tab') {
        clearActive();        // focus is leaving; drop the virtual selection

        // The theme has its own Tab handler that pulls DOM focus onto the
        // first result. Stop it (without preventDefault) so native Tab
        // moves on to the next control instead of entering the popup.
        if (isOpen()) { e.stopImmediatePropagation(); }
      }
    }, true);

    // Home/End are deliberately not intercepted - in a combobox with a
    // text input they must keep moving the caret.

    // Typing re-runs the search: the previous selection is meaningless.
    $(input).on('input', function () {
      clearActive();
    });

    // Clicking a result should behave like activating it - nothing to do
    // beyond dropping the virtual state.
    $(listbox).on('click', OPTION_SEL, function () {
      clearActive();
    });

    /* --- Keep in step with the AJAX popup ------------------------- */
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () {
          queued = false;
          collect();
          if (active >= options.length) { clearActive(); }
        }, 60);
      }).observe(listbox, { childList: true, subtree: true });

      // Closing the popup must drop aria-activedescendant.
      new MutationObserver(function () {
        if (!isOpen()) { clearActive(); }
      }).observe(input, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    collect();
  }

  $(init);
}(jQuery));


/* ============= BidetKing — Bug 96: hero slideshow never announces slide changes=====================================================
   BidetKing — Bug 96: hero slideshow never announces slide changes
   div.slideshow[role="region"][aria-roledescription="carousel"]

   Everything else in this carousel is already right, and was verified:
     - region labelled "Promotional banners carousel. Use the left and
       right arrow keys to change slide.", tabindex="0"
     - 3 slides, each role="group" aria-label="Slide N of 3"
     - off-screen slides carry aria-hidden="true" + tabindex="-1"
     - dots are role="button", tabindex="0", aria-controls the slide,
       and the active one already carries aria-current="step"
     - working Pause/Play toggle (.a11y-slideshow-toggle) whose label
       flips between "Pause banner slideshow" and "Play banner slideshow"
   The only thing missing is the status region: 0 elements inside the
   slideshow had aria-live or role="status".

   The status element copies the pattern already used on this site by
   #search-status, #cart-live-region and .jdgm-carousel__status:
   class="visually-hidden" role="status" aria-live="polite" aria-atomic="true".

   IMPORTANT deviation from the log's recommendation, on purpose:
   the carousel auto-rotates. A polite live region that fires on every
   autoplay tick interrupts the screen reader user every few seconds
   while they are reading something else - which is why APG keeps the
   carousel's live region OFF during automatic rotation and turns it on
   when rotation stops. So this announces when:
       the slideshow is paused, OR the change was user-initiated
         (arrow keys on the region, or activating a dot),
   and stays silent during unattended autoplay.

   WCAG 2.2 - 4.1.3 Status Messages (AA)
   Theme: Warehouse v4 + Flickity  |  Requires: jQuery (3.7.1 on site)
   ================================================================== */
(function ($) {
  'use strict';

  var REGION  = '.slideshow';
  var SLIDE   = '.slideshow__slide';
  var TOGGLE  = '.a11y-slideshow-toggle';
  var DOT     = '.flickity-page-dots .dot';
  var STATUS_ID = 'slideshow-status';

  function init() {
    var region = document.querySelector(REGION);
    if (!region) { return; }
    if (document.getElementById(STATUS_ID)) { return; }

    /* --- The status element ---------------------------------------- */
    var status = document.createElement('div');
    status.id = STATUS_ID;
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'off');   // off while autoplay runs
    status.setAttribute('aria-atomic', 'true');
    region.appendChild(status);

    var userActed = false;
    var announceTimer = null;

    function isPaused() {
      var t = region.querySelector(TOGGLE) ||
              document.querySelector(TOGGLE);
      // Label reads "Play ..." only when rotation is stopped.
      return !!t && /^play\b/i.test($.trim(t.getAttribute('aria-label') || ''));
    }

    function currentLabel() {
      var slides = $(region).find(SLIDE).toArray();
      if (!slides.length) { return ''; }

      var i = -1;
      $.each(slides, function (n, el) {
        if (/(^|\s)is-selected(\s|$)/.test(el.className)) { i = n; }
      });
      if (i < 0) { return ''; }

      // The slide's own label is already "Slide 2 of 3" and is
      // translated with the theme - reuse it rather than rebuilding it.
      return slides[i].getAttribute('aria-label') ||
             ('Slide ' + (i + 1) + ' of ' + slides.length);
    }

    function announce() {
      var text = currentLabel();
      if (!text) { return; }

      status.setAttribute('aria-live', 'polite');

      // Clearing first makes an identical string announce again, e.g.
      // when the user steps away and back to the same slide.
      status.textContent = '';
      window.clearTimeout(announceTimer);
      announceTimer = window.setTimeout(function () {
        status.textContent = text;
      }, 50);
    }

    function maybeAnnounce() {
      if (userActed || isPaused()) {
        announce();
      } else {
        // Unattended autoplay: keep the region silent.
        status.setAttribute('aria-live', 'off');
        status.textContent = '';
      }
      userActed = false;
    }

    /* --- What counts as user-initiated ------------------------------ */
    function markUserAction() {
      userActed = true;
    }

    $(region).on('keydown', function (e) {
      if (/^(ArrowLeft|ArrowRight|Left|Right|Home|End)$/.test(e.key)) {
        markUserAction();
      }
    });

    $(document)
      .on('click keydown', DOT, function (e) {
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
          markUserAction();
        }
      })
      .on('click', TOGGLE, function () {
        // Pausing is itself a user action; announce where we stopped.
        window.setTimeout(function () {
          if (isPaused()) { announce(); }
        }, 100);
      });

    /* --- Watch for the slide change --------------------------------
       Flickity moves .is-selected between slides; watch class changes
       on the slide track rather than hooking Flickity's own API.     */
    var track = region.querySelector('.flickity-slider') || region;

    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () {
          queued = false;
          maybeAnnounce();
        }, 80);
      }).observe(track, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    }
  }

  $(init);
}(jQuery));


/* ========== BidetKing — Bug 101: viewport meta disables pinch-zoom ========================================================
   

   *** THIS FILE IS A STOPGAP, NOT THE FIX. ***

   The real fix is one line in theme.liquid (see below). Use this only
   if the theme files cannot be edited yet and the CDN-injected a11y.js
   is the only channel available. A runtime rewrite happens AFTER the
   browser has already parsed and applied the original viewport, so it
   must be re-verified on a real Android device before it is claimed as
   remediated.

   ------------------------------------------------------------------
   THE REAL FIX - theme.liquid, immediately after <meta charset="utf-8">
   (rendered line 24 on the live homepage, identical on preview and
   production, hardcoded in the theme - not injected by any app):

   FROM:
     <meta name="viewport" content="width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0">

   TO:
     <meta name="viewport" content="width=device-width, initial-scale=1.0">
   ------------------------------------------------------------------

   Why each directive goes:
     maximum-scale=1.0  - the actual barrier; caps zoom at 100%
     minimum-scale=1.0  - blocks zooming back out below 100%
     height=device-height - not an a11y failure, but it causes layout
                          jumps on mobile as the browser chrome hides
                          and shows, and it serves no purpose here
   Note there is no user-scalable=no on this site: maximum-scale alone
   is doing the damage. touch-action computes to auto on <html> and
   <body>, so nothing in CSS is blocking zoom as well.

   WCAG 2.2 - 1.4.4 Resize Text (AA); also supports 1.4.10 Reflow
   ================================================================== */
(function () {
  'use strict';

  var WANTED = 'width=device-width, initial-scale=1.0';

  function fix() {
    var metas = document.querySelectorAll('meta[name="viewport" i]');
    if (!metas.length) { return; }

    // If an app ever injects a second one, the last wins - normalise all.
    Array.prototype.forEach.call(metas, function (m) {
      var content = m.getAttribute('content') || '';
      if (!/maximum-scale|minimum-scale|user-scalable|height\s*=/i.test(content)) {
        return;                                   // already clean
      }
      m.setAttribute('content', WANTED);
    });
  }

  fix();

  // Some apps rewrite the viewport after load; re-assert if that happens.
  if (window.MutationObserver && document.head) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) { return; }
      queued = true;
      window.setTimeout(function () { queued = false; fix(); }, 100);
    }).observe(document.head, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['content']
    });
  }
}());

/* =========== BidetKing — Bug 102: collection Sort-by / Display panels=======================================================
   BidetKing — Bug 102: collection Sort-by / Display panels
   button.value-picker-button  ->  div.value-picker

   Structure (identical for both panels):
     div.value-picker#<id>            aria-hidden toggled, NO role, NO label
       div.value-picker__inner
         header.value-picker__header  <- display:none above ~640px
           span.value-picker__title   "Sort by" / "Display"
           button.value-picker__close aria-label="Close"
         div.value-picker__choice-list
           button.value-picker__choice-item  x N
             current one marked ONLY by an .is-selected CSS class

   Measured, and it changes the picture:

   * The component is TWO different things at two breakpoints.
       >= ~640px  panel is position:absolute, a 170x319 dropdown, and
                  the header is display:none - so there is no title and
                  no Close button, and the first Tab stop is the first
                  choice ("Featured"), NOT Close.
       <  ~640px  panel is position:fixed, a full-width sheet, header
                  visible, and Close IS the first focusable - which is
                  the behaviour the bug log describes.
     So "the first focusable is a confusing Close button" is true on
     phones only. Worth correcting in the row, or a dev will test at
     desktop width and close it as not-reproducible.

   * role="dialog" (the logged recommendation) is wrong at desktop
     width: an absolutely-positioned 170px dropdown with no backdrop
     and no focus trap. Announcing "dialog" promises modal behaviour
     that is not there. The trigger already declares aria-haspopup,
     and the panel is a list of mutually-exclusive settings applied on
     activation - that is a MENU. This implements the menu pattern,
     which is correct at both breakpoints.

   * Escape does nothing today: the panel stays open (verified). Not
     in the log.

   What this adds:
     - .value-picker__choice-list -> role="menu", labelled by the
       panel's own title span (aria-labelledby works even while that
       span's header is display:none)
     - each choice -> role="menuitemradio" + aria-checked, so the
       applied option is announced instead of living in a CSS class
     - roving tabindex, Up/Down/Home/End, Escape closes and returns
       focus to the trigger, Tab closes
     - on open, focus lands on the CHECKED option, which is what makes
       the phone-width "Close is first" problem go away without moving
       anything in the DOM

   WCAG 2.2 - 4.1.2 Name, Role, Value (A), 1.3.1 (A), 2.1.1 (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var TRIGGER = 'button.value-picker-button';
  var PANEL   = '.value-picker';
  var LIST    = '.value-picker__choice-list';
  var ITEM    = '.value-picker__choice-item';
  var TITLE   = '.value-picker__title';
  var CLOSE   = '.value-picker__close';
  var ID_BASE = 'value-picker-title-';

  var seq = 0;

  function setup(trigger) {
    var panelId = trigger.getAttribute('aria-controls');
    var panel   = panelId ? document.getElementById(panelId) : null;
    if (!panel) { return null; }

    var list = panel.querySelector(LIST);
    if (!list) { return null; }

    /* --- Label the menu from the panel's own title ---------------- */
    var title = panel.querySelector(TITLE);
    if (title) {
      if (!title.id) { title.id = ID_BASE + (++seq); }
      list.setAttribute('aria-labelledby', title.id);
    } else {
      list.setAttribute('aria-label', $.trim($(trigger).text()) || 'Options');
    }

    list.setAttribute('role', 'menu');
    trigger.setAttribute('aria-haspopup', 'menu');   // was the vaguer "true"

    // Close is a pointer affordance; Escape is the keyboard route out.
    $(panel).find(CLOSE).attr('tabindex', '-1');

    return { trigger: trigger, panel: panel, list: list };
  }

  function items(ctx) {
    return $(ctx.list).find(ITEM).filter(function () {
      return this.getClientRects().length > 0;
    }).toArray();
  }

  function sync(ctx) {
    var list = items(ctx);
    var checkedIndex = -1;

    $.each(list, function (i, el) {
      var on = /(^|\s)is-selected(\s|$)/.test(el.className);
      el.setAttribute('role', 'menuitemradio');
      el.setAttribute('aria-checked', on ? 'true' : 'false');
      el.setAttribute('tabindex', '-1');
      if (on) { checkedIndex = i; }
    });

    // Roving tabindex: the checked item is the single tab stop.
    var entry = checkedIndex > -1 ? checkedIndex : 0;
    if (list[entry]) { list[entry].setAttribute('tabindex', '0'); }

    return { list: list, entry: entry };
  }

  function focusItem(ctx, i) {
    var list = items(ctx);
    if (!list.length) { return; }
    if (i < 0) { i = list.length - 1; }
    if (i > list.length - 1) { i = 0; }

    $.each(list, function (n, el) { el.setAttribute('tabindex', '-1'); });
    list[i].setAttribute('tabindex', '0');
    list[i].focus();
  }

  function indexOfActive(ctx) {
    return $.inArray(document.activeElement, items(ctx));
  }

  function close(ctx, returnFocus) {
    if (ctx.trigger.getAttribute('aria-expanded') === 'true') {
      ctx.trigger.click();                       // let the theme close it
    }
    if (returnFocus) { ctx.trigger.focus(); }
  }

  function init() {
    $(TRIGGER).each(function () {
      var ctx = setup(this);
      if (!ctx) { return; }

      sync(ctx);

      /* --- Keyboard inside the menu ----------------------------- */
      $(ctx.list).on('keydown', ITEM, function (e) {
        var i = indexOfActive(ctx);

        switch (e.key) {
          case 'ArrowDown': case 'Down':
            e.preventDefault(); focusItem(ctx, i + 1); break;
          case 'ArrowUp': case 'Up':
            e.preventDefault(); focusItem(ctx, i - 1); break;
          case 'Home':
            e.preventDefault(); focusItem(ctx, 0); break;
          case 'End':
            e.preventDefault(); focusItem(ctx, items(ctx).length - 1); break;
          case 'Escape': case 'Esc':
            e.preventDefault(); close(ctx, true); break;
          case 'Tab':
            close(ctx, false); break;            // Tab exits the menu
          default: break;
        }
      });

      // Escape while focus is still on the trigger.
      $(ctx.trigger).on('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') &&
            ctx.trigger.getAttribute('aria-expanded') === 'true') {
          e.preventDefault();
          close(ctx, true);
        }
      });

      /* --- On open, land on the applied option ------------------- */
      if (window.MutationObserver) {
        new MutationObserver(function () {
          if (ctx.trigger.getAttribute('aria-expanded') !== 'true') { return; }
          var s = sync(ctx);
          window.setTimeout(function () { focusItem(ctx, s.entry); }, 30);
        }).observe(ctx.trigger, {
          attributes: true, attributeFilter: ['aria-expanded']
        });

        // The theme re-renders the list when filters change. Watch
        // childList only: the theme adds .is-kbd-focus on focus, and
        // observing class changes would re-run sync() on every arrow
        // press and stamp the roving tabindex back onto the checked item.
        new MutationObserver(function () {
          sync(ctx);
        }).observe(ctx.list, { childList: true, subtree: true });
      }
    });
  }

  $(init);
}(jQuery));


/* =========== BidetKing — Bug 104: collection grid/list layout toggles=======================================================
   BidetKing — Bug 104: collection grid/list layout toggles
   button.collection__layout-button[data-action="change-layout"]

   Verified on BOTH builds (preview and production - unlike Bugs 102
   and 103, this one is not already fixed on the preview):

     <button type="button"
             class="collection__layout-button is-selected link touch-area"
             aria-label="Display products as grid"
             data-action="change-layout" data-layout-mode="grid">
     <button type="button"
             class="collection__layout-button  link touch-area"
             aria-label="Display products as list"
             data-action="change-layout" data-layout-mode="list">

   No aria-pressed, no aria-current, no aria-selected, no role on
   either button and none on their container. The active layout is
   carried solely by the .is-selected class, so both buttons announce
   identically and a screen reader user cannot tell which view is on.

   aria-pressed (as logged) rather than a radiogroup: these are two
   independent toggle buttons in the existing markup, and radio
   semantics would oblige arrow-key navigation the theme does not
   implement. aria-pressed adds the missing state without promising
   a keyboard contract that isn't there.

   Because the user activates the button themselves, focus is on it
   when the state flips, so the new "pressed" state is announced
   without needing a live region.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var BUTTON = 'button.collection__layout-button';

  function sync() {
    var $buttons = $(BUTTON);
    if (!$buttons.length) { return; }

    $buttons.each(function () {
      var on = /(^|\s)is-selected(\s|$)/.test(this.className);
      var want = on ? 'true' : 'false';
      if (this.getAttribute('aria-pressed') !== want) {
        this.setAttribute('aria-pressed', want);
      }
    });
  }

  function init() {
    var $buttons = $(BUTTON);
    if (!$buttons.length) { return; }

    sync();

    // The theme swaps .is-selected between the two buttons on click.
    if (window.MutationObserver) {
      var queued = false;
      var observer = new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; sync(); }, 30);
      });

      $buttons.each(function () {
        observer.observe(this, { attributes: true, attributeFilter: ['class'] });
      });
    }

    // Belt and braces: also re-sync just after activation, and after a
    // section re-render.
    $(document).on('click', BUTTON, function () {
      window.setTimeout(sync, 50);
    });
    $(document).on('shopify:section:load', sync);
  }

  $(init);
}(jQuery));



/* ========= BidetKing — Bug 105: applying a collection filter drops focus to <body>=========================================================
   BidetKing — Bug 105: applying a collection filter drops focus to
   <body>

   Measured on the preview, keyboard only:
     focus #filter.v.option.size-Elongated -> Space
     -> URL gains the filter, grid re-renders, and
        document.activeElement === document.body

   Two facts that shape the fix:
     * It is an AJAX re-render, not a page load - a global set before
       the click was still there afterwards.
     * The checkbox NODE is replaced, but its ID survives
       ("filter.v.option.size-Elongated", still present, now checked).
       So the control can be found again by id after the swap.

   Note the ids contain dots, so they must be looked up with
   getElementById - "#filter.v.option.size-Elongated" as a CSS
   selector parses as a class chain and matches nothing.

   Covers both filter forms (#desktop-filters-form and
   #mobile-collection-filters-form, 31 inputs each) and every
   input[name^="filter"], which includes the price gte/lte number
   fields, not just the checkboxes.

   WCAG 2.2 - 2.4.3 Focus Order (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
// (function ($) {
//   'use strict';

//   var CONTROL   = 'input[name^="filter"], select[name^="filter"]';
//   var ARM_MS    = 4000;    // stop trying this long after the change
//   var RETRIES   = [120, 350, 800, 1600, 2600];

//   var pendingId = null;
//   var armedUntil = 0;
//   var timers = [];

//   function clearTimers() {
//     while (timers.length) { window.clearTimeout(timers.pop()); }
//   }

//   function focusLost() {
//     var a = document.activeElement;
//     return !a || a === document.body || a === document.documentElement;
//   }

//   function tryRestore() {
//     if (!pendingId || Date.now() > armedUntil) { return; }

//     // Act only once the re-render has actually dropped focus to <body>.
//     // Deliberately do NOT give up when focus is still somewhere real:
//     // for the first ~200ms it is still sitting on the pre-render node,
//     // and disarming at that point means never restoring at all. If the
//     // user has moved focus somewhere deliberately, this simply never
//     // fires and the arm window expires.
//     if (!focusLost()) { return; }

//     var el = document.getElementById(pendingId);   // ids contain dots
//     if (!el || !el.getClientRects().length) { return; }

//     el.focus();

//     if (document.activeElement === el) { disarm(); }
//   }

//   function disarm() {
//     pendingId = null;
//     armedUntil = 0;
//     clearTimers();
//   }

//   function arm(id) {
//     if (!id) { return; }
//     pendingId = id;
//     armedUntil = Date.now() + ARM_MS;

//     clearTimers();
//     $.each(RETRIES, function (i, ms) {
//       timers.push(window.setTimeout(tryRestore, ms));
//     });
//     timers.push(window.setTimeout(disarm, ARM_MS));
//   }

//   function init() {
//     if (!document.querySelector(CONTROL)) { return; }

//     // Delegated: the controls are replaced on every re-render.
//     $(document).on('change', CONTROL, function () {
//       arm(this.id);
//     });

//     // The grid and the filter panel are swapped in; restore as soon as
//     // the DOM settles rather than waiting on the retry schedule alone.
//     if (window.MutationObserver) {
//       var queued = false;
//       new MutationObserver(function () {
//         if (!pendingId) { return; }
//         if (queued) { return; }
//         queued = true;
//         window.setTimeout(function () { queued = false; tryRestore(); }, 80);
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   $(init);
// }(jQuery));


/* ========== BidetKing — Bug 106: filtered result count is never announced .collection__products-count========================================================
   BidetKing — Bug 106: filtered result count is never announced
   .collection__products-count

   Measured on the collection page:

   * There are TWO count elements, shown at different breakpoints:
       .collection__products-count-total    "43 products"
           class hidden-lap-and-up  -> visible only below 1000px
       .collection__products-count-showing  "Showing 1 - 24 of 43 products"
           class hidden-pocket hidden-desk  -> visible only 1000-1279px
     Confirmed: at 614px SHOWING computes to display:none while TOTAL is
     block; at 1054px it is the other way round.

   * Neither carries aria-live or role="status", and applying a filter
     updates their text silently (43 products -> 40 products).

   IMPORTANT deviation from the logged recommendation:
   do NOT put role="status" / aria-live on the showing-count element
   itself. It is display:none at phone widths, and a live region that
   is display:none is removed from the accessibility tree and never
   announces - so on exactly the mobile screen readers named in the
   environment column, that fix would be silent.

   Instead this adds one always-present visually-hidden live region and
   feeds it the count text. It reads from the SHOWING element even
   where that element is visually hidden, because the richer
   "Showing 1 - 24 of 40 products" is the more useful announcement, and
   the text is in the DOM at every breakpoint.

   Helpfully, the theme mutates these nodes in place rather than
   replacing them (verified: same node identity before and after a
   filter), so observing them directly is reliable.

   House pattern matched: class="visually-hidden" role="status"
   aria-live="polite" aria-atomic="true"  - as used by #search-status,
   #cart-live-region and .jdgm-carousel__status.

   WCAG 2.2 - 4.1.3 Status Messages (AA)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
// (function ($) {
//   'use strict';

//   var COUNT     = '.collection__products-count';
//   var SHOWING   = '.collection__products-count-showing';
//   var TOTAL     = '.collection__products-count-total';
//   var STATUS_ID = 'collection-results-status';

//   function init() {
//     var $counts = $(COUNT);
//     if (!$counts.length) { return; }
//     if (document.getElementById(STATUS_ID)) { return; }

//     /* --- The live region ------------------------------------------- */
//     var status = document.createElement('div');
//     status.id = STATUS_ID;
//     status.className = 'visually-hidden';
//     status.setAttribute('role', 'status');
//     status.setAttribute('aria-live', 'polite');
//     status.setAttribute('aria-atomic', 'true');

//     // Sits beside the counts, outside anything the theme swaps out.
//     var host = $counts.first().closest('.collection__meta')[0] || document.body;
//     host.appendChild(status);

//     function readCount() {
//       // Prefer the fuller "Showing 1 - 24 of 40 products" even when that
//       // element is display:none at this breakpoint.
//       var el = document.querySelector(SHOWING) || document.querySelector(TOTAL);
//       return el ? $.trim(el.textContent.replace(/\s+/g, ' ')) : '';
//     }

//     // Seed with the current value so the first page render is silent.
//     var last = readCount();
//     var timer = null;

//     function update() {
//       var now = readCount();
//       if (!now || now === last) { return; }   // nothing actually changed
//       last = now;
//       status.textContent = now;
//     }

//     /* --- Watch the counts ------------------------------------------
//        The theme rewrites the text of these nodes in place, so watch
//        their character data rather than waiting for a node swap.     */
//     if (window.MutationObserver) {
//       var observer = new MutationObserver(function () {
//         window.clearTimeout(timer);
//         timer = window.setTimeout(update, 150);   // let the swap settle
//       });

//       $counts.each(function () {
//         observer.observe(this, {
//           childList: true,
//           subtree: true,
//           characterData: true
//         });
//       });

//       // If the surrounding block is ever re-rendered wholesale, pick the
//       // new nodes up too.
//       if (host !== document.body) {
//         new MutationObserver(function () {
//           window.clearTimeout(timer);
//           timer = window.setTimeout(update, 150);
//         }).observe(host, { childList: true, subtree: true });
//       }
//     }
//   }

//   $(init);
// }(jQuery));

/* ===========BidetKing - Bug 107 — active filter "chip" under the Filters heading=======================================================
   BidetKing — active filter "chip" under the Filters heading
   (the  [x] Elongated  pill on collection pages)

   What it actually is on desktop:

     <label for="filter.v.option.size-Elongated"
            class="collection__active-filter-item">
       Elongated
       <span class="collection__active-filter-cross">
         <svg role="presentation"></svg>
       </span>
     </label>

   It is a <label>, not a button or a link:
     - tabIndex is -1: it is NOT in the tab order, so a keyboard user
       can never reach it, even though it renders as a pill with an X
       and removes the filter when clicked
     - no role, so assistive tech gets no control semantics
     - its whole accessible text is "Elongated" - nothing says that
       activating it REMOVES that filter
   It works with a mouse only because clicking a <label> toggles the
   checkbox named in its "for" attribute.

   The mobile variant (button.collection__mobile-active-filter-item) IS
   a real button and is focusable, but has no aria-label either, so it
   announces as "Elongated, button" with no hint of what it does.

   Conformance framing, because a dev will push back:
   the same filter can still be removed from the sidebar checkbox,
   which is visible and keyboard reachable - so a strict 2.1.1 argument
   is arguable at page level. The failure that is not arguable is
   4.1.2: this is a rendered, mouse-operable control that exposes no
   role and no name for its action. A sighted keyboard user also sees
   a control they cannot reach, which is the practical barrier.

   Fix: give the chip real button semantics and keyboard activation,
   name it for what it does, and put focus back on the sidebar
   checkbox afterwards (the chip itself disappears when used, so focus
   cannot return to it).

   WCAG 2.2 - 4.1.2 Name, Role, Value (A), 2.1.1 Keyboard (A),
              2.4.3 Focus Order (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
// (function ($) {
//   'use strict';

//   var DESKTOP_CHIP = 'label.collection__active-filter-item';
//   var MOBILE_CHIP  = 'button.collection__mobile-active-filter-item';
//   var CROSS        = '.collection__active-filter-cross';

//   // "Remove filter: Elongated" - adjust wording to match the client's
//   // copy if the audit report standardises on something else.
//   function labelFor(name) {
//     return 'Remove filter: ' + name;
//   }

//   function chipName($chip) {
//     // The cross is decorative; the remaining text is the filter name.
//     var clone = $chip.clone();
//     clone.find(CROSS).remove();
//     clone.find('svg').remove();
//     return $.trim(clone.text().replace(/\s+/g, ' '));
//   }

//   function apply() {
//     $(DESKTOP_CHIP).each(function () {
//       var $chip = $(this);
//       if ($chip.attr('data-a11y-chip')) { return; }

//       var name = chipName($chip);
//       if (!name) { return; }

//       $chip.attr({
//         'role': 'button',
//         'tabindex': '0',
//         'aria-label': labelFor(name),
//         'data-a11y-chip': '1'
//       });

//       $chip.find(CROSS).attr('aria-hidden', 'true');
//     });

//     // Mobile chips are already buttons - they just need the name to say
//     // what activating them does.
//     $(MOBILE_CHIP).each(function () {
//       var $chip = $(this);
//       if ($chip.attr('aria-label')) { return; }
//       var name = chipName($chip);
//       if (name) { $chip.attr('aria-label', labelFor(name)); }
//     });
//   }

//   /* --- Keyboard activation ----------------------------------------
//      A <label> does nothing on Enter/Space, so drive the associated
//      checkbox directly and fire change() so the theme's AJAX runs.   */
//   function activate(chip) {
//     var id = chip.getAttribute('for');
//     var box = id ? document.getElementById(id) : null;   // ids contain dots
//     if (!box) { return; }

//     // Replicate the native label click exactly: box.click(). Setting
//     // .checked and firing a jQuery change() is NOT equivalent here -
//     // the theme keeps a second copy of every filter in the mobile form
//     // ("mobile-filter.v.option.size-Elongated"), and only a real click
//     // keeps the two in sync. Doing it by hand left the mobile twin
//     // checked, so the filter stayed applied and the chip never left.
//     box.click();

//     // A native label click also focuses the checkbox, so this is only a
//     // safety net for the case where the re-render drops focus to <body>.
//     restoreTo(id);
//   }

//   var pending = null, until = 0, timers = [];

//   function restoreTo(id) {
//     pending = id;
//     until = Date.now() + 4000;
//     while (timers.length) { window.clearTimeout(timers.pop()); }
//     $.each([120, 350, 800, 1600, 2600], function (i, ms) {
//       timers.push(window.setTimeout(tryRestore, ms));
//     });
//   }

//   function tryRestore() {
//     if (!pending || Date.now() > until) { return; }

//     var a = document.activeElement;
//     if (a && a !== document.body && a !== document.documentElement) { return; }

//     var el = document.getElementById(pending);
//     if (!el || !el.getClientRects().length) { return; }

//     el.focus();
//     if (document.activeElement === el) { pending = null; }
//   }

//   function init() {
//     apply();

//     $(document).on('keydown', DESKTOP_CHIP, function (e) {
//       if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32) {
//         e.preventDefault();          // stop Space scrolling the page
//         activate(this);
//       }
//     });

//     // Pointer users still get the native label behaviour; just make sure
//     // focus lands somewhere sensible afterwards too.
//     $(document).on('click', DESKTOP_CHIP, function () {
//       var id = this.getAttribute('for');
//       if (id) { restoreTo(id); }
//     });

//     // Chips are re-rendered with the grid.
//     if (window.MutationObserver) {
//       var queued = false;
//       new MutationObserver(function () {
//         if (queued) { return; }
//         queued = true;
//         window.setTimeout(function () { queued = false; apply(); tryRestore(); }, 120);
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   $(init);
// }(jQuery));


/* ======== BidetKing — Bug 109: colour swatch names come only from aria-label on a <label> element==========================================================
   BidetKing — Bug 109: colour swatch names come only from aria-label
   on a <label> element

   Actual markup, verified:

     <input class="color-swatch__radio" type="checkbox"
            name="filter.p.m.custom.color"
            id="filter.p.m.custom.color-Beige" value="Beige">
     <label for="filter.p.m.custom.color-Beige"
            class="color-swatch__item" aria-label="Beige">
       <span class="color-swatch__item" style="background-image:url(...)"></span>
     </label>

   The checkbox has no text anywhere. Its name is computed by walking
   the associated <label>, whose only naming source is an aria-label on
   the label element itself - an unusual placement that Chrome resolves
   (it currently announces "Beige" / "White") but that is the fragile
   path the bug row describes.

   Fix: put a real visually-hidden text node inside the label and
   REMOVE the aria-label. Keeping both would be pointless - aria-label
   on the label wins the name computation, so the hidden text would
   never be the thing that names the control and the fragile path
   would still be the effective one. Text content inside a <label> is
   the most reliably supported naming mechanism there is.

   The colour name is taken from the existing aria-label, falling back
   to the input's value attribute, so nothing is hardcoded and it
   follows the store's own naming.

   Covers both filter forms (the mobile duplicates carry the same
   markup with mobile- prefixed ids) and re-applies after the filter
   panel re-renders.

   Layout is unaffected: .visually-hidden is position:absolute with a
   1px clip rect, and the swatch tile is a separate child span.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
// (function ($) {
//   'use strict';

//   var LABEL = '.color-swatch label.color-swatch__item';
//   var MARK  = 'data-a11y-swatch-name';

//   function nameFor($label) {
//     var fromAria = $.trim($label.attr('aria-label') || '');
//     if (fromAria) { return fromAria; }

//     var input = $label.closest('.color-swatch').find('input')[0];
//     return input ? $.trim(input.value || '') : '';
//   }

//   function apply() {
//     $(LABEL).each(function () {
//       var $label = $(this);
//       if ($label.attr(MARK)) { return; }

//       var name = nameFor($label);
//       if (!name) { return; }

//       // Real text, exposed to every engine via the label's content.
//       $label.append($('<span class="visually-hidden"></span>').text(name));

//       // Keep the original value for reference, then take the fragile
//       // path out of the name computation so the text is what counts.
//       $label.attr(MARK, name).removeAttr('aria-label');
//     });
//   }

//   function init() {
//     if (!document.querySelector(LABEL)) { return; }

//     apply();

//     // Swatches are re-rendered with the grid on every filter change.
//     if (window.MutationObserver) {
//       var queued = false;
//       new MutationObserver(function () {
//         if (queued) { return; }
//         queued = true;
//         window.setTimeout(function () { queued = false; apply(); }, 120);
//       }).observe(document.body, { childList: true, subtree: true });
//     }

//     $(document).on('shopify:section:load', apply);
//   }

//   $(init);
// }(jQuery));


/* =========Bug 113, Bug 114, Bug 115 and Bug 116=========================================================
   BidetKing — Bug 113: product gallery is an unlabelled generic
   .product-gallery__carousel-wrapper

   Verified on the product page:

     wrapper  .product-gallery__carousel-wrapper
              attributes: class ONLY - no role, no aria-label,
              no aria-roledescription, and no tabindex attribute
     items    14 x .product-gallery__carousel-item
              off-screen ones correctly aria-hidden="true" +
              tabindex="-1", but NO role="group" and NO
              "Image N of M" label - unlike the homepage slideshow
     nav      14 x a.product-gallery__thumbnail, tabindex 0, with
              good labels ("Load image 2 in gallery view: White bidet
              toilet seat on a toilet, side view...")
     live     none

   TWO CORRECTIONS to the bug row, both worth making before a dev
   picks this up:

   1. There is no tabindex="-1" attribute on the wrapper. Its only
      attribute is class; tabIndex reports -1 because a plain <div>
      is not focusable. Nothing in the whole gallery chain
      (wrapper > __carousel > .flickity-viewport > .flickity-slider)
      carries a tabindex attribute.

   2. Do NOT use the suggested label "Product images. Use the left and
      right arrow keys to change image." Arrow keys do not operate
      this gallery and cannot: nothing inside the wrapper is
      focusable, so the carousel can never receive the key events.
      That instruction is true of the HOMEPAGE slideshow (its region
      has tabindex="0" and arrow support) but not of this one, and
      telling a screen reader user to press keys that do nothing is
      worse than saying nothing.
      Images are changed with the thumbnail links, which are already
      keyboard reachable and well labelled - so the gallery IS
      operable, it is only unlabelled.

   What this adds:
     - region role + roledescription + an honest label
     - "Image N of M" groups on the slides, matching the homepage
     - aria-current on the selected thumbnail (its state currently
       lives only in an .is-nav-selected class - arguably its own row)
     - a polite live region announcing the new image, using the house
       pattern (#search-status / #cart-live-region / .jdgm-carousel__status).
       No autoplay gating is needed here: this gallery only changes on
       user action.

   Slide labelling (bug row 114) is handled here too, in the same
   file, so the two fixes cannot race each other over the same
   attributes. Two notes on that row:

     * It says "Image 2 of 7". This product has FOURTEEN slides
       (14 .product-gallery__carousel-item and 14 thumbnails, all
       present and none variant-hidden), so the count in the row does
       not match this URL.
     * The gallery is not all images. The server HTML marks each slide
       with data-media-type: on this product, slides 3 and 5 are
       "external_video" (YouTube) and the other twelve are "image".
       The theme's own thumbnail labels already distinguish them
       ("Load video in gallery view"), so a blanket "Image N of M"
       would mislabel two of the fourteen. Video slides are labelled
       "Video N of M" here.

     * The tabindex="-1" the bug log mentions is on the SLIDES, not on
       the wrapper - the raw markup for each item is
       class,tabindex,data-media-id,data-media-type.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A), 1.3.1 (A), 4.1.3 (AA)
   Theme: Warehouse v4 + Flickity  |  Requires: jQuery (3.7.1 on site)
   ================================================================== */
(function ($) {
  'use strict';

  var WRAPPER   = '.product-gallery__carousel-wrapper';
  var ITEM      = '.product-gallery__carousel-item';
  var THUMB     = 'a.product-gallery__thumbnail';
  var SELECTED  = 'is-nav-selected';
  var STATUS_ID = 'product-gallery-status';

  // Deliberately no "use the arrow keys" - see note 2 above.
  var REGION_LABEL = 'Product images';

  // false: group label is position only ("Image 2 of 14") and the
  //        image keeps its own alt text - no duplicate announcement.
  // true : group label is "Image 2 of 14: <alt>" per bug row 114, and
  //        the img alt is blanked so it is not announced twice.
  var INCLUDE_DESCRIPTION = false;

  function init() {
    var wrapper = document.querySelector(WRAPPER);
    if (!wrapper) { return; }

    /* --- 1. Name and role the gallery --------------------------- */
    if (!wrapper.getAttribute('role')) {
      wrapper.setAttribute('role', 'region');
    }
    if (!wrapper.getAttribute('aria-roledescription')) {
      wrapper.setAttribute('aria-roledescription', 'carousel');
    }
    if (!wrapper.getAttribute('aria-label') && !wrapper.getAttribute('aria-labelledby')) {
      wrapper.setAttribute('aria-label', REGION_LABEL);
    }

    /* --- 2. Label the slides ------------------------------------
       Position only, by default. The slide's <img> already carries a
       real descriptive alt, and repeating it in the group label makes
       a screen reader read the description twice - once entering the
       group, once on the image. Set INCLUDE_DESCRIPTION to true for
       the literal "Image 2 of 14: <description>" wording in the bug
       row; it also blanks the img alt so nothing is read twice, at
       the cost of losing the alt for broken images and image search. */
    // Every slide is rendered with data-media-type in the server HTML
    // ("image" or "external_video"), which is far more reliable than
    // sniffing for an <iframe>: the YouTube embed is injected after
    // load, so a DOM sniff run at init mislabels the video slides as
    // "Image N of M" and the wrong label then sticks.
    function slideKind(el) {
      var type = (el.getAttribute('data-media-type') || '').toLowerCase();
      if (type) { return /video/.test(type) ? 'Video' : 'Image'; }
      return el.querySelector('iframe, video, [class*="video"]') ? 'Video' : 'Image';
    }

    function labelItems() {
      var items = $(wrapper).find(ITEM).toArray();
      var total = items.length;

      $.each(items, function (i, el) {
        if (!el.getAttribute('role')) { el.setAttribute('role', 'group'); }
        if (!el.getAttribute('aria-roledescription')) {
          el.setAttribute('aria-roledescription', 'slide');
        }
        var existing = el.getAttribute('aria-label');
        var ours = el.getAttribute('data-a11y-slide-label');

        // Never clobber a label the theme supplied; only maintain ours.
        if (existing && existing !== ours) { return; }

        var text = slideKind(el) + ' ' + (i + 1) + ' of ' + total;

        if (INCLUDE_DESCRIPTION) {
          var img = el.querySelector('img');
          var alt = img ? $.trim(img.getAttribute('alt') || '') : '';
          if (alt) {
            text += ': ' + alt;
            img.setAttribute('data-a11y-original-alt', alt);
            img.setAttribute('alt', '');      // avoid the double read
          }
        }

        if (existing === text) { return; }

        el.setAttribute('aria-label', text);
        el.setAttribute('data-a11y-slide-label', text);
      });

      return total;
    }

    var total = labelItems();

    /* --- 3. The live region ------------------------------------- */
    var status = document.getElementById(STATUS_ID);
    if (!status) {
      status = document.createElement('div');
      status.id = STATUS_ID;
      status.className = 'visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      wrapper.appendChild(status);
    }

    function currentIndex() {
      var items = $(wrapper).find(ITEM).toArray();
      for (var i = 0; i < items.length; i++) {
        if (/(^|\s)is-selected(\s|$)/.test(items[i].className)) { return i; }
      }
      return -1;
    }

    var last = currentIndex();

    /* --- 4. Thumbnail state + announcement ---------------------- */
    function syncThumbs() {
      var thumbs = $(THUMB).toArray();
      $.each(thumbs, function (i, el) {
        if (new RegExp('(^|\\s)' + SELECTED + '(\\s|$)').test(el.className)) {
          el.setAttribute('aria-current', 'true');
        } else {
          el.removeAttribute('aria-current');
        }
      });
    }

    function update() {
      labelItems();
      syncThumbs();

      var now = currentIndex();
      if (now < 0 || now === last) { return; }
      last = now;
      var items = $(wrapper).find(ITEM).toArray();
      status.textContent = slideKind(items[now]) + ' ' + (now + 1) + ' of ' + total;
    }

    syncThumbs();

    if (window.MutationObserver) {
      var queued = false;
      var observer = new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; update(); }, 100);
      });

      observer.observe(wrapper, {
        attributes: true,
        childList: true,          // catches the video iframes being injected
        subtree: true,
        attributeFilter: ['class', 'aria-hidden']
      });

      var thumbList = document.querySelector('.product-gallery__thumbnail-list');
      if (thumbList) {
        observer.observe(thumbList, {
          attributes: true, subtree: true, attributeFilter: ['class']
        });
      }
    }
  }

  $(init);
}(jQuery));


/* ======== BidetKing — Bug 117: product photo magnification is hover-only==========================================================
   BidetKing — Bug 117: product photo magnification is hover-only

   What is actually there (measured on the product page):

     * The magnifier is Drift.js, not PhotoSwipe. Hovering the main
       image opens <div class="drift-zoom-pane drift-open"> inside
       .product__zoom-wrapper. I confirmed it opens on hover and that
       .pswp stays display:none the whole time on desktop.
     * The instruction line has two variants:
         .hidden-pocket    "Roll over image to zoom in"   (>= lap)
         .hidden-lap-and-up "Click on image to zoom"      (phone)
       so PhotoSwipe is the PHONE zoom path, not the desktop one.
     * Nothing in the image chain is focusable:
         .product-gallery__carousel-item[tabindex="-1"]
           > .product-gallery__size-limiter > .aspect-ratio
             > img.product-gallery__image[tabindex=-1]
       There is no button, no link. A keyboard user has no way in.
       A real mouse click on the image at desktop width does NOT open
       PhotoSwipe either, so "click it with the keyboard" is not a fix.

   THE CLEAN FIX IS THEME-SIDE. The theme's own ProductGallery class
   already has the launcher: its prototype exposes _openMobileZoom()
   and _doPswpAction(). Inside the theme's JS, where the instance is in
   scope, the fix is a few lines - make the zoomable image focusable
   and call _openMobileZoom() on Enter/Space. That reuses PhotoSwipe
   exactly as the bug row recommends.

   THIS FILE IS THE CDN-ONLY FALLBACK, for when the theme JS cannot be
   edited. The gallery instance is not reachable from outside (no
   registry on window.theme, no jQuery data on .product-gallery, and
   the handlers are bound natively), so calling _openMobileZoom() from
   here is not possible. Instead this adds a real focusable control and
   its own small accessible dialog showing the full-size image, which
   is taken from the img's data-zoom attribute (1320px source).

   It also does what the row asks of the instruction text: the control
   is placed in the "Roll over image to zoom in" line, so the keyboard
   route is documented where the mouse route already is.

   WCAG 2.2 - 2.1.1 Keyboard (A); the dialog also satisfies
              2.4.3 Focus Order and 2.1.2 No Keyboard Trap
   Theme: Warehouse v4 + Drift + PhotoSwipe
   Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var NOTICE   = '.product-gallery__zoom-notice';
  var SELECTED = '.product-gallery__carousel-item.is-selected';
  var IMAGE    = 'img.product-gallery__image';
  var BTN_ID   = 'a11y-zoom-button';
  var DLG_ID   = 'a11y-zoom-dialog';

  var CSS =
    '#' + BTN_ID + '{margin-left:.75em;padding:.25em .6em;border:1px solid #354561;' +
      'background:transparent;color:#354561;font:inherit;cursor:pointer;border-radius:3px;}' +
    '#' + DLG_ID + '{position:fixed;inset:0;z-index:9999;display:none;' +
      'align-items:center;justify-content:center;background:rgba(0,0,0,.85);}' +
    '#' + DLG_ID + '.is-open{display:flex;}' +
    '#' + DLG_ID + ' .a11y-zoom-figure{max-width:92vw;max-height:88vh;overflow:auto;background:#fff;}' +
    '#' + DLG_ID + ' img{display:block;max-width:none;}' +
    '#' + DLG_ID + ' .a11y-zoom-close{position:absolute;top:1rem;right:1rem;' +
      'padding:.4em .8em;border:2px solid #fff;background:#354561;color:#fff;font:inherit;cursor:pointer;}';

  function injectCss() {
    if (document.getElementById('a11y-zoom-css')) { return; }
    var s = document.createElement('style');
    s.id = 'a11y-zoom-css';
    s.appendChild(document.createTextNode(CSS));
    document.head.appendChild(s);
  }

  function currentImage() {
    var slide = document.querySelector(SELECTED);
    return slide ? slide.querySelector(IMAGE) : null;
  }

  function isVideoSlide() {
    var slide = document.querySelector(SELECTED);
    return !!slide && /video/i.test(slide.getAttribute('data-media-type') || '');
  }

  function init() {
    var notice = document.querySelector(NOTICE);
    if (!notice) { return; }

    injectCss();

    /* --- The dialog ------------------------------------------------ */
    var dialog = document.createElement('div');
    dialog.id = DLG_ID;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Full-size product image');

    var figure = document.createElement('div');
    figure.className = 'a11y-zoom-figure';
    figure.setAttribute('tabindex', '0');          // so it can be scrolled

    var big = document.createElement('img');
    figure.appendChild(big);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'a11y-zoom-close';
    close.textContent = 'Close';

    dialog.appendChild(figure);
    dialog.appendChild(close);
    document.body.appendChild(dialog);

    var opener = null;

    function open() {
      var img = currentImage();
      if (!img) { return; }

      big.src = img.getAttribute('data-zoom') || img.currentSrc || img.src;
      big.alt = img.getAttribute('alt') || '';

      opener = document.activeElement;
      dialog.classList.add('is-open');
      close.focus();
    }

    function shut() {
      dialog.classList.remove('is-open');
      big.removeAttribute('src');
      if (opener && opener.getClientRects().length) { opener.focus(); }
      opener = null;
    }

    close.addEventListener('click', shut);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) { shut(); }        // backdrop
    });

    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); shut(); return; }

      if (e.key !== 'Tab') { return; }
      // Two stops only: the scrollable image and Close. Keep focus in.
      var stops = [figure, close];
      var i = stops.indexOf(document.activeElement);
      var next = e.shiftKey ? (i <= 0 ? stops.length - 1 : i - 1)
                            : (i === stops.length - 1 ? 0 : i + 1);
      e.preventDefault();
      stops[next].focus();
    });

    /* --- The control, placed in the instruction line --------------- */
    var button = document.createElement('button');
    button.type = 'button';
    button.id = BTN_ID;
    button.textContent = 'View full-size image';
    button.addEventListener('click', open);
    notice.appendChild(button);

    // Videos have nothing to magnify.
    function syncButton() {
      button.hidden = isVideoSlide();
    }

    syncButton();

    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; syncButton(); }, 120);
      }).observe(document.querySelector('.product-gallery__carousel-wrapper') || document.body,
                 { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  }

  $(init);
}(jQuery));


/* =========== BidetKing — Bug 123: popup content carries its own <h1>=======================================================
  

   Measured on the product page:

     * There are SIXTEEN <h1> elements in the DOM before any popup is
       opened - one real page title plus fifteen inside
       .easypopup-popup-item containers. The EasyPopup app renders
       each popup's body THREE times, so five popups produce fifteen.
     * Those fifteen are display:none while closed, so they are out of
       the accessibility tree and do NOT pollute heading navigation at
       rest. The row's premise is right that the problem appears when
       a popup opens.
     * With the Quickship popup open: 2 visible h1s -
         "Alpha JX2 Bidet Toilet Seat"        (the page title)
         "BIDETKING EXPRESS QUICKSHIP PROGRAM" (id=ep-dialog-title-2)
       The dialog contains three copies of that heading; only the
       first is visible and only it carries the id that the dialog's
       aria-labelledby points at.

   ------------------------------------------------------------------
   THE REAL FIX IS IN THE APP, NOT IN CODE.

   This heading is authored content: it lives in the popup body inside
   the EasyPopup app admin. Changing <h1> to <h2> there fixes it at
   source, on every page, with no script - and it is the change to put
   in the audit's Recommendation column.

   This file is the CDN fallback for when the app content cannot be
   edited.
   ------------------------------------------------------------------

   It sets aria-level="2" rather than swapping the tag. Replacing the
   node would mean re-creating it as an <h2> and re-applying the id,
   and ada.js has already set ep-dialog-title-N on that exact node and
   pointed the dialog's aria-labelledby at it - so swapping risks
   breaking the dialog's name for the sake of the outline. aria-level
   changes what a screen reader announces (heading level 2) while
   leaving the element, its id and its CSS untouched.

   WCAG 2.2 - 1.3.1 Info and Relationships (A)
   Theme: Warehouse v4 + EasyPopup
   Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var LEVEL  = '2';
  var SCOPES = '.ep_featherlight, .easypopup-popup-item';

  function demote(root) {
    $(root).find('h1').each(function () {
      if (this.getAttribute('aria-level')) { return; }
      // Implicit role is already heading; aria-level overrides the level.
      this.setAttribute('aria-level', LEVEL);
    });
  }

  function apply() {
    $(SCOPES).each(function () { demote(this); });
  }

  function init() {
    apply();

    // The lightbox is built on demand, so watch for it appearing.
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; apply(); }, 100);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  $(init);
}(jQuery));


/* =========== BidetKing — Bug 124: "(Click for Details)" triggers announce as buttons but do not behave like them=======================================================
   

   What is actually on the page (preview build):

     <a href="#quickship-popup" role="button" aria-haspopup="dialog"
        aria-expanded="false" data-epa11y-trigger
        aria-label="BK Express Quickship — Click for Details, opens a dialog">

   Three corrections to the bug row, all measured:

   1. "still navigating like a link" - it does not. The hrefs are
      in-page fragments (#quickship-popup and three others) and NONE
      of those fragment targets exist in the document. There is
      nothing to navigate to; the control opens a dialog via JS.

   2. "the tooltip container is marked role='alert'" - there is no
      tooltip. Zero role="alert" and zero role="tooltip" anywhere on
      the page, on BOTH builds, before and after opening a popup, and
      none inside the eight .easypopup-popup-item source containers.
      That half of the row does not reproduce here.

   3. The recommendation says to REMOVE role="button". I would keep
      it. These controls open a dialog and have no destination, so
      button is the honest role - and it is the theme's own
      remediation that added it (production has no role override).

   THE REAL DEFECT, which the row does not state, is the one that
   follows from claiming role="button":

      Space does nothing. Focused on the trigger, Space scrolled the
      page (scrollY 0 -> 1332) and no dialog opened; aria-expanded
      stayed false. Enter works correctly.

   A screen reader announces "button", and buttons are operated with
   Space. Anchors activate on Enter only. Same defect as the cart
   toggle in Bug 85.

   The aria-describedby point in the row is fair on its own terms -
   the trigger is not associated with any description - but with no
   tooltip element to point at, there is nothing to reference. The
   aria-label already carries the purpose ("... opens a dialog"), and
   the dialog itself is named via aria-labelledby (Bug 120).

   NOTE ON OVERLAP: the cart toggle (a.header__cart-toggle) is also
   an a[role="button"][data-epa11y-trigger], and the Bug 85 fix
   already gives it Space activation. It is excluded here so the two
   files cannot both fire and double-activate it.

   WCAG 2.2 - 2.1.1 Keyboard (A), 4.1.2 Name, Role, Value (A)
   Theme: Warehouse v4 + EasyPopup
   Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  // Any anchor promoted to a button, except the one Bug 85 handles.
  var SEL = 'a[role="button"]:not(.header__cart-toggle)';

  function isSpace(e) {
    return e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32;
  }

  function init() {
    $(document)
      .on('keydown', SEL, function (e) {
        if (isSpace(e)) { e.preventDefault(); }      // stop the page scroll
      })
      .on('keyup', SEL, function (e) {
        if (!isSpace(e)) { return; }
        e.preventDefault();
        this.click();                                 // match native button timing
      });
  }

  $(init);
}(jQuery));


/* ========BidetKing — Bug 126: quick-view dialogs have no name and are not declared modal ==========================================================
   
   Verified markup (both quick-view modals on the product page):

     <div class="modal" id="modal-quick-view-…" aria-hidden="true">
       <div class="modal__dialog modal__dialog--stretch" role="dialog">
         <button class="modal__close link" data-action="close-modal">
         <div class="modal__loader">
         <div class="modal__inner">          <- empty until opened

   The dialog element carries exactly two attributes, class and role.
   No aria-modal, no aria-label, no aria-labelledby - exactly as the
   row states. For contrast, the mini cart on the same page is done
   properly: role="dialog" aria-modal="true" aria-label="Shopping cart".

   The complication the row does not mention: the dialog is a SHELL.
   .modal__inner is empty and the product content (and therefore the
   product title) is fetched when the modal opens. So aria-labelledby
   cannot be wired up at page load - there is nothing to point at yet.
   This sets a fallback name immediately and upgrades it to the real
   product title as soon as the content lands.

   NOT VERIFIED IN USE: no quick-view trigger renders on the product
   page or the collection page as configured - the modals exist but
   nothing opens them (11 .tmenu_product_quickview divs belong to the
   mega-menu app, not this modal). The attribute work below is
   verified against the shell; the announcement needs one run-through
   wherever quick view is actually enabled.

   ALSO WORTH A LOOK when that happens: aria-modal="true" is a promise
   that focus is confined to the dialog. I could not exercise the open
   state to confirm the theme does that, so check it at the same time -
   if focus is not trapped, the honest fix is to add containment
   rather than to drop the attribute.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var DIALOG   = '.modal__dialog[role="dialog"]';
  var INNER    = '.modal__inner';
  var FALLBACK = 'Quick view';
  var ID_BASE  = 'quick-view-title-';

  // Ordered by preference: the product title as the product template
  // renders it, then any heading in the loaded content.
  var TITLE_SEL = '.product-meta__title, .product-item__title, h1, h2';

  var seq = 0;

  function nameDialog(dialog) {
    var inner = dialog.querySelector(INNER);
    var title = inner ? inner.querySelector(TITLE_SEL) : null;

    if (title && $.trim(title.textContent)) {
      if (!title.id) { title.id = ID_BASE + (++seq); }
      dialog.setAttribute('aria-labelledby', title.id);
      dialog.removeAttribute('aria-label');       // labelledby wins; keep it tidy
      return true;
    }

    // Nothing loaded yet - never leave the dialog nameless.
    if (!dialog.getAttribute('aria-labelledby') && !dialog.getAttribute('aria-label')) {
      dialog.setAttribute('aria-label', FALLBACK);
    }
    return false;
  }

  function apply() {
    $(DIALOG).each(function () {
      if (!this.getAttribute('aria-modal')) {
        this.setAttribute('aria-modal', 'true');
      }
      nameDialog(this);
    });
  }

  function init() {
    if (!document.querySelector(DIALOG)) { return; }

    apply();

    if (window.MutationObserver) {
      var queued = false;
      var observer = new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; apply(); }, 120);
      });

      // Content arriving in .modal__inner, and the modal being shown
      // (the wrapper toggles aria-hidden), both need a re-run.
      $('.modal').each(function () {
        observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-hidden', 'class']
        });
      });
    }
  }

  $(init);
}(jQuery));


/* ==========BidetKing — Bug 127: PhotoSwipe viewer container is unnamed and not declared modal=======================================================
   

   Verified markup - the container carries exactly four attributes:

     <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

   No aria-modal, no aria-label, no aria-labelledby. The row is also
   right that the internal controls are fine: the three buttons are
   labelled Close, Previous and Next.

   I opened it to check the live behaviour (it is the PHONE zoom path -
   at 614px the notice reads "Click on image to zoom" and clicking the
   image opens it; on desktop the magnifier is Drift instead, see
   Bug 117). Two things that change the fix:

     GOOD  On open, PhotoSwipe moves focus into the dialog - the .pswp
           element itself takes focus via its tabindex="-1". Escape
           closes it, even with focus outside the dialog.

     BAD   Focus is NOT contained. Tabbing through Close, Previous,
           Next and then once more leaves the viewer entirely and
           lands on .product-meta__vendor - page content sitting
           behind a full-screen overlay.

   So aria-modal="true" on its own would be a false promise: the
   attribute tells assistive tech the user is confined to the dialog
   while the browser happily tabs them out of it. This file adds the
   containment first and then the attribute, so the two agree.

   The stray-focus behaviour is arguably its own row (2.4.11 Focus Not
   Obscured - a focused control is behind the overlay), and it is not
   in the log.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A); the containment also
              supports 2.4.11 Focus Not Obscured (AA)
   Theme: Warehouse v4 + PhotoSwipe
   Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var PSWP  = '.pswp';
  var OPEN  = 'pswp--open';
  var LABEL = 'Product image viewer';
  var FOCUSABLE = 'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';

  function init() {
    var pswp = document.querySelector(PSWP);
    if (!pswp) { return; }

    if (!pswp.getAttribute('aria-label') && !pswp.getAttribute('aria-labelledby')) {
      pswp.setAttribute('aria-label', LABEL);
    }
    if (!pswp.getAttribute('aria-modal')) {
      pswp.setAttribute('aria-modal', 'true');
    }

    function isOpen() {
      return new RegExp('(^|\\s)' + OPEN + '(\\s|$)').test(pswp.className);
    }

    function stops() {
      return $(pswp).find(FOCUSABLE).filter(function () {
        return this.getClientRects().length > 0;
      }).toArray();
    }

    /* --- Remember where the viewer was opened from ----------------
       PhotoSwipe has already moved focus by the time the open class
       lands, so track the last focus OUTSIDE the dialog instead.   */
    var opener = null;
    document.addEventListener('focusin', function (e) {
      if (!pswp.contains(e.target)) { opener = e.target; }
    }, true);

    /* --- Contain Tab while open ---------------------------------- */
    window.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen()) { return; }

      var items = stops();
      if (!items.length) { return; }

      var i = items.indexOf(document.activeElement);
      var next;

      if (i === -1) {
        next = e.shiftKey ? items[items.length - 1] : items[0];
      } else {
        next = e.shiftKey ? items[(i - 1 + items.length) % items.length]
                          : items[(i + 1) % items.length];
      }

      e.preventDefault();
      next.focus();
    }, true);

    /* --- Put focus back when it closes ---------------------------- */
    if (window.MutationObserver) {
      var wasOpen = isOpen();
      new MutationObserver(function () {
        var now = isOpen();
        if (now === wasOpen) { return; }
        wasOpen = now;

        if (now) { return; }

        var a = document.activeElement;
        var lost = !a || a === document.body || a === document.documentElement || pswp.contains(a);
        if (lost && opener && opener.getClientRects().length) { opener.focus(); }
      }).observe(pswp, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }
  }

  $(init);
}(jQuery));


// /* =========== BidetKing — Bug 128: mobile nav drawer is not a modal and leavesthe page behind it live=======================================================
  

//    Measured at 614px with the drawer open:

//      #mobile-menu attributes: id, class, aria-hidden  - no role,
//        no aria-modal, no label
//      focusables inside the drawer:            20
//      focusables OUTSIDE it, still visible:   134
//        including "Skip to content", the announcement bar, the logo,
//        the search input and everything in main and footer
//      <main> and <footer>: no aria-hidden, no inert

//    So a screen reader reads straight past the drawer into content that
//    is visually covered, exactly as the row says.

//    Also found, and not in the row: ESCAPE DOES NOT CLOSE THE DRAWER.
//    With it open, Escape left aria-expanded="true" and the drawer
//    showing. Worth its own row - it is the expected way out of a modal.

//    Structure that shapes the fix:

//      header.header > div.container > div.header__inner
//        > nav.header__mobile-nav
//            > button.header__mobile-nav-toggle   (the open/close control)
//            > div#mobile-menu                    (the drawer)

//    The toggle is a SIBLING of the drawer, and its label flips to
//    "Close menu" when open - so it is the drawer's close control and
//    must stay reachable. That is why this hides everything outside
//    nav.header__mobile-nav rather than everything outside #mobile-menu:
//    inerting the drawer's own siblings would strand the user with no
//    way out.

//    inert is used as well as aria-hidden: aria-hidden alone removes the
//    background from the accessibility tree but leaves all 134 controls
//    in the tab order. inert does both, and is supported here.

//    WCAG 2.2 - 4.1.2 Name, Role, Value (A), 2.4.3 Focus Order (A)
//    Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
//    ================================================================== */
// (function ($) {
//   'use strict';

//   var TOGGLE = '.header__mobile-nav-toggle';
//   var DRAWER = '#mobile-menu';
//   var LIVE   = '.header__mobile-nav';     // toggle + drawer stay operable
//   var LABEL  = 'Main menu';

//   var HID  = 'data-a11y-drawer-hidden';
//   var INRT = 'data-a11y-drawer-inert';

//   function init() {
//     var toggle = document.querySelector(TOGGLE);
//     var drawer = document.querySelector(DRAWER);
//     if (!toggle || !drawer) { return; }

//     var live = drawer.closest(LIVE) || drawer;

//     if (!drawer.getAttribute('role')) { drawer.setAttribute('role', 'dialog'); }
//     if (!drawer.getAttribute('aria-label') && !drawer.getAttribute('aria-labelledby')) {
//       drawer.setAttribute('aria-label', LABEL);
//     }

//     function isOpen() {
//       return toggle.getAttribute('aria-expanded') === 'true';
//     }

//     /* --- Hide / restore everything outside the live subtree -------- */
//     function background(on) {
//       var node = live;
//       while (node && node.parentElement && node !== document.body) {
//         var parent = node.parentElement;
//         $(parent).children().each(function () {
//           if (this === node) { return; }

//           if (on) {
//             if (!this.hasAttribute('aria-hidden')) {
//               this.setAttribute('aria-hidden', 'true');
//               this.setAttribute(HID, '1');
//             }
//             if (!this.hasAttribute('inert')) {
//               this.setAttribute('inert', '');
//               this.setAttribute(INRT, '1');
//             }
//           } else {
//             if (this.hasAttribute(HID)) {
//               this.removeAttribute('aria-hidden');
//               this.removeAttribute(HID);
//             }
//             if (this.hasAttribute(INRT)) {
//               this.removeAttribute('inert');
//               this.removeAttribute(INRT);
//             }
//           }
//         });
//         node = parent;
//       }
//     }

//     function sync() {
//       if (isOpen()) {
//         drawer.setAttribute('aria-modal', 'true');
//         background(true);
//       } else {
//         drawer.removeAttribute('aria-modal');
//         background(false);
//       }
//     }

//     sync();

//     if (window.MutationObserver) {
//       new MutationObserver(sync).observe(toggle, {
//         attributes: true, attributeFilter: ['aria-expanded']
//       });
//     }

//     /* --- Escape closes and hands focus back to the toggle ---------- */
//     $(document).on('keydown', function (e) {
//       if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
//       if (!isOpen()) { return; }
//       e.preventDefault();
//       toggle.click();           // the toggle IS the close control
//       toggle.focus();
//     });
//   }

//   $(init);
// }(jQuery));

/* ========  BidetKing — Bug 128: mobile nav drawer is not a modal and leaves
   the page behind it live==========================================================
 

   Measured at 614px with the drawer open:

     #mobile-menu attributes: id, class, aria-hidden  - no role,
       no aria-modal, no label
     focusables inside the drawer:            20
     focusables OUTSIDE it, still visible:   134
       including "Skip to content", the announcement bar, the logo,
       the search input and everything in main and footer
     <main> and <footer>: no aria-hidden, no inert

   So a screen reader reads straight past the drawer into content that
   is visually covered, exactly as the row says.

   Also found, and not in the row: ESCAPE DOES NOT CLOSE THE DRAWER.
   With it open, Escape left aria-expanded="true" and the drawer
   showing. Worth its own row - it is the expected way out of a modal.

   Structure that shapes the fix:

     header.header > div.container > div.header__inner
       > nav.header__mobile-nav
           > button.header__mobile-nav-toggle   (the open/close control)
           > div#mobile-menu                    (the drawer)

   The toggle is a SIBLING of the drawer, and its label flips to
   "Close menu" when open - so it is the drawer's close control and
   must stay reachable. That is why this hides everything outside
   nav.header__mobile-nav rather than everything outside #mobile-menu:
   inerting the drawer's own siblings would strand the user with no
   way out.

   inert is used as well as aria-hidden: aria-hidden alone removes the
   background from the accessibility tree but leaves all 134 controls
   in the tab order. inert does both, and is supported here.

   Bug 130 is handled in this same file: on open, focus moves to the
   drawer's first focusable. One correction to that row - it says the
   drawer's contents "come after unrelated header markup in the tab
   order". They do not. Measured at 640px on a clean build, the very
   first Tab after opening lands on "Bidet Seats", the first link
   inside the drawer, because the toggle and the drawer are siblings
   in nav.header__mobile-nav. So the only real defect there is that
   focus starts on the toggle rather than inside.

   That is only worth changing BECAUSE of the Bug 128 work: a plain
   disclosure may reasonably leave focus on its trigger, but a
   dialog with aria-modal="true" should move focus into itself. The
   two changes belong together, which is why they ship as one file.

   WCAG 2.2 - 4.1.2 Name, Role, Value (A), 2.4.3 Focus Order (A)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var TOGGLE = '.header__mobile-nav-toggle';
  var DRAWER = '#mobile-menu';
  var LIVE   = '.header__mobile-nav';     // toggle + drawer stay operable
  var LABEL  = 'Main menu';

  var HID  = 'data-a11y-drawer-hidden';
  var INRT = 'data-a11y-drawer-inert';

  function init() {
    var toggle = document.querySelector(TOGGLE);
    var drawer = document.querySelector(DRAWER);
    if (!toggle || !drawer) { return; }

    var live = drawer.closest(LIVE) || drawer;

    if (!drawer.getAttribute('role')) { drawer.setAttribute('role', 'dialog'); }
    if (!drawer.getAttribute('aria-label') && !drawer.getAttribute('aria-labelledby')) {
      drawer.setAttribute('aria-label', LABEL);
    }

    function isOpen() {
      return toggle.getAttribute('aria-expanded') === 'true';
    }

    /* --- Hide / restore everything outside the live subtree -------- */
    function background(on) {
      var node = live;
      while (node && node.parentElement && node !== document.body) {
        var parent = node.parentElement;
        $(parent).children().each(function () {
          if (this === node) { return; }

          if (on) {
            if (!this.hasAttribute('aria-hidden')) {
              this.setAttribute('aria-hidden', 'true');
              this.setAttribute(HID, '1');
            }
            if (!this.hasAttribute('inert')) {
              this.setAttribute('inert', '');
              this.setAttribute(INRT, '1');
            }
          } else {
            if (this.hasAttribute(HID)) {
              this.removeAttribute('aria-hidden');
              this.removeAttribute(HID);
            }
            if (this.hasAttribute(INRT)) {
              this.removeAttribute('inert');
              this.removeAttribute(INRT);
            }
          }
        });
        node = parent;
      }
    }

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function focusFirstInDrawer() {
      var first = $(drawer).find(FOCUSABLE).filter(function () {
        return this.getClientRects().length > 0;
      })[0];
      if (first) { first.focus(); }
    }

    var wasOpen = isOpen();

    function sync() {
      var open = isOpen();

      if (open) {
        drawer.setAttribute('aria-modal', 'true');
        background(true);
      } else {
        drawer.removeAttribute('aria-modal');
        background(false);
      }

      // Bug 130: move focus in on the open transition only - never on
      // a re-sync, or it would yank focus back while the user reads.
      if (open && !wasOpen) {
        window.setTimeout(focusFirstInDrawer, 50);   // let the drawer paint
      }

      wasOpen = open;
    }

    sync();

    if (window.MutationObserver) {
      new MutationObserver(sync).observe(toggle, {
        attributes: true, attributeFilter: ['aria-expanded']
      });
    }

    /* --- Escape closes and hands focus back to the toggle ---------- */
    $(document).on('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
      if (!isOpen()) { return; }
      e.preventDefault();
      toggle.click();           // the toggle IS the close control
      toggle.focus();
    });
  }

  $(init);
}(jQuery));


/* ===========================BidetKing.com — Judge.me reviews carousel: play/pause actually pauses=================================================
 * 
 * ----------------------------------------------------------------------------
 * SYMPTOM
 *   The play/pause button on the reviews slider does nothing. Pressing it flips
 *   the icon and the accessible name, but the carousel keeps sliding.
 *
 * EVIDENCE (preview, home page)
 *   Button reports aria-label="Play reviews carousel" (i.e. "I am paused"),
 *   while .jdgm-carousel__item-wrapper transform moved
 *     matrix(1,0,0,1,-1784,0)  ->  matrix(1,0,0,1,-2204.23,0)   over 6s.
 *   Advancing, with the control claiming it is stopped.
 *
 * ROOT CAUSE — three separate faults in the deployed handler (ada-vs.js)
 *
 *   1. It targets a control that does not exist on this store.
 *        var nativeBtn = wrapper.querySelector('.jdgm-carousel__play-pause');
 *        nativeBtn && ... && nativeBtn.click();
 *      Judge.me renders NO native play/pause here. Verified:
 *      document.querySelector('.jdgm-carousel__play-pause') === null.
 *      nativeBtn is null, so the only line that could have stopped anything is
 *      short-circuited away every time.
 *
 *   2. Its fallback pauses CSS animations, and there are none.
 *        getComputedStyle(el).animationName !== 'none' &&
 *          (el.style.animationPlayState = state)
 *      Verified: 0 elements inside .jdgm-carousel-wrapper have an animationName.
 *      The carousel is not CSS-animated — Judge.me advances it from a JS timer
 *      by writing transform: translate3d(...) on the item wrapper. animation-
 *      play-state has nothing to act on.
 *
 *   3. Even a correct attempt would have failed, because of a jQuery split.
 *      The real handle is the interval id, which Judge.me stores as jQuery data:
 *        jdgm.autoSlideCarousel = function(e){
 *          var i = 1000 * (jdgmSettings.featured_carousel_autoslide_interval ||
 *                          jdgmSettings.autoSlideInterval);
 *          var t = setInterval(function(){ return jdgm.performSliding(e,1); }, i);
 *          return e.data('auto-slider', t);
 *        }
 *      Judge.me runs its OWN jQuery 3.6.0; the theme runs 3.7.1. jQuery keeps
 *      .data() in a per-copy internal cache, so the two do not see each other:
 *        jdgm.jQuery('.jdgm-carousel').data('auto-slider')  -> 437
 *        window.jQuery('.jdgm-carousel').data('auto-slider') -> undefined
 *      Any fix written against the theme's jQuery reads undefined and silently
 *      does nothing. THIS is the trap to avoid on re-implementation.
 *
 *   Net effect: WCAG 2.2.2 Pause, Stop, Hide (Level A) still fails. Moving
 *   content that auto-starts and runs longer than 5s has no working pause. The
 *   button being present but inert is worse than absent — it tells a user the
 *   motion has stopped when it has not.
 *
 * FIX
 *   Drive the real timer, through Judge.me's own jQuery:
 *     pause  -> clearInterval(J(car).data('auto-slider'))
 *     resume -> jdgm.autoSlideCarousel(J(car))
 *   Verified both directions on preview: cleared timer 437, transform frozen at
 *   matrix(1,0,0,1,-892,0) across 7s; resumed as timer 889, transform moved to
 *   matrix(1,0,0,1,-1115,0).
 *
 *   This file REPLACES the button installed by ada-vs.js. It removes the old
 *   node (which drops the old broken listener with it) and inserts its own,
 *   reusing the same class names so the existing ada.css styling and icons
 *   carry over unchanged. Remove the old block from ada-vs.js when convenient;
 *   this file is safe to run either way.
 *
 * NOTES ON THE PATTERN
 *   - No aria-pressed. This is a name-changing toggle ("Pause reviews
 *     carousel" / "Play reviews carousel"), which is the APG pattern for
 *     media-style controls. Adding aria-pressed on top produces doubled,
 *     contradictory output ("Play ... pressed").
 *   - The control stays the FIRST child of the wrapper so keyboard and screen
 *     reader users reach it before the moving content, per 2.2.2.
 *   - Judge.me re-initialises its widgets asynchronously and will happily start
 *     a fresh interval after the user has paused. A watchdog re-clears any new
 *     timer while the paused state is held.
 *
 * DEPENDENCIES: none beyond Judge.me itself (does not use the theme's jQuery)
 * DEPLOY: append to a11y.js / ada.js, and delete the old block in ada-vs.js
 * ==========================================================================*/
// (function () {
//   'use strict';

//   var CAROUSEL_SEL = '.jdgm-carousel',
//       WRAPPER_SEL  = '.jdgm-carousel-wrapper',
//       BTN_CLASS    = 'a11y-jdgm-carousel-pp',
//       PAUSED_CLASS = 'is-paused',
//       DATA_KEY     = 'auto-slider',
//       LIVE_ID      = 'a11y-reviews-carousel-status',
//       WATCH_MS     = 1000,
//       BOOT_TRIES   = 40,      // ~20s at 500ms — Judge.me loads late
//       BOOT_EVERY   = 500;

//   function jdgmJQuery() {
//     return window.jdgm && (window.jdgm.jQuery || window.jdgm.$) || null;
//   }

//   function liveRegion() {
//     var el = document.getElementById(LIVE_ID);
//     if (el) { return el; }
//     el = document.createElement('div');
//     el.id = LIVE_ID;
//     el.className = 'visually-hidden';
//     el.setAttribute('role', 'status');
//     el.setAttribute('aria-live', 'polite');
//     el.setAttribute('aria-atomic', 'true');
//     document.body.appendChild(el);
//     return el;
//   }

//   function announce(msg) {
//     var el = liveRegion();
//     el.textContent = '';
//     window.setTimeout(function () { el.textContent = msg; }, 50);
//   }

//   function enhance(carousel) {
//     if (carousel.__a11yPlayPause) { return; }
//     carousel.__a11yPlayPause = true;

//     var J = jdgmJQuery();
//     if (!J) { return; }

//     var wrapper = carousel.closest(WRAPPER_SEL) || carousel.parentElement,
//         $car = J(carousel),
//         paused = false,
//         watchdog = null;

//     // ---- the real controls -------------------------------------------------
//     function stopTimer() {
//       var id = $car.data(DATA_KEY);
//       if (id) {
//         window.clearInterval(id);
//         $car.removeData(DATA_KEY);
//       }
//     }

//     function startTimer() {
//       if ($car.data(DATA_KEY)) { return; }              // already running
//       if (window.jdgm && typeof window.jdgm.autoSlideCarousel === 'function') {
//         window.jdgm.autoSlideCarousel($car);
//       }
//     }

//     // Judge.me may re-init and start a new interval behind our back.
//     function watch() {
//       if (watchdog) { return; }
//       watchdog = window.setInterval(function () {
//         if (paused) { stopTimer(); } else { unwatch(); }
//       }, WATCH_MS);
//     }

//     function unwatch() {
//       if (watchdog) { window.clearInterval(watchdog); watchdog = null; }
//     }

//     // ---- button ------------------------------------------------------------
//     // Drop the button ada-vs.js installed, taking its broken listener with it.
//     var old = wrapper.querySelector('.' + BTN_CLASS);
//     if (old) { old.parentNode.removeChild(old); }

//     var btn = document.createElement('button');
//     btn.type = 'button';
//     btn.className = BTN_CLASS;

//     function sync() {
//       btn.classList.toggle(PAUSED_CLASS, paused);
//       btn.setAttribute(
//         'aria-label',
//         paused ? 'Play reviews carousel' : 'Pause reviews carousel'
//       );
//     }

//     function setPaused(next, announceIt) {
//       paused = !!next;
//       if (paused) { stopTimer(); watch(); } else { unwatch(); startTimer(); }
//       sync();
//       if (announceIt) {
//         announce(paused ? 'Reviews carousel paused.' : 'Reviews carousel playing.');
//       }
//     }

//     btn.addEventListener('click', function () { setPaused(!paused, true); });

//     sync();
//     wrapper.insertBefore(btn, wrapper.firstChild);

//     // Honour reduced motion — and this time actually stop the thing.
//     if (window.matchMedia &&
//         window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//       setPaused(true, false);
//     }
//   }

//   function run() {
//     var carousels = document.querySelectorAll(CAROUSEL_SEL);
//     if (!carousels.length || !jdgmJQuery()) { return false; }
//     Array.prototype.forEach.call(carousels, enhance);
//     return true;
//   }

//   function boot() {
//     if (run()) { return; }
//     var tries = 0,
//         poll = window.setInterval(function () {
//           if (run() || ++tries >= BOOT_TRIES) { window.clearInterval(poll); }
//         }, BOOT_EVERY);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', boot);
//   } else {
//     boot();
//   }
// })();
(function () {
  'use strict';
  var CAROUSEL = '.jdgm-carousel', WRAPPER = '.jdgm-carousel-wrapper',
      BTN = 'a11y-jdgm-carousel-pp', PAUSED = 'is-paused', LIVE_ID = 'a11y-reviews-carousel-status';

  function live() {
    var el = document.getElementById(LIVE_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = LIVE_ID; el.className = 'visually-hidden';
      el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); el.setAttribute('aria-atomic', 'true');
      document.body.appendChild(el);
    }
    return el;
  }
  function announce(msg) { var el = live(); el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 50); }

  // Every jQuery data store attached to this element, whichever instance wrote it
  function stores(el) {
    return Object.keys(el).filter(function (k) { return /^jQuery\d+/.test(k); })
      .map(function (k) { return el[k]; }).filter(function (s) { return s && typeof s === 'object'; });
  }
  function killTimers(el) {
    stores(el).forEach(function (s) {
      ['autoSlider', 'auto-slider'].forEach(function (k) {
        if (s[k]) { clearInterval(s[k]); delete s[k]; }
      });
    });
  }
  function currentJ() { return window.jdgm && (window.jdgm.jQuery || window.jdgm.$) || null; }

  // Single global guard: performSliding is what every interval calls, in every instance
  function patchSliding() {
    var j = window.jdgm;
    if (!j || typeof j.performSliding !== 'function' || j.performSliding.__a11yPatched) return;
    var orig = j.performSliding;
    j.performSliding = function (e, n, force) {
      var el = e && e[0];
      if (!force && el && el.__a11yPaused) return;   // block auto-advance; user arrows pass force=true? no – see below
      return orig.apply(this, arguments);
    };
    j.performSliding.__a11yPatched = true;
  }

  function enhance(carousel) {
    if (carousel.__a11yPlayPause) return;
    carousel.__a11yPlayPause = true;
    var wrapper = carousel.closest(WRAPPER) || carousel.parentElement;
    var old = wrapper.querySelector('.' + BTN); if (old) old.remove();

    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = BTN;

    function sync() {
      btn.classList.toggle(PAUSED, !!carousel.__a11yPaused);
      btn.setAttribute('aria-label', carousel.__a11yPaused ? 'Play reviews carousel' : 'Pause reviews carousel');
    }
    function setPaused(next, say) {
      carousel.__a11yPaused = !!next;
      patchSliding();
      if (next) {
        killTimers(carousel);
      } else {
        var J = currentJ();
        killTimers(carousel);                       // avoid doubling up
        if (J && window.jdgm.autoSlideCarousel) window.jdgm.autoSlideCarousel(J(carousel));
      }
      sync();
      if (say) announce(next ? 'Reviews carousel paused.' : 'Reviews carousel playing.');
    }

    // Judge.me restarts the timer on mouseleave – re-kill it while paused
    carousel.addEventListener('mouseleave', function () { if (carousel.__a11yPaused) setTimeout(function () { killTimers(carousel); }, 0); });

    btn.addEventListener('click', function () { setPaused(!carousel.__a11yPaused, true); });
    sync();
    wrapper.insertBefore(btn, wrapper.firstChild);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) setPaused(true, false);
  }

  function run() {
    patchSliding();
    document.querySelectorAll(CAROUSEL).forEach(enhance);
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();



/* ============ BidetKing — Bug 135: changing a line item's quantity announces "Item added to cart."=====================================================
   

   Reproduced in the drawer with one line item:

     click "Increase quantity"  ->  quantity goes 1 -> 2
     #cart-live-region receives: "Item added to cart."

   Identical to the message for a brand-new addition, and neither the
   new quantity nor the updated total is announced - even though the
   drawer displays both ("Total $778.00 USD" in
   .mini-cart__recap-price-line).

   SEPARATE DEFECT FOUND ALONGSIDE, worth its own row:
   the quantity field is <input class="quantity-selector__value"
   role="status" aria-label="Quantity">. role="status" on an <input>
   OVERRIDES its textbox role, so screen readers announce it as a
   status region rather than an editable quantity field - and it does
   not achieve the announcement it was presumably added for, because
   live regions announce text content changes, not input VALUE
   changes. Removing role="status" from that input is the fix; this
   file does not touch it, since that is a different row.

   What this does: when a quantity control is used, it replaces the
   generic message with a specific one built from the drawer's own
   re-rendered content:

     "Alpha JX2 Bidet Toilet Seat - White / Elongated quantity
      updated to 2. Cart total $778.00 USD."

   WCAG 2.2 - 4.1.3 Status Messages (AA)
   Theme: Warehouse v4  |  Requires: jQuery (3.7.1 already on the site)
   ================================================================== */
(function ($) {
  'use strict';

  var DRAWER   = '#mini-cart';
  var LIVE     = '#cart-live-region';
  var QTY_BTN  = '.quantity-selector__button';
  var QTY_VAL  = '.quantity-selector__value';
  var TITLE    = '.mini-cart__product-title';
  var TOTAL    = '.mini-cart__recap-price-line';
  var ITEM     = '.mini-cart__product, .mini-cart__line-item, li';

  var CLAIM_MS = 2500;     // how long after a click we own the message

  function init() {
    var live = document.querySelector(LIVE);
    var drawer = document.querySelector(DRAWER);
    if (!live || !drawer) { return; }

    var claimUntil = 0;
    var lineIndex = -1;
    var writing = false;

    function lines() {
      return $(drawer).find(TITLE).toArray();
    }

    function totalText() {
      var row = drawer.querySelector(TOTAL);
      if (!row) { return ''; }
      // The label ("Total") and the amount share the row; take the amount.
      var amount = $(row).find('*').filter(function () {
        return this.children.length === 0 && /\d/.test(this.textContent || '');
      }).last().text();
      return $.trim(amount);
    }

    function compose() {
      var titles = lines();
      var title = titles[lineIndex] || titles[0];
      if (!title) { return ''; }

      var item = title.closest(ITEM) || drawer;
      var input = item.querySelector(QTY_VAL) || drawer.querySelector(QTY_VAL);
      var qty = input ? $.trim(input.value || input.textContent) : '';
      if (!qty) { return ''; }

      var msg = $.trim(title.textContent.replace(/\s+/g, ' ')) +
                ' quantity updated to ' + qty + '.';

      var total = totalText();
      if (total) { msg += ' Cart total ' + total + '.'; }

      return msg;
    }

    function claim() {
      claimUntil = Date.now() + CLAIM_MS;
    }

    // Which line was touched, so the right title is announced.
    $(document).on('click', DRAWER + ' ' + QTY_BTN, function () {
      var title = $(this).closest(ITEM).find(TITLE)[0];
      lineIndex = title ? lines().indexOf(title) : 0;
      claim();
    });

    $(document).on('change', DRAWER + ' ' + QTY_VAL, function () {
      var title = $(this).closest(ITEM).find(TITLE)[0];
      lineIndex = title ? lines().indexOf(title) : 0;
      claim();
    });

    /* --- Replace the generic message while we own it --------------- */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (writing) { return; }
        if (!claimUntil || Date.now() > claimUntil) { return; }

        var text = $.trim(live.textContent);
        if (!text) { return; }

        var msg = compose();
        if (!msg || msg === text) { return; }

        writing = true;
        live.textContent = msg;
        claimUntil = 0;
        window.setTimeout(function () { writing = false; }, 0);
      }).observe(live, { childList: true, subtree: true, characterData: true });
    }
  }

  $(init);
}(jQuery));


/* ============================================================================
 * BidetKing.com — Mini-cart list semantics
 * ----------------------------------------------------------------------------
 * SYMPTOM REPORTED
 *   Opening the cart drawer is announced as:
 *     "Shopping cart, dialogue, with 19 items, White bidet toilet seat with
 *      front control panel and attached handheld remote, group, banner"
 *   ...while the cart contains 4 products.
 *
 * ROOT CAUSE
 *   The "19" is NOT in the page. Verified on preview: no attribute, no text
 *   node and no aria-label anywhere in the cart markup contains it. The cart
 *   drawer is:
 *
 *     <form id="mini-cart" role="dialog" aria-modal="true" aria-label="Shopping cart">
 *
 *   — an accessible name that is a fixed string with no count in it.
 *
 *   "with N items" is the screen reader's OWN count of the nodes it is about
 *   to traverse inside the container it just entered. Screen readers fall back
 *   to that raw child count when a container has no list semantics to report
 *   instead. And the cart list has none:
 *
 *     <div class="mini-cart__line-item-list">      <- plain div, no role="list"
 *       <div class="mini-cart__line-item">  ...    <- plain div, no role="listitem"
 *
 *   Measured on preview with ONE product in the cart, the dialog subtree holds
 *   ~17 exposed accessibility nodes (10 of them focusable). So the number a
 *   user hears is DOM arithmetic — it has no relationship to how many products
 *   are in the cart, and it will never match. This is WCAG 1.3.1 Info and
 *   Relationships (Level A): a visual list of cart line items is not conveyed
 *   as a list programmatically.
 *
 * FIX
 *   Give the line-item list real list semantics. Once the list is a list, the
 *   screen reader announces "list, 4 items" — a count that IS the product
 *   count — instead of inventing one from the node graph.
 *
 *   NOTE: the container count on the DIALOG itself cannot be suppressed; it is
 *   inherent screen reader behaviour for any container. Do NOT try to "fix" it
 *   by putting a number into the dialog's aria-label — that produces
 *   "Shopping cart, 4 items, dialogue, with 19 items", which is worse. The
 *   truthful count belongs on the list. The running total is already announced
 *   correctly by the cart toggle ("Cart, 4 items" — see Bug 85).
 *
 *   Also handled here: the line-item thumbnail is a standalone <img> (not
 *   wrapped in a link) carrying a long descriptive alt, immediately followed
 *   by a link whose text is the same product. The alt adds nothing and is read
 *   twice per line item — it is what filled the rest of the announcement in
 *   the screenshot. Decorative in this context, so alt="" (WCAG 1.1.1).
 *
 * DEPENDENCIES: jQuery 3.7.1 (already site-wide)
 * DEPLOY: append to a11y.js
 * ==========================================================================*/
(function ($) {
  'use strict';

  var LIST_SEL = '.mini-cart__line-item-list',
      ITEM_SEL = '.mini-cart__line-item',
      IMG_SEL  = '.mini-cart__image-wrapper img',
      DRAWER   = '#mini-cart';

  function applyListSemantics(scope) {
    $(scope).find(LIST_SEL).addBack(LIST_SEL).each(function () {
      var $list = $(this),
          $items = $list.children(ITEM_SEL);

      // Only expose a list when there is something in it. An empty cart should
      // not announce "list, 0 items".
      if (!$items.length) {
        $list.removeAttr('role');
        return;
      }

      if ($list.attr('role') !== 'list') {
        $list.attr('role', 'list');
      }

      $items.each(function () {
        if (this.getAttribute('role') !== 'listitem') {
          this.setAttribute('role', 'listitem');
        }
      });

      // Anything else that is a direct child of the list (Shopify sometimes
      // renders discount/gift notes here) would break the list/listitem
      // ownership contract, so neutralise it.
      $list.children().not(ITEM_SEL).each(function () {
        if (!this.getAttribute('role')) {
          this.setAttribute('role', 'presentation');
        }
      });
    });
  }

  function silenceThumbnails(scope) {
    $(scope).find(IMG_SEL).each(function () {
      var alt = this.getAttribute('alt');
      if (alt === '') { return; }                       // already done
      if (alt !== null && !this.hasAttribute('data-a11y-original-alt')) {
        this.setAttribute('data-a11y-original-alt', alt); // keep for audit/rollback
      }
      this.setAttribute('alt', '');
      this.setAttribute('aria-hidden', 'true');
    });
  }

  function apply(scope) {
    scope = scope || document;
    applyListSemantics(scope);
    silenceThumbnails(scope);
  }

  function boot() {
    apply(document);

    // The cart drawer is re-rendered wholesale on every add / remove /
    // quantity change, which throws these attributes away each time.
    var host = document.querySelector(DRAWER) || document.body;
    if (window.MutationObserver && host) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) { return; }
        pending = window.setTimeout(function () {
          pending = null;
          apply(document);
        }, 50);
      }).observe(host, { childList: true, subtree: true });
    }

    // Section re-render in the theme editor / on cart section refresh.
    $(document).on('shopify:section:load', function () { apply(document); });
    $(document).on('cart:refresh cart:updated cart:change', function () { apply(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(jQuery);

/* =====================BidetKing.com — Bug 136: "Remove" controls must name their product=======================================================
 * 
 * ----------------------------------------------------------------------------
 * ROW CORRECTIONS (please apply before this goes to the client dev)
 *
 * 1. STATUS IS WRONG FOR THE DRAWER. The row says "Not fixed" for both
 *    surfaces. The mini-cart drawer is already fixed on the current theme, and
 *    fixed in Liquid rather than by script — the server HTML carries:
 *
 *      <a href="/cart/change?quantity=0&line=1" data-action="decrease-quantity"
 *         class="mini-cart__quantity-remove link"
 *         aria-label="remove item Alpha JX2 Bidet Toilet Seat - White / Elongated "
 *      >Remove</a>
 *
 *    Only the /cart PAGE is unlabelled:
 *
 *      <a href="/cart/change?quantity=0&line=1" data-action="decrease-quantity"
 *         class="line-item__quantity-remove link"
 *      >Remove</a>
 *
 *    Scope the row to /cart, or a dev will "fix" the drawer twice and report
 *    the row as bogus.
 *
 * 2. TWO CONTROLS PER LINE ITEM ON /cart, not one. The template renders a
 *    mobile copy and a desktop copy of every Remove link, both pointing at the
 *    same line:
 *      div.line-item__quantity.hidden-tablet-and-up < td.line-item__product-info
 *      td.line-item__quantity.table__cell--center
 *    Only one is visible at a time, so this is not a duplicate-control defect,
 *    but any fix must label BOTH or the failure survives at one breakpoint.
 *    Verified: 2 matches for a single line item in the cart.
 *
 * 3. THE CRITERION HOLDS, BUT NOT FOR THE REASON A DEV WILL ASSUME.
 *    2.4.4 Link Purpose (In Context) is right. Expect the pushback "it is in
 *    the same table row as the product name, so context covers it." It does
 *    not. WCAG's programmatically determined link context is text in the same
 *    sentence, paragraph, list item or TABLE CELL as the link, or in the table
 *    HEADER cell associated with it. Here the link sits in
 *    td.line-item__quantity; the product name is in a SIBLING cell
 *    (td.line-item__product-info), and the associated headers are
 *    "Product | Quantity | Total". A sibling data cell is not in that list, so
 *    the context is not programmatically determined and 2.4.4 fails.
 *    Worth writing that into the row now.
 *
 * 4. LABEL WORDING. The row's suggested "Remove [Product Name] from cart" is
 *    correct and better than what the drawer currently ships, for two reasons:
 *    it starts with the visible text "Remove", which keeps 2.5.3 Label in Name
 *    comfortable and lets speech-input users say "click Remove"; and the
 *    drawer's current string is lowercase "remove item ..." with a trailing
 *    space. This file normalises both surfaces to one wording.
 *
 * WHAT THIS FILE DOES
 *    Sets aria-label="Remove <full product title> from cart" on every remove
 *    control in the drawer and on /cart, re-applying after each cart re-render.
 *    Visible text stays "Remove" — nothing changes on screen.
 *
 * THE REAL FIX is in Liquid: the /cart line-item snippet should carry the same
 *    aria-label the mini-cart snippet already has. This file is the interim
 *    layer and is safe to leave in place afterwards (it is idempotent and will
 *    simply agree with the markup).
 *
 * DEPENDENCIES: jQuery 3.7.1 (already site-wide)
 * DEPLOY: append to a11y.js
 * ==========================================================================*/
(function ($) {
  'use strict';

  // [ remove-control selector, ancestor that scopes one line item, title within it ]
  var SURFACES = [
    ['a.mini-cart__quantity-remove',  '.mini-cart__line-item', '.mini-cart__product-title'],
    ['a.line-item__quantity-remove',  'tr.line-item',          'a.line-item__title, .line-item__title']
  ];

  // Catches markup variants without needing a row per template.
  var FALLBACK_CTRL = 'a[data-action="decrease-quantity"][data-quantity="0"], ' +
                      'button[data-action="decrease-quantity"][data-quantity="0"]';

  function clean(s) {
    return $.trim(String(s || '').replace(/\s+/g, ' '));
  }

  function titleFor(ctrl, itemSel, titleSel) {
    var $item = itemSel ? $(ctrl).closest(itemSel) : $();
    if (!$item.length) {
      // Unknown template: walk up to the nearest row / list item / line item.
      $item = $(ctrl).closest('tr, li, [role="listitem"], [class*="line-item"], [class*="cart-item"]');
    }
    if (!$item.length) { return ''; }

    var t = clean($item.find(titleSel || '').first().text());
    if (t) { return t; }

    // Last resort: the product link in the same line.
    return clean($item.find('a[href*="/products/"]').first().text());
  }

  function label(ctrl, itemSel, titleSel) {
    var title = titleFor(ctrl, itemSel, titleSel),
        want = title ? 'Remove ' + title + ' from cart' : 'Remove item from cart';

    // Idempotent — do not thrash the attribute on every mutation.
    if (ctrl.getAttribute('aria-label') !== want) {
      ctrl.setAttribute('aria-label', want);
    }
  }

  function apply(scope) {
    scope = scope || document;

    $.each(SURFACES, function (_, s) {
      $(scope).find(s[0]).addBack(s[0]).each(function () {
        label(this, s[1], s[2]);
      });
    });

    // Anything the two selectors above missed.
    $(scope).find(FALLBACK_CTRL).addBack(FALLBACK_CTRL).each(function () {
      if (this.getAttribute('aria-label')) { return; }
      label(this, null, '.mini-cart__product-title, a.line-item__title, .line-item__title');
    });
  }

  function boot() {
    apply(document);

    // The two surfaces behave differently, and it is worth knowing which:
    //
    //   /cart      Remove and the quantity steppers are plain
    //              <a href="/cart/change?quantity=N&line=N"> navigations. Every
    //              change is a FULL PAGE LOAD — verified by planting a window
    //              marker, clicking a quantity button, and finding the marker
    //              gone afterwards. So on /cart this script simply re-runs from
    //              scratch on each load; no observer is involved.
    //
    //   drawer     Re-rendered in place over AJAX, replacing the line items
    //              underneath #mini-cart. That is what the observer is for.
    //
    // Bound to document.body rather than to #mini-cart or .line-item-table so
    // it keeps working if a re-render swaps those nodes out rather than
    // mutating them. childList only — this file writes attributes, so it cannot
    // retrigger itself, and the debounced work is a few querySelectorAll calls.
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) { return; }
        pending = window.setTimeout(function () {
          pending = null;
          apply(document);
        }, 100);
      }).observe(document.body, { childList: true, subtree: true });
    }

    $(document).on('shopify:section:load', function () { apply(document); });
    $(document).on('cart:refresh cart:updated cart:change', function () { apply(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(jQuery);

/* ============= BidetKing.com — Bug 137: restore focus after a cart mutation===============================================================
 * 
 * ----------------------------------------------------------------------------
 * CONFIRMED, BOTH SURFACES
 *   Drawer, quantity + on line 2 (focus verified on the button first):
 *       after re-render  document.activeElement === document.body
 *   Drawer, Remove on line 2:
 *       after re-render  document.activeElement === document.body
 *   Keyboard user is dumped to the top of the document and has to Tab all the
 *   way back for every single change. WCAG 2.4.3 Focus Order. Severity High is
 *   right.
 *
 * ROW CORRECTION — THE TWO SURFACES FAIL FOR DIFFERENT REASONS
 *   The row treats /cart and the drawer as one defect ("re-renders the line
 *   items and leaves focus on <body>"). That is true of the DRAWER only.
 *
 *   /cart does not re-render. It performs a FULL PAGE NAVIGATION on every
 *   mutation. Verified: planted a marker on window, clicked a quantity
 *   stepper, and the marker was gone afterwards —
 *       window.__marker  ->  undefined   (new document)
 *   The quantity steppers are <button data-action="increase-quantity"
 *   data-line="1">, but the theme resolves them to /cart/change?quantity=N&line=N
 *   and navigates; Remove is a plain <a> to the same endpoint.
 *
 *   This matters for the fix. You cannot "restore focus after the re-render" on
 *   /cart, because there is no re-render and no surviving JavaScript state —
 *   the recommendation as written is not implementable there. The intent has to
 *   be persisted ACROSS the navigation and replayed on the next page load.
 *   Split the row, or add a note, so the dev does not build the drawer solution
 *   twice and report /cart as unfixable.
 *
 *   Knock-on effect worth its own row: because /cart reloads, any live-region
 *   confirmation dies with the document. A screen reader user removing an item
 *   on /cart gets a silent page load. That is 4.1.3, not 2.4.3, and it is not
 *   fixed by this file.
 *
 * WHAT THIS FILE DOES
 *   Records which line and which control the user activated, then puts focus
 *   back on the equivalent control once the new list exists.
 *     drawer -> held in memory, replayed after the AJAX re-render
 *     /cart  -> held in sessionStorage, replayed on the next page load
 *
 *   Target selection, per the row's own recommendation:
 *     - quantity + / - / field  -> the same line's same control
 *     - remove                  -> the control at the same POSITION, which is
 *                                  now the next line item down
 *     - that position no longer exists -> the last line item's equivalent
 *     - cart now empty          -> drawer: the cart toggle
 *                                  /cart:  first control in the empty state,
 *                                          else the page heading
 *
 * TWO IMPLEMENTATION NOTES
 *   1. Only restore when focus was ACTUALLY lost. An earlier fix of this shape
 *      (Bug 105) failed because it disarmed itself on the first retry while
 *      focus was still on the pre-render node. Here the guard is: act only if
 *      activeElement is body or the recorded element has left the document, and
 *      never disarm for any other reason — keep retrying until the deadline.
 *   2. On /cart the restore must not fire on an ordinary visit to the page, so
 *      the stored record carries a timestamp, is only honoured for MAX_AGE ms,
 *      and is deleted the moment it is read.
 *
 * DEPENDENCIES: jQuery 3.7.1 (already site-wide)
 * DEPLOY: append to a11y.js
 * ==========================================================================*/
(function ($) {
  'use strict';

  var DRAWER      = '#mini-cart',
      DRAWER_ITEM = '.mini-cart__line-item',
      PAGE_ITEM   = 'tr.line-item',
      STEPPER     = 'button.quantity-selector__button',
      QTY_INPUT   = 'input.quantity-selector__value',
      REMOVE      = 'a.mini-cart__quantity-remove, a.line-item__quantity-remove',
      TOGGLE      = '.header__cart-toggle',
      STORE_KEY   = 'bk:cartFocus',
      MAX_AGE     = 10000,   // ignore a stored record older than this
      RETRY_MS    = 80,
      DEADLINE_MS = 2500;

  var pending = null,        // drawer: record awaiting replay
      pendingNode = null;    // the element that was activated

  /* ---------- what did the user just press? ------------------------------- */

  function kindOf(el) {
    var $el = $(el);
    if ($el.is(REMOVE)) { return 'remove'; }
    if ($el.is(QTY_INPUT)) { return 'qty'; }
    if ($el.is(STEPPER)) {
      return $el.attr('aria-label') === 'Increase quantity' ? 'increase' : 'decrease';
    }
    return null;
  }

  function record(el) {
    var kind = kindOf(el);
    if (!kind) { return null; }
    var line = parseInt($(el).attr('data-line'), 10);
    if (!line) {
      // Fall back to position if the attribute is missing.
      var $item = $(el).closest(DRAWER_ITEM + ',' + PAGE_ITEM);
      line = $item.length ? $item.index() + 1 : 1;
    }
    return {
      surface: $(el).closest(DRAWER).length ? 'drawer' : 'page',
      line: line,
      kind: kind,
      t: Date.now()
    };
  }

  /* ---------- where should focus go? -------------------------------------- */

  function items(surface) {
    return surface === 'drawer'
      ? $(DRAWER).find(DRAWER_ITEM)
      : $(PAGE_ITEM);
  }

  function visibleFirst($set) {
    var $v = $set.filter(':visible');
    return ($v.length ? $v : $set).first()[0] || null;
  }

  function controlIn($item, kind) {
    if (!$item || !$item.length) { return null; }
    if (kind === 'remove') { return visibleFirst($item.find(REMOVE)); }
    if (kind === 'qty')    { return visibleFirst($item.find(QTY_INPUT)); }
    var want = kind === 'increase' ? 'Increase quantity' : 'Decrease quantity';
    return visibleFirst($item.find(STEPPER).filter(function () {
      return this.getAttribute('aria-label') === want;
    }));
  }

  function emptyFallback(surface) {
    if (surface === 'drawer') { return $(TOGGLE)[0] || null; }
    var el = visibleFirst($('.cart, #main, main')
              .find('a[href], button').filter(':visible'));
    if (el) { return el; }
    var $h = $('h1').filter(':visible').first();
    if ($h.length) {
      if (!$h.attr('tabindex')) { $h.attr('tabindex', '-1'); }
      return $h[0];
    }
    return $(TOGGLE)[0] || null;
  }

  function target(rec) {
    var $items = items(rec.surface);
    if (!$items.length) { return emptyFallback(rec.surface); }

    // Same position first — after a removal that IS the next item down.
    var $at = $items.eq(rec.line - 1);
    var el = controlIn($at, rec.kind);
    if (el) { return el; }

    // Position gone (removed the last line): use the new last line.
    el = controlIn($items.last(), rec.kind);
    if (el) { return el; }

    return emptyFallback(rec.surface);
  }

  function focusLost() {
    var ae = document.activeElement;
    if (!ae || ae === document.body || ae === document.documentElement) { return true; }
    if (pendingNode && !document.contains(pendingNode) && ae === document.body) { return true; }
    return false;
  }

  function place(el) {
    if (!el) { return false; }
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
    if (document.activeElement !== el) { return false; }
    if (el.scrollIntoView) {
      try { el.scrollIntoView({ block: 'center' }); } catch (e) { el.scrollIntoView(); }
    }
    return true;
  }

  /* ---------- drawer: replay after the AJAX re-render ---------------------- */

  function attemptDrawerRestore() {
    if (!pending) { return; }
    if (Date.now() - pending.t > DEADLINE_MS) { pending = pendingNode = null; return; }

    // Only act once focus has actually been discarded. Do NOT disarm just
    // because focus is still somewhere sensible — the re-render may not have
    // happened yet. (This is the Bug 105 mistake.)
    if (!focusLost()) {
      window.setTimeout(attemptDrawerRestore, RETRY_MS);
      return;
    }

    if (place(target(pending))) { pending = pendingNode = null; return; }
    window.setTimeout(attemptDrawerRestore, RETRY_MS);
  }

  /* ---------- wiring ------------------------------------------------------ */

  function boot() {
    // Capture phase, so this runs before the theme navigates or re-renders.
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest &&
               e.target.closest(REMOVE + ',' + STEPPER + ',' + QTY_INPUT);
      if (!el) { return; }
      var rec = record(el);
      if (!rec) { return; }

      if (rec.surface === 'page') {
        // /cart navigates away — the record has to outlive this document.
        try { window.sessionStorage.setItem(STORE_KEY, JSON.stringify(rec)); } catch (err) {}
        return;
      }
      pending = rec;
      pendingNode = el;
      window.setTimeout(attemptDrawerRestore, RETRY_MS);
    }, true);

    // The quantity field commits on change and takes the same path.
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !$(el).is(QTY_INPUT)) { return; }
      var rec = record(el);
      if (!rec) { return; }
      if (rec.surface === 'page') {
        try { window.sessionStorage.setItem(STORE_KEY, JSON.stringify(rec)); } catch (err) {}
        return;
      }
      pending = rec;
      pendingNode = el;
      window.setTimeout(attemptDrawerRestore, RETRY_MS);
    }, true);

    // /cart: replay whatever the previous document stored, once, if it is fresh.
    var raw = null;
    try { raw = window.sessionStorage.getItem(STORE_KEY); } catch (e) {}
    if (raw) {
      try { window.sessionStorage.removeItem(STORE_KEY); } catch (e) {}
      var rec = null;
      try { rec = JSON.parse(raw); } catch (e) {}
      if (rec && rec.surface === 'page' && (Date.now() - rec.t) < MAX_AGE) {
        var tries = 0,
            go = function () {
              if (place(target(rec))) { return; }
              if (++tries * RETRY_MS < DEADLINE_MS) { window.setTimeout(go, RETRY_MS); }
            };
        window.setTimeout(go, 120);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(jQuery);

/* ========BidetKing.com — Bug 138: cart table headers + the prices inside the cells====================================================================
 * 
 * ----------------------------------------------------------------------------
 * THE ROW IS RIGHT ABOUT THE MARKUP
 *   <table class="line-item-table table table--loose">
 *     <thead class="hidden-phone"><tr>
 *       <th>Product</th><th>Quantity</th><th>Total</th>
 *   Verified: 3 <th>, none with scope, no <caption>, no colspan, one table on
 *   the page, body rows are a clean 3-cell match. scope="col" is worth adding
 *   (WCAG technique H63) and this file adds it.
 *
 * BUT IT WILL NOT FIX WHAT THE ROW DESCRIBES
 *   The row lists VoiceOver iOS/Android and asks the tester to "navigate the
 *   cart table with a screen reader's table navigation commands". On a phone
 *   there is no table to navigate. Measured computed styles at 400px wide
 *   against the same page at 1054px:
 *
 *                       1054px               400px
 *       table           table                block
 *       thead           table-header-group   none
 *       tr.line-item    table-row            block
 *       td              table-cell           block
 *
 *   Overriding display on table elements removes the table, row and cell roles
 *   from the accessibility tree — every current browser does this. So at the
 *   phone breakpoint the cart is not exposed as a table at all, the header row
 *   is display:none on top of that, and scope="col" is inert. Repro step 2
 *   cannot be performed on the platforms the row names.
 *
 *   On top of that, two of the three cells are hidden outright on phones:
 *   td.line-item__quantity and td.line-item__line-price both measured
 *   visible:false at 400px. The quantity control and Remove link survive
 *   because the template renders a second, mobile-only copy of them inside
 *   cell 1 (see Bug 136). The per-line total does not — it exists only in the
 *   hidden cell.
 *
 *   Practical consequence: on desktop this is a table and scope helps. On
 *   mobile the fix is not table semantics at all — it is that every control
 *   and value in the stacked card has to name itself, which is what Bug 136
 *   (Remove) and the quantity-field work already do. Split the row on that
 *   line, or the mobile half will be signed off on a change that does nothing.
 *
 * SEPARATE AND MORE SERIOUS — THE PRICE PAIR IS VISUAL-ONLY
 *   Inside the Product cell:
 *
 *     <div class="line-item__price-list">
 *       <span class="line-item__price line-item__price--highlight">$389.00</span>
 *       <span class="line-item__price line-item__price--compare">$499.00</span>
 *     </div>
 *
 *   Two bare spans. A screen reader reads "$389.00 $499.00" with nothing to
 *   say which is the price being charged.
 *
 *   And the strike-through is not text-decoration. Measured on the compare
 *   span: text-decoration-line: none. The line is painted by a pseudo-element —
 *     ::before { position:absolute; height:1px; width:61.97px; top:13.09px;
 *                background:rgba(103,114,121,0.7) }
 *   so even the screen readers that do report line-through get nothing here.
 *   The "was" price is conveyed by presentation alone, with no programmatic
 *   equivalent. WCAG 1.3.1, and it fails on desktop AND mobile, in the drawer
 *   AND on /cart. The drawer has the identical pattern with different class
 *   names (.mini-cart__price-list > .price--highlight / .price--compare).
 *
 *   This file prefixes each with visually-hidden text, so the pair reads
 *   "Sale price $389.00, regular price $499.00".
 *
 * NOT FIXED HERE, ON PURPOSE
 *   On phones the per-line total is hidden from EVERYONE, sighted users
 *   included — only the cart-level Total is shown. Screen reader users are
 *   therefore not disadvantaged relative to sighted mobile users, and
 *   injecting a hidden line total would give AT users information the visual
 *   design deliberately omits. That is a design decision for the client, not a
 *   remediation. Raise it; do not script it.
 *
 * DEPENDENCIES: jQuery 3.7.1 (already site-wide)
 * DEPLOY: append to a11y.js. The scope/caption half belongs in the Liquid
 *         template long-term; the price labels do too.
 * ==========================================================================*/
// (function ($) {
//   'use strict';

//   var TABLE     = 'table.line-item-table',
//       CART_SCOPE = 'table.line-item-table, #mini-cart',
//       HIGHLIGHT = '.line-item__price--highlight, .mini-cart__price-list .price--highlight',
//       COMPARE   = '.line-item__price--compare, .mini-cart__price-list .price--compare',
//       VH        = 'visually-hidden',           // theme class, verified: 1x1 clipped
//       MARK      = 'data-a11y-price-label',
//       CAPTION   = 'Shopping cart';

//   /* ---------- column headers ---------------------------------------------- */

//   function fixHeaders(scope) {
//     $(scope).find(TABLE).addBack(TABLE).each(function () {
//       var table = this;

//       $(table).find('thead th').each(function () {
//         if (this.getAttribute('scope') !== 'col') {
//           this.setAttribute('scope', 'col');
//         }
//       });

//       // Any <th> used as a row header in the body (none today, but the
//       // template may grow one) gets scope="row".
//       $(table).find('tbody th').each(function () {
//         if (this.getAttribute('scope') !== 'row') {
//           this.setAttribute('scope', 'row');
//         }
//       });

//       // A caption names the table during table navigation. Hidden visually so
//       // nothing changes on screen.
//       if (!table.querySelector('caption')) {
//         var cap = document.createElement('caption');
//         cap.className = VH;
//         cap.textContent = CAPTION;
//         table.insertBefore(cap, table.firstChild);
//       }
//     });
//   }

//   /* ---------- the price pair ---------------------------------------------- */

//   function prefix(el, text) {
//     if (!el || el.getAttribute(MARK)) { return; }
//     var span = document.createElement('span');
//     span.className = VH;
//     span.textContent = text + ' ';
//     el.insertBefore(span, el.firstChild);
//     el.setAttribute(MARK, '1');
//   }

//   function fixPrices(scope) {
//     $(scope).find(CART_SCOPE).addBack(CART_SCOPE).each(function () {
//       // Scoped to the cart deliberately — .price--highlight / .price--compare
//       // are also used on product cards and the PDP, which are not this row.
//       $(this).find(HIGHLIGHT).each(function () { prefix(this, 'Sale price'); });
//       $(this).find(COMPARE).each(function () { prefix(this, 'Regular price'); });
//     });
//   }

//   function apply(scope) {
//     scope = scope || document;
//     fixHeaders(scope);
//     fixPrices(scope);
//   }

//   function boot() {
//     apply(document);

//     // /cart reloads on every mutation so this simply re-runs, but the drawer
//     // re-renders in place. body, because a re-render can swap the table node
//     // itself rather than mutating it. childList only — this file inserts
//     // marked elements and checks the mark, so it cannot loop on its own writes.
//     if (window.MutationObserver) {
//       var pending = null;
//       new MutationObserver(function () {
//         if (pending) { return; }
//         pending = window.setTimeout(function () {
//           pending = null;
//           apply(document);
//         }, 100);
//       }).observe(document.body, { childList: true, subtree: true });
//     }

//     $(document).on('shopify:section:load', function () { apply(document); });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', boot);
//   } else {
//     boot();
//   }
// })(jQuery);

/* ========== BidetKing.com — Bug 140: announce cart changes on /cart==================================================================
 * 
 * ----------------------------------------------------------------------------
 * CONFIRMED
 *   #cart-live-region exists on /cart and is correctly configured:
 *     <div id="cart-live-region" class="visually-hidden"
 *          aria-live="polite" aria-atomic="true"></div>
 *   textContent is "" and stays "" through a quantity change. Silent. High
 *   severity and 4.1.3 are both right.
 *
 * ROW CORRECTION — WHY IT IS SILENT, AND WHY THE FIX AS WRITTEN CANNOT WORK
 *   The row says "nothing is ever written to it" and recommends "write a
 *   message to #cart-live-region on every quantity change". On /cart that is
 *   not implementable, because there is no moment at which the message could
 *   be heard.
 *
 *   /cart performs a FULL PAGE NAVIGATION on every mutation. Verified in
 *   Bug 137 by planting a marker on window, clicking a quantity stepper, and
 *   finding the marker gone afterwards — new document. The steppers look like
 *   in-page controls (<button data-action="increase-quantity" data-line="1">)
 *   but the theme resolves them to /cart/change?quantity=N&line=N and
 *   navigates; Remove is a plain <a> to the same endpoint.
 *
 *   Two consequences:
 *     - The handler the theme DOES have never fires here. ada.js announces off
 *       a MutationObserver watching .header__cart-count, and on /cart that
 *       element never mutates — the browser navigates instead. So the live
 *       region is not merely unwritten, it is unreachable by the existing
 *       mechanism.
 *     - Writing to the live region at click time would be pointless: the
 *       document is torn down milliseconds later, before any screen reader
 *       could speak it.
 *
 *   The announcement has to be composed on the NEXT page load, from state
 *   carried across the navigation. Same shape as the Bug 137 focus fix. Please
 *   reword the row's recommendation, or a dev will implement the literal
 *   instruction, hear nothing, and conclude the live region is broken.
 *
 * WHAT THIS FILE DOES
 *   Before the navigation, records what the user activated and the product and
 *   quantity it applied to. On the next load it reads the updated cart from the
 *   DOM and writes one sentence into #cart-live-region:
 *
 *     "Alpha JX2 Bidet Toilet Seat - White / Elongated quantity updated to 2.
 *      Total $778.00 USD."
 *     "TOTO Glaston WASHLET+ S7 ... removed from cart. Total $389.00 USD."
 *     "... removed from cart. Your cart is empty."
 *
 *   It says "Total" rather than "Subtotal" because that is the label the page
 *   itself shows (.cart-recap__price-line-label reads "Total"), and the
 *   announcement should match what a sighted user sees.
 *
 * DEPLOYMENT NOTES
 *   1. Its sessionStorage key is bk:cartSay, deliberately NOT the bk:cartFocus
 *      key used by cart-focus-restore.js. Both files consume-and-delete their
 *      record on load; sharing one key would mean whichever ran first ate it
 *      and the other did nothing. Separate keys, no ordering dependency.
 *   2. Scoped to controls OUTSIDE #mini-cart. The drawer is AJAX and is already
 *      covered by cart-quantity-announcement.js and
 *      mini-cart-add-and-quantity-a11y.js; this file must not double-announce
 *      there.
 *   3. The region is given role="status" as well as aria-live="polite" — some
 *      screen readers are more reliable with the explicit role, and it costs
 *      nothing.
 *
 * DEPENDENCIES: jQuery 3.7.1 (already site-wide)
 * DEPLOY: append to a11y.js
 * ==========================================================================*/
(function ($) {
  'use strict';

  var LIVE_ID   = 'cart-live-region',
      ROW       = 'tr.line-item',
      TITLE     = 'a.line-item__title, .line-item__title',
      QTY_INPUT = 'input.quantity-selector__value',
      STEPPER   = 'button.quantity-selector__button',
      REMOVE    = 'a.line-item__quantity-remove',
      RECAP     = '.cart-recap__price-line-price',
      DRAWER    = '#mini-cart',
      KEY       = 'bk:cartSay',
      MAX_AGE   = 10000,
      SPEAK_MS  = 600;      // let the page settle before the region is filled

  function clean(s) {
    return $.trim(String(s || '').replace(/\s+/g, ' '));
  }

  function region() {
    var el = document.getElementById(LIVE_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = LIVE_ID;
      el.className = 'visually-hidden';
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      document.body.appendChild(el);
    }
    if (!el.getAttribute('role')) { el.setAttribute('role', 'status'); }
    return el;
  }

  function rows() { return $(ROW); }

  function titleOf($row) {
    return clean($row.find(TITLE).first().text());
  }

  function qtyOf($row) {
    var input = $row.find(QTY_INPUT).filter(':visible').first()[0] ||
                $row.find(QTY_INPUT).first()[0];
    return input ? clean(input.value) : '';
  }

  function totalText() {
    return clean($(RECAP).first().text());
  }

  /* ---------- capture what is about to happen ----------------------------- */

  function kindOf(el) {
    var $el = $(el);
    if ($el.is(REMOVE))    { return 'remove'; }
    if ($el.is(QTY_INPUT)) { return 'qty'; }
    if ($el.is(STEPPER)) {
      return $el.attr('aria-label') === 'Increase quantity' ? 'increase' : 'decrease';
    }
    return null;
  }

  function capture(el) {
    if ($(el).closest(DRAWER).length) { return; }   // drawer is handled elsewhere
    var kind = kindOf(el);
    if (!kind) { return; }

    var $row = $(el).closest(ROW);
    if (!$row.length) { return; }

    var line = parseInt($(el).attr('data-line'), 10) || ($row.index() + 1);

    try {
      window.sessionStorage.setItem(KEY, JSON.stringify({
        kind: kind,
        line: line,
        title: titleOf($row),
        prevQty: qtyOf($row),
        t: Date.now()
      }));
    } catch (e) {}
  }

  /* ---------- say it on the next load ------------------------------------- */

  function compose(rec) {
    var $rows = rows(),
        tail;

    if (!$rows.length) {
      tail = ' Your cart is empty.';
    } else {
      var total = totalText();
      tail = total ? ' Total ' + total + '.' : '';
    }

    var name = rec.title || 'Item';

    if (rec.kind === 'remove') {
      return name + ' removed from cart.' + tail;
    }

    // Quantity change: read back the line that changed.
    var $row = $rows.eq(rec.line - 1);

    // If the row is gone, or a different product now sits at that index, the
    // line was removed (quantity driven to 0).
    if (!$row.length || (rec.title && titleOf($row) !== rec.title)) {
      return name + ' removed from cart.' + tail;
    }

    var qty = qtyOf($row);
    if (!qty) { return ''; }
    if (rec.prevQty && qty === rec.prevQty) { return ''; }   // nothing changed

    return name + ' quantity updated to ' + qty + '.' + tail;
  }

  function speak(msg) {
    if (!msg) { return; }
    var el = region();
    el.textContent = '';
    window.setTimeout(function () { el.textContent = msg; }, SPEAK_MS);
  }

  function replay() {
    var raw = null;
    try { raw = window.sessionStorage.getItem(KEY); } catch (e) {}
    if (!raw) { return; }
    try { window.sessionStorage.removeItem(KEY); } catch (e) {}

    var rec = null;
    try { rec = JSON.parse(raw); } catch (e) {}
    if (!rec || (Date.now() - rec.t) >= MAX_AGE) { return; }

    speak(compose(rec));
  }

  /* ---------- wiring ------------------------------------------------------ */

  function boot() {
    region();   // exist before anything is written into it

    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest &&
               e.target.closest(REMOVE + ',' + STEPPER + ',' + QTY_INPUT);
      if (el) { capture(el); }
    }, true);

    document.addEventListener('change', function (e) {
      if (e.target && $(e.target).is(QTY_INPUT)) { capture(e.target); }
    }, true);

    replay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(jQuery);


/* =========== Wave BidetKing.com — collection filters: duplicate id on the "30 Day Trial" filter=================================================================
 * 
 * ----------------------------------------------------------------------------
 * WHAT WAVE REPORTED
 *   "A form control has more than one label associated with it." — 30 Day Trial.
 *
 * WHAT IS ACTUALLY WRONG
 *   The collection page renders the filter set TWICE, once in
 *   #desktop-filters-form and once in #mobile-collection-filters-form, and both
 *   are in the DOM at the same time. To keep the two copies apart the theme
 *   prefixes every mobile id with "mobile-":
 *
 *       desktop   filter.v.option.size-Elongated
 *       mobile    mobile-filter.v.option.size-Elongated
 *
 *   28 of the 29 filters follow that convention. Exactly one does not:
 *
 *       desktop   filter.p.m.custom.30_day_trial
 *       mobile    filter.p.m.custom.30_day_trial     <-- prefix missing
 *
 *   Verified on the live page: idsSharedBetweenForms returns exactly one entry,
 *   and it is this filter.
 *
 * WHY THAT PRODUCES THE WAVE ERROR — AND A REAL BUG
 *   label[for] resolves to the FIRST element in the document with that id. Both
 *   labels therefore point at the desktop input:
 *
 *       desktop label -> desktop input   (correct)
 *       mobile  label -> desktop input   (wrong)
 *
 *   Confirmed by reading label.control on both. So:
 *
 *     1. The desktop checkbox has two labels. That is what WAVE flagged.
 *     2. The mobile checkbox has NO label at all — nothing points at it, and it
 *        carries no aria-label. A screen reader on a phone reaches an unnamed
 *        checkbox. WCAG 4.1.2 Name, Role, Value (A) and 1.3.1 (A).
 *     3. Not an accessibility bug at all, but worth more to the client than
 *        either of the above: tapping the "30 Day Trial" text on a phone
 *        toggles the HIDDEN DESKTOP checkbox, not the one the user can see.
 *        The visible control does not respond to its own label.
 *
 *   Note for the report: WCAG 2.2 REMOVED 4.1.1 Parsing, so "duplicate id" is
 *   no longer a failure in its own right. Cite 4.1.2 and 1.3.1 — the broken
 *   label association — not 4.1.1. A dev who looks up 4.1.1 will find it
 *   obsolete and dismiss the row.
 *
 * THE REAL FIX IS ONE TOKEN OF LIQUID
 *   The mobile filter snippet builds ids as "mobile-{{ filter.param_name }}"
 *   for every branch except the boolean metafield branch this filter uses.
 *   Adding the prefix there matches the other 28 and closes all three issues at
 *   source. Please raise that; this file is the interim.
 *
 * WHAT THIS FILE DOES
 *   Inside #mobile-collection-filters-form only, any control whose id is
 *   missing the "mobile-" prefix is renamed, and the label that belongs to it
 *   IN THAT SAME FORM is repointed. Generic, so if the same Liquid branch
 *   produces another boolean filter later it is handled too.
 *
 *   Nothing about submission changes: filtering is driven by the `name`
 *   attribute, which is untouched.
 *
 * DEPENDENCIES: none
 * DEPLOY: append to a11y.js
 * ==========================================================================*/
(function () {
  'use strict';

  var MOBILE_FORM  = '#mobile-collection-filters-form',
      DESKTOP_FORM = '#desktop-filters-form',
      PREFIX       = 'mobile-';

  function fixForm(mobileForm) {
    if (!mobileForm) { return 0; }
    var controls = mobileForm.querySelectorAll('input[id], select[id], textarea[id]'),
        fixed = 0, i, c, oldId, newId, labels, j;

    for (i = 0; i < controls.length; i++) {
      c = controls[i];
      oldId = c.id;
      if (!oldId || oldId.indexOf(PREFIX) === 0) { continue; }

      // Only act on a genuine collision — another element outside this form
      // already owns the id. A unique id is nobody's problem.
      var owners = document.querySelectorAll('[id="' + (window.CSS && CSS.escape ? CSS.escape(oldId) : oldId) + '"]');
      if (owners.length < 2) { continue; }

      newId = PREFIX + oldId;
      if (document.getElementById(newId)) { continue; }   // never create a new clash

      // Repoint the label that lives in THIS form before renaming, so we do not
      // rely on label[for] resolution (which is exactly what is broken).
      labels = mobileForm.querySelectorAll('label[for]');
      for (j = 0; j < labels.length; j++) {
        if (labels[j].getAttribute('for') === oldId) {
          labels[j].setAttribute('for', newId);
        }
      }

      c.id = newId;
      c.setAttribute('data-a11y-original-id', oldId);   // for audit / rollback
      fixed++;
    }
    return fixed;
  }

  function boot() {
    if (!document.querySelector(DESKTOP_FORM)) { return; }  // not a filtered collection
    fixForm(document.querySelector(MOBILE_FORM));

    // The filter panels are re-rendered when a filter is applied, which
    // restores the duplicate. Re-run after each render.
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) { return; }
        pending = window.setTimeout(function () {
          pending = null;
          fixForm(document.querySelector(MOBILE_FORM));
        }, 100);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* =============Descriptive names for the repeated "Read More" links===============================================================
 * BidetKing.com — /pages/bidet-video-tutorials
 * 
 * ----------------------------------------------------------------------------
 * WHAT IS WRONG
 *   The page carries 10 links whose entire accessible name is "Read More".
 *   No aria-label, no title, nothing else. Verified on the live page: 10
 *   matches, all with identical text, all with aria-label null.
 *
 *   Pulled up in a links list — which is how most screen reader users navigate
 *   a page like this — the user gets ten identical entries and no way to tell
 *   which article each one opens.
 *
 *   WCAG 2.4.4 Link Purpose (In Context), Level A. Arguably passable in the
 *   strictest reading, since each link sits in a container with its heading,
 *   but the links-list case is exactly the scenario 2.4.4 exists for and the
 *   fix is trivial. It also clears 2.4.9 Link Purpose (Link Only, AAA) for free.
 *
 * THE NAMING SOURCE
 *   Every one of the 10 links is preceded by its own <h3>, and all ten
 *   headings are distinct. Verified:
 *
 *     allHaveHeading  true
 *     allDistinct     true
 *
 *     "How To Remove, and Replace a Bidet's Lid and Seat"
 *     "How To Troubleshoot a Bidet Seat with Intermittent Water or Seat Heating"
 *     "How to Troubleshoot a Leaking Bidet Seat"
 *     "How To Troubleshoot a Bidet Seat That Won't Spray"
 *     "What is a bidet seat?"
 *     "How do you install a bidet seat?"
 *     "How to Replace a Bidet Seat Deodorizer"   ... and so on
 *
 *   So the heading is the right thing to name the link with, not the href slug.
 *
 * WHY THE LABEL KEEPS THE WORDS "READ MORE"
 *   The obvious version — aria-label="How to Troubleshoot a Leaking Bidet Seat"
 *   — is a trap. aria-label REPLACES the name, so the accessible name would no
 *   longer contain the visible text "Read More". That is a WCAG 2.5.3 Label in
 *   Name (A) failure, and it breaks speech input: a Dragon or Voice Control
 *   user looking at the screen says "click Read More" and nothing happens.
 *
 *   So the label is composed as:
 *
 *     aria-label="Read more: <heading>"
 *
 *   Visible text first, so speech input still matches, then the specifics.
 *   Announced as: "Read more: How to Troubleshoot a Leaking Bidet Seat, link".
 *
 * ALTERNATIVE WORTH CONSIDERING FOR THE THEME FIX
 *   aria-labelledby="<linkId> <headingId>" composes the same name out of real
 *   page text instead of a copied string, so it can never drift when the
 *   merchant edits a heading in the Shopify editor. It reads slightly more
 *   run-on ("Read More How to Troubleshoot..." with no colon), which is why
 *   this file uses aria-label as requested. If this ever moves into the page
 *   content rather than a script, prefer aria-labelledby — one less copy of the
 *   text to go stale.
 *
 * SAFETY
 *   Only applied where a preceding heading is actually found, and never
 *   overwrites an aria-label that already exists. Nothing visible changes.
 *
 * DEPENDENCIES: none
 * DEPLOY: append to a11y.js
 * ==========================================================================*/
// (function () {
//   'use strict';

//   // Ambiguous link text this should name. Matched on the whole trimmed string.
//   var VAGUE = /^(read more|learn more|view more|see more|continue reading|more)$/i,
//       PREFIX_SEP = ': ',
//       MARK = 'data-a11y-named-link',
//       MAX_WALK = 400;

//   function textOf(el) {
//     return (el.textContent || '').replace(/\s+/g, ' ').trim();
//   }

//   /* Walk backwards through the document from the link and return the nearest
//      heading that precedes it. Steps to the previous sibling where there is one,
//      otherwise up to the parent and continues — so it crosses out of the
//      paragraph and table cell the link sits in, which is where these headings
//      live. Takes the LAST heading inside a previous subtree, i.e. the closest
//      one above the link, not the first. */
//   function precedingHeading(el) {
//     var n = el, guard = 0, hs;
//     while (n && guard++ < MAX_WALK) {
//       if (n.previousElementSibling) {
//         n = n.previousElementSibling;
//       } else {
//         n = n.parentElement;
//         if (!n || n === document.body) { return null; }
//         continue;
//       }
//       if (/^H[1-6]$/.test(n.tagName)) { return n; }
//       hs = n.querySelectorAll ? n.querySelectorAll('h1,h2,h3,h4,h5,h6') : null;
//       if (hs && hs.length) { return hs[hs.length - 1]; }
//     }
//     return null;
//   }

//   function nameLink(a) {
//     if (a.getAttribute(MARK)) { return false; }
//     if (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) { return false; }

//     var visible = textOf(a);
//     if (!VAGUE.test(visible)) { return false; }

//     var heading = precedingHeading(a);
//     if (!heading) { return false; }             // nothing to say — leave it alone

//     var topic = textOf(heading);
//     if (!topic) { return false; }

//     // Visible text first so speech input still matches it (2.5.3).
//     a.setAttribute('aria-label', visible + PREFIX_SEP + topic);
//     a.setAttribute(MARK, '1');
//     return true;
//   }

//   function run() {
//     var links = document.querySelectorAll('a[href]'), i, n = 0;
//     for (i = 0; i < links.length; i++) { if (nameLink(links[i])) { n++; } }
//     return n;
//   }

//   function boot() {
//     run();

//     if (window.MutationObserver) {
//       var pending = null;
//       new MutationObserver(function () {
//         if (pending) { return; }
//         pending = window.setTimeout(function () { pending = null; run(); }, 150);
//       }).observe(document.body, { childList: true, subtree: true });
//     }

//     document.addEventListener('shopify:section:load', run);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', boot);
//   } else {
//     boot();
//   }
// })();


/* ============================================================================
 * BidetKing.com — descriptive names for vague links, derived from the URL
 * v2 — replaces read-more-link-names.js
 * ----------------------------------------------------------------------------
 * WHY v1 MISSED MOST LINKS
 *   Two separate faults, both confirmed on the live site.
 *
 *   1. THE MATCHER WAS WHOLE-STRING. v1 tested
 *        /^(read more|learn more|view more|see more|continue reading|more)$/i
 *      against the entire trimmed text. That matches "Read More" and nothing
 *      else real. Every one of these, found on the home page, was rejected:
 *        "View All Bidet Seats"   "Shop Now"   "View all"
 *        "Click here for additional details."   "Summer Sale | Shop Now"
 *        "click here if you want to live"
 *      This version matches vague text ANYWHERE in the string, so extra words
 *      no longer defeat it.
 *
 *   2. IT REQUIRED A PRECEDING HEADING. Even when the text matched, v1 bailed
 *      if precedingHeading() found nothing — which is the normal case in promo
 *      blocks and product cards, where the heading lives INSIDE the link's own
 *      container rather than before it. So it silently did nothing.
 *      Deriving from the href removes that dependency entirely: a link always
 *      has one.
 *
 * WHAT IS ALREADY HANDLED — DO NOT DOUBLE UP
 *   ada.js already labels several of these with better, hand-written wording:
 *     $('a:contains("Shop Now")')      -> "Shop now from the X collection"
 *     a.section__action-link "VIEW ALL"-> "View all X"
 *     $('a:has(.promo-block__cta)')    -> "Learn more about X"
 *   Measured on the home page at runtime: 11 vague visible links, 8 already
 *   labelled by ada.js, 3 left over. This file never touches a link that
 *   already has aria-label or aria-labelledby, so those stay as they are.
 *
 * HOW THE NAME IS BUILT
 *   Last meaningful path segment of the href, minus query and hash, minus any
 *   file extension, with - and _ turned into spaces, decoded, sentence-cased,
 *   and with known acronyms restored:
 *
 *     /how-to-replace-a-bidets-lid-and-seat
 *        -> "Read More: How to replace a bidets lid and seat"
 *     /how-to-troubleshoot-a-leaking-bidet-seat
 *        -> "Read More: How to troubleshoot a leaking bidet seat"
 *
 *   The visible text stays at the FRONT of the label. aria-label replaces the
 *   accessible name, so dropping "Read More" would break WCAG 2.5.3 Label in
 *   Name (A) and stop speech-input users activating the link by what they can
 *   see. Prefixing keeps both.
 *
 * THE HONEST TRADE-OFF WITH URL-DERIVED TEXT
 *   A slug is lossy. It has no apostrophes and no real capitalisation, so:
 *     "How To Remove, and Replace a Bidet's Lid and Seat"   (the heading)
 *     "How to remove and replace a bidets lid and seat"     (from the slug)
 *   "bidets" instead of "bidet's", and product codes flatten unless they are
 *   in ACRONYMS below. The heading version reads better; the URL version works
 *   in far more places and needs no DOM relationship. That is the deal being
 *   made here, and it is the right one for coverage — but if a specific link
 *   deserves better wording, hand-write an aria-label on it and this file will
 *   leave it alone.
 *
 *   Extend ACRONYMS as product lines appear. It is a plain map, nothing clever.
 *
 * THE REDUNDANCY GUARD — WHY SOME LINKS ARE DELIBERATELY SKIPPED
 *   "View All Bidet Seats" pointing at /collections/bidet-seats would become
 *   "View All Bidet Seats: Bidet seats". Pointless noise. If the visible text
 *   already contains the words the slug would add, the link is already doing
 *   its job and is left untouched. Verified: that rule skips all three of the
 *   home page leftovers, correctly.
 *
 * DEPLOY ALONGSIDE read-more-link-names.js — DO NOT REPLACE IT
 *   v1 is already live on /pages/bidet-video-tutorials and is doing a BETTER
 *   job than this file can there. Measured on the deployed preview:
 *
 *     v1 (from the heading)  "Read More: How To Remove, and Replace a
 *                             Bidet's Lid and Seat"
 *     v2 (from the slug)     "Read More: How to remove and replace a bidets
 *                             lid and seat"
 *
 *   The heading keeps the apostrophe and the real capitalisation; a slug
 *   cannot. So v1 stays where it works, and this file picks up everything v1
 *   cannot reach. The two compose safely in either order, because this file
 *   never touches a link that already has aria-label or aria-labelledby.
 *
 * DEPENDENCIES: none
 * DEPLOY: append to a11y.js, keeping read-more-link-names.js in place.
 * ==========================================================================*/
(function () {
  'use strict';

  // Vague wording, matched ANYWHERE in the link text (not whole-string).
  var VAGUE = [
    /\bread\s+more\b/i,
    /\blearn\s+more\b/i,
    /\bview\s+more\b/i,
    /\bsee\s+more\b/i,
    /\bfind\s+out\s+more\b/i,
    /\bdiscover\s+more\b/i,
    /\bcontinue\s+reading\b/i,
    /\bclick\s+here\b/i,
    /\bmore\s+details\b/i,
    /\bview\s+all\b/i,
    /\bshop\s+now\b/i,
    /^\s*(more|details|here|this|go)\s*$/i
  ];

  // Tokens that should not be sentence-cased into lower case.
  var ACRONYMS = {
    jx: 'JX', jx2: 'JX2', ux: 'UX', uxt: 'UXT', uxa: 'UXA', gx: 'GX', gxr: 'GXR',
    ix: 'iX', bb: 'BB', dls: 'DLS', toto: 'TOTO', gpf: 'GPF', ada: 'ADA',
    led: 'LED', usa: 'USA', faq: 'FAQ', diy: 'DIY', hsa: 'HSA', fsa: 'FSA'
  };

  var SEP  = ': ',
      MARK = 'data-a11y-url-label',
      MAX_LEN = 46;          // ignore link text long enough to be descriptive already

  function textOf(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function isVague(t) {
    for (var i = 0; i < VAGUE.length; i++) { if (VAGUE[i].test(t)) { return true; } }
    return false;
  }

  function normalise(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  /* Words that carry no information about a destination. Used to decide
     whether a link's own text is ALREADY descriptive. */
  var FILLER = /^(read|learn|view|see|find|out|discover|continue|reading|click|shop|now|here|this|go|more|all|details|detail|info|information|about|for|additional|the|a|an|and|our|to|of|item|items|page|link)$/i;

  /* True when the link text is nothing BUT vague wording and filler — i.e. it
     genuinely tells the user nothing. "Read More" qualifies. "View All Sale
     Items" does not: strip the vague part and "Sale" survives, which is the
     description. Labelling that one would only add noise, so it is left alone.
     This is deliberately conservative — better to skip a borderline link than
     to bolt a redundant slug onto one that already reads fine. */
  function saysNothing(text) {
    var words = text.replace(/[^A-Za-z0-9\s]/g, ' ').split(/\s+/).filter(Boolean);
    for (var i = 0; i < words.length; i++) {
      if (!FILLER.test(words[i])) { return false; }
    }
    return words.length > 0;
  }

  /* href -> readable phrase, or '' when the URL carries nothing useful. */
  function phraseFromHref(href) {
    if (!href) { return ''; }

    var raw = href.split('#')[0].split('?')[0];
    if (!raw || raw === '/' || raw === '#') { return ''; }

    // strip protocol + host, keep the path
    raw = raw.replace(/^[a-z]+:\/\/[^/]+/i, '');
    if (/^(mailto|tel):/i.test(href)) { return ''; }

    var parts = raw.split('/').filter(Boolean);
    if (!parts.length) { return ''; }

    var slug = parts[parts.length - 1];

    // Trailing numeric segments (dates, ids) tell the user nothing. Step back
    // past ALL of them, not just one — /blogs/news/2024/12345 should land on
    // "news", not on "2024".
    var idx = parts.length - 1;
    while (idx > 0 && /^[0-9]+$/.test(parts[idx])) { idx--; }
    slug = parts[idx];

    try { slug = decodeURIComponent(slug); } catch (e) { /* keep raw */ }

    slug = slug.replace(/\.(html?|php|aspx?)$/i, '')
               .replace(/[-_]+/g, ' ')
               .replace(/\s+/g, ' ')
               .trim();

    if (!slug || slug.length < 3) { return ''; }

    var words = slug.split(' ').map(function (w, i) {
      var key = w.toLowerCase();
      if (ACRONYMS[key]) { return ACRONYMS[key]; }
      if (i === 0) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }
      return w.toLowerCase();
    });

    return words.join(' ');
  }

  function nameLink(a) {
    if (a.getAttribute(MARK)) { return false; }
    if (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby')) { return false; }

    var visible = textOf(a);
    if (!visible || visible.length > MAX_LEN) { return false; }
    if (!isVague(visible)) { return false; }

    var phrase = phraseFromHref(a.getAttribute('href'));
    if (!phrase) { return false; }

    // Already says what the slug would say — adding it is noise.
    if (normalise(visible).indexOf(normalise(phrase)) > -1) { return false; }

    // Link text already carries its own description — leave it alone.
    if (!saysNothing(visible)) { return false; }

    // Trim trailing punctuation off the visible text, or a link reading
    // "Click here for additional details." becomes "...details.: Quickship".
    var lead = visible.replace(/[\s.:;,\u2026|\u00bb\u2192\u203a>-]+$/, '');
    if (!lead) { lead = visible; }

    a.setAttribute('aria-label', lead + SEP + phrase);
    a.setAttribute(MARK, '1');
    return true;
  }

  function run() {
    var links = document.querySelectorAll('a[href]'), i, n = 0;
    for (i = 0; i < links.length; i++) { if (nameLink(links[i])) { n++; } }
    return n;
  }

  function boot() {
    run();
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (pending) { return; }
        pending = window.setTimeout(function () { pending = null; run(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Header search: category select — Enter opens the dropdown instead of submitting the form (WCAG 2.1.1) */
jQuery(function ($) {
  $(document).on('keydown', '#search-product-type', function (e) {
    if (e.key !== 'Enter' || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;

    e.preventDefault(); // blocks implicit submission of #header-search-bar to /search

    if (typeof this.showPicker === 'function') {
      try { this.showPicker(); } catch (err) { /* no user activation / unsupported: fail quietly */ }
    }
  });
});


/*! form-validation-a11y
 * form-validation-a11y.js — BidetKing (Warehouse v4 + tmenu)
 * Required-field indicators, visible labels and accessible inline error messages
 * for every Shopify contact/newsletter form (form[action^="/contact"]):
 *   - Announcement-bar "Join the VIP Bidet Club" newsletter
 *   - Homepage newsletter section
 *   - Contact page form (/pages/contact-us)
 *   - tmenu "Support" mega-menu contact form (injected by the app after load)
 * WCAG 2.2: 1.3.1, 1.3.5, 1.4.3, 1.4.11, 3.3.1, 3.3.2, 3.3.3, 4.1.2, 4.1.3
 * Requires jQuery (3.7.1 is loaded site-wide).
 */
(function ($) {
  'use strict';

  var FORM_SELECTOR = 'form[action^="/contact"]';
  var ERROR_COLOR = '#B3261E'; // 6.54:1 on #fff, 5.85:1 on the theme's error tint (#feefef)

  // Per-field copy, keyed by the Shopify field name.
  var FIELDS = {
    'contact[name]':  { label: 'Name',    autocomplete: 'name',  required: true,
                        empty: 'Please enter your name.' },
    'contact[email]': { label: 'Email',   autocomplete: 'email', required: true,
                        empty: 'Please enter your email address.',
                        invalid: 'Please enter a valid email address, for example name@example.com.' },
    'contact[body]':  { label: 'Message', required: true,
                        empty: 'Please enter your message.' },
    'contact[phone]': { label: 'Phone',   autocomplete: 'tel' }
  };

  // Stricter than type=email: Shopify rejects "a@b", so require a dot-TLD.
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var uid = 0;

  /* ---------- styles ---------- */
  function injectStyles() {
    if (document.getElementById('a11y-form-validation-css')) return;
    var css =
      '.a11y-req{color:' + ERROR_COLOR + ';margin-left:2px;font-weight:600}' +
      '.a11y-req-note{font-size:13px;line-height:1.4;color:#515151;margin:0 0 10px}' +
      '.a11y-field-error{display:flex;align-items:flex-start;gap:6px;margin:6px 0 0;' +
        'font-size:14px;line-height:1.4;font-weight:500;color:' + ERROR_COLOR + ';text-align:left}' +
      '.a11y-field-error[hidden]{display:none!important}' +
      '.a11y-field-error svg{flex:0 0 16px;width:16px;height:16px;margin-top:2px}' +
      // Theme uses #f71b1b (4.1:1 — fails 1.4.3) and only styles invalid fields while empty.
      'form .form__field[aria-invalid="true"],form [aria-invalid="true"]{border-color:' + ERROR_COLOR + '!important;' +
        'box-shadow:inset 0 0 0 1px ' + ERROR_COLOR + '}' +
      'form .form__field[aria-invalid="true"]:not(.is-filled){color:' + ERROR_COLOR + '}' +
      'form .form__field[aria-invalid="true"] + .form__floating-label{color:' + ERROR_COLOR + '}' +
      // tmenu visually hides every label in its contact form — show ours.
      '.tmenu_contact_item label.a11y-field-label{position:static!important;width:auto!important;height:auto!important;' +
        'margin:0 0 4px!important;padding:0!important;overflow:visible!important;clip:auto!important;' +
        'white-space:normal!important;display:block;font-size:14px;font-weight:600;color:#495057}' +
      'form .alert[tabindex="-1"]:focus{outline:2px solid #1A5FB4;outline-offset:2px}' +
      // Newsletter row is input + button in a flex row; keep the button beside the input, not the error.
      'form[data-a11y-validate] .form__input-row{align-items:flex-start}';
    $('<style id="a11y-form-validation-css">').text(css).appendTo('head');
  }

  /* ---------- shared live region (house pattern) ---------- */
  function statusRegion() {
    var $s = $('#a11y-form-status');
    if (!$s.length) {
      $s = $('<div id="a11y-form-status" class="visually-hidden" role="status" aria-live="polite" aria-atomic="true"></div>')
        .appendTo('body');
    }
    return $s;
  }
  function announce(msg) {
    var $s = statusRegion().text('');
    setTimeout(function () { $s.text(msg); }, 100);
  }

  /* ---------- helpers ---------- */
  function cfgFor(field) { return FIELDS[field.name] || {}; }

  function wrapperFor(field) {
    var $w = $(field).closest('.form__input-wrapper, .tmenu_contact_item');
    return $w.length ? $w : $(field).parent();
  }

  function addToken(el, attr, token) {
    var list = (el.getAttribute(attr) || '').split(/\s+/).filter(Boolean);
    if (list.indexOf(token) === -1) list.push(token);
    el.setAttribute(attr, list.join(' '));
  }
  function removeToken(el, attr, token) {
    var list = (el.getAttribute(attr) || '').split(/\s+/).filter(function (t) { return t && t !== token; });
    if (list.length) el.setAttribute(attr, list.join(' ')); else el.removeAttribute(attr);
  }

  function labelText(field) {
    var lbl = field.labels && field.labels[0];
    if (lbl) return $.trim($(lbl).clone().find('.a11y-req').remove().end().text());
    return cfgFor(field).label || field.getAttribute('aria-label') || field.name;
  }

  /* ---------- setup ---------- */
  function initField(field, form) {
    var cfg = cfgFor(field);
    if (!field.id) field.id = 'a11y-field-' + (++uid);

    if (cfg.required) field.required = true;
    if (cfg.autocomplete) field.setAttribute('autocomplete', cfg.autocomplete); // 1.3.5

    // 1. Visible label — create one when the field only has a placeholder/aria-label (tmenu form).
    var lbl = field.labels && field.labels[0];
    if (!lbl) {
      lbl = document.createElement('label');
      lbl.className = 'a11y-field-label';
      lbl.htmlFor = field.id;
      lbl.textContent = cfg.label || field.getAttribute('aria-label') || field.placeholder || field.name;
      field.parentNode.insertBefore(lbl, field);
      field.removeAttribute('placeholder'); // the visible label replaces it
    }
    // The label is now the accessible name; drop the competing aria-label.
    field.removeAttribute('aria-label');

    // 2. Asterisk — visual only; "required" is exposed by the required attribute.
    if (field.required && !$(lbl).find('.a11y-req').length) {
      $(lbl).append('<span class="a11y-req" aria-hidden="true">*</span>');
    }

    // 3. Error container — appended to the END of the wrapper so the theme's
    //    "input + .form__floating-label" sibling selector keeps working.
    var errId = field.id.replace(/[^\w-]/g, '_') + '-error';
    if (!document.getElementById(errId)) {
      wrapperFor(field).append(
        '<p class="a11y-field-error" id="' + errId + '" hidden>' +
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="7.25" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
          '<path d="M8 4.2v4.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="8" cy="11.4" r="1" fill="currentColor"/></svg>' +
          '<span><span class="visually-hidden">Error: </span><span class="a11y-field-error__text"></span></span>' +
        '</p>'
      );
    }
    $(field).data('a11yErrId', errId);
  }

  function initForm(form) {
    if (form.getAttribute('data-a11y-validate')) return;
    // After a successful post Shopify re-renders the form with only the message and no fields.
    handleServerMessages(form);
    var fields = $(form).find('input, textarea, select').filter(function () {
      return this.type !== 'hidden' && this.type !== 'submit' && this.type !== 'button' &&
             (FIELDS[this.name] || this.required);
    }).get();
    if (!fields.length) return;

    form.setAttribute('data-a11y-validate', '1');
    form.noValidate = true; // our messages replace the browser tooltips (not reliably announced, not persistent)

    fields.forEach(function (f) { initField(f, form); });

    // Explain the asterisk (3.3.2) once per form, above the fields.
    if (fields.some(function (f) { return f.required; }) && !$(form).find('.a11y-req-note').length) {
      var $note = $('<p class="a11y-req-note">Fields marked with an asterisk (<span class="a11y-req">*</span>) are required.</p>');
      var $first = $(form).find('.form__input-row, .form__input-wrapper, .tmenu_contact_item').first();
      if ($first.length) $note.insertBefore($first); else $note.prependTo(form);
    }
  }

  /* ---------- validation ---------- */
  function messageFor(field) {
    var cfg = cfgFor(field);
    var v = $.trim(field.value);
    if (field.required && !v) return cfg.empty || ('Please enter your ' + labelText(field).replace(/^your\s+/i, '').toLowerCase() + '.');
    if (field.type === 'email' && v && !EMAIL_RE.test(v)) return cfg.invalid || 'Please enter a valid email address.';
    return '';
  }

  function showError(field, msg) {
    var errId = $(field).data('a11yErrId');
    var $err = $('#' + errId);
    $err.find('.a11y-field-error__text').text(msg);
    $err.prop('hidden', false);
    field.setAttribute('aria-invalid', 'true');
    addToken(field, 'aria-describedby', errId);
    wrapperFor(field).addClass('a11y-has-error');
  }

  function clearError(field) {
    var errId = $(field).data('a11yErrId');
    $('#' + errId).prop('hidden', true).find('.a11y-field-error__text').text('');
    // Remove, don't set "false": the theme styles ANY [aria-invalid] as an error.
    field.removeAttribute('aria-invalid');
    removeToken(field, 'aria-describedby', errId);
    wrapperFor(field).removeClass('a11y-has-error');
  }

  function validateField(field) {
    var msg = messageFor(field);
    if (msg) showError(field, msg); else clearError(field);
    return !msg;
  }

  function fieldsOf(form) {
    return $(form).find('input, textarea, select').filter(function () {
      return $(this).data('a11yErrId');
    }).get();
  }

  // Capture phase on document: runs before theme/app submit handlers (e.g. AJAX newsletter).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches(FORM_SELECTOR)) return;
    if (!form.getAttribute('data-a11y-validate')) initForm(form);

    var invalid = fieldsOf(form).filter(function (f) { return !validateField(f); });
    if (!invalid.length) return;

    e.preventDefault();
    e.stopPropagation();
    form.setAttribute('data-a11y-submitted', '1');

    var first = invalid[0];
    var summary = invalid.length === 1
      ? messageFor(first)
      : invalid.length + ' fields need attention. ' + invalid.map(function (f) { return labelText(f) + ': ' + messageFor(f); }).join(' ');

    if (document.activeElement === first) {
      announce(summary); // focus won't move, so the description would not be re-read
    } else {
      first.focus();     // announced: label, invalid, required, "Error: …"
      if (invalid.length > 1) announce(invalid.length + ' fields need attention.');
    }
  }, true);

  // Live correction: clear as soon as the value becomes valid; re-check on leave once errored/submitted.
  $(document).on('input change', FORM_SELECTOR + ' [aria-invalid="true"]', function () {
    if (!messageFor(this)) clearError(this);
  });
  $(document).on('focusout', FORM_SELECTOR + ' input, ' + FORM_SELECTOR + ' textarea', function () {
    if (!$(this).data('a11yErrId')) return;
    if (this.getAttribute('aria-invalid') === 'true' || this.form.getAttribute('data-a11y-submitted')) {
      validateField(this);
    }
  });

  /* ---------- Shopify server-side results (page reloads with #formId) ---------- */
  function handleServerMessages(form) {
    var $err = $(form).find('.alert--error').first();
    var $ok  = $(form).find('.alert--success').first();
    var $msg = $err.length ? $err : $ok;
    if (!$msg.length || $msg.attr('data-a11y-handled')) return;
    $msg.attr('data-a11y-handled', '1');

    if (!$msg.attr('id')) $msg.attr('id', 'a11y-form-alert-' + (++uid));
    $msg.attr('tabindex', '-1');

    if ($err.length) {
      var email = $(form).find('input[type="email"]')[0];
      if (email) {
        email.setAttribute('aria-invalid', 'true');
        addToken(email, 'aria-describedby', $err.attr('id'));
      }
    }
    // Only the form that was just submitted (Shopify appends #formId to the action).
    if (location.hash && location.hash.slice(1) === form.id && $msg.is(':visible')) {
      setTimeout(function () { $msg[0].focus(); }, 300);
    }
  }

  /* ---------- boot ---------- */
  function initAll() { $(FORM_SELECTOR).each(function () { initForm(this); }); }

  $(function () {
    injectStyles();
    statusRegion();
    initAll();

    // tmenu injects its contact form after load — pick it up when it arrives.
    if (window.MutationObserver && document.body) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if ($(FORM_SELECTOR + ':not([data-a11y-validate])').length) initAll();
        }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})(jQuery);

/*! collection-filters-a11y
 * collection-filters-a11y.js — BidetKing collection filters (Warehouse v4)
 * REPLACES the Bug 105 block in ada-pro-max.js (the one starting
 *   var CONTROL = 'input[name^="filter"], select[name^="filter"]'; var ARM_MS = 4000; ...)
 * Paste it in that block's place — or keep it as its own asset. Not both (a guard stops a
 * second copy from running, but there is no reason to ship it twice).
 *
 * It also takes over the Bug 106 count announcement, the Bug 107 chip block and the Bug 109
 * swatch names: once every ready handler has run, it switches the old handlers off and
 * removes the old live region, so it works no matter where those blocks sit in the file.
 *
 * What it fixes
 *  1. Focus never jumps. Changing a filter keeps focus on that control after the re-render
 *     (or on the next filter field if the user already tabbed on). Removing a chip keeps focus
 *     in the same spot in the chip list (the chip that moves into its place; the previous chip
 *     if it was the last; the "Filters" title if none are left). "Clear all" -> "Filters" title.
 *                                                                                  WCAG 2.4.3
 *  2. Every change is confirmed in ONE polite message, spoken after focus settles, e.g.
 *     "Round filter removed. Showing 1 - 20 of 20 products."                        WCAG 4.1.3
 *  3. Enter toggles every filter checkbox, colour swatch and switch (Space still works). 2.1.1
 *  4. Chips are role="button" named "Remove filter: <name>".                            4.1.2
 *  5. Each filter group is a named group ("Size", "Brand"…).                            1.3.1
 *  6. Price inputs are "Minimum / Maximum price"; sliders announce "$120".              1.3.1
 *  7. Colour swatches get a real text name and a visible keyboard focus ring.    4.1.2, 2.4.7
 */
(function ($) {
  'use strict';

  if (window.__bkFiltersA11y) { return; }
  window.__bkFiltersA11y = true;

  /* ---------- selectors ---------- */
  var FORMS        = '#desktop-filters-form, #mobile-collection-filters-form';
  var FIELDS       = '#desktop-filters-form input:not([type="hidden"]), #desktop-filters-form select, ' +
                     '#mobile-collection-filters-form input:not([type="hidden"]), #mobile-collection-filters-form select';
  var CHECKBOX     = 'input[type="checkbox"]';
  var DESKTOP_CHIP = '.collection__active-filters .collection__active-filter-item'; // <label for="filter.…">
  var MOBILE_CHIP  = '.collection__mobile-active-filter-item';
  var ANY_CHIP     = DESKTOP_CHIP + ', ' + MOBILE_CHIP;
  var CHIP_MARK    = 'data-bk-chip';
  var CROSS        = '.collection__active-filter-cross';
  var CLEAR_ALL    = '[data-action="clear-filters"]';
  var TITLE        = '.card__title--small, .collection-drawer__section-title';
  var SHOWING      = '.collection__products-count-showing';
  var TOTAL        = '.collection__products-count-total';
  var SWATCH_LABEL = '.color-swatch label.color-swatch__item';
  var STATUS_ID    = 'collection-filter-status';

  // Selectors used by the old blocks in ada-pro-max.js — switched off in init().
  var OLD_CONTROL  = 'input[name^="filter"], select[name^="filter"]';
  var OLD_CHIP     = 'label.collection__active-filter-item';
  var OLD_STATUS   = 'collection-results-status';

  var ARM_MS  = 4000;
  var RETRIES = [80, 200, 400, 800, 1600, 2600];

  /* ---------- small helpers ---------- */
  function visible(el) { return !!(el && el.getClientRects().length); }

  function focusLost() {
    var a = document.activeElement;
    return !a || a === document.body || a === document.documentElement;
  }

  function clean(text) { return $.trim(String(text || '').replace(/\s+/g, ' ')); }

  function chipName(el) {
    var $c = $(el).clone();
    $c.find(CROSS).remove();
    $c.find('svg, .visually-hidden').remove();
    return clean($c.text());
  }

  function visibleChips(sel) {
    return $(sel).filter(function () { return visible(this); }).get();
  }

  function findChip(sel, name) {
    return visibleChips(sel).filter(function (el) { return chipName(el) === name; })[0] || null;
  }

  // "Elongated (40)" -> "Elongated"; swatches/switches fall back to their stored name or value.
  function fieldName(el) {
    var lbl = el.labels && el.labels[0];
    var name = '';
    if (lbl) {
      name = lbl.getAttribute('data-a11y-swatch-name') || clean($(lbl).clone().find('svg').remove().end().text());
      if (!name) { name = clean(lbl.getAttribute('aria-label')); }
    }
    return clean((name || el.value || '').replace(/\s*\(\d+\)\s*$/, ''));
  }

  function titleOf(form) {
    var t = $(form).find(TITLE).filter(function () { return visible(this); })[0];
    if (t && !t.hasAttribute('tabindex')) { t.setAttribute('tabindex', '-1'); }
    return t || null;
  }

  /* ---------- 1. announcements (single live region) ---------- */
  var statusEl = null;
  var pending  = null;   // { text, at, countTouched }

  function ensureStatus() {
    statusEl = document.getElementById(STATUS_ID);
    if (!statusEl) {
      statusEl = document.createElement('div');
      statusEl.id = STATUS_ID;
      statusEl.className = 'visually-hidden';
      statusEl.setAttribute('role', 'status');
      statusEl.setAttribute('aria-live', 'polite');
      statusEl.setAttribute('aria-atomic', 'true');
      document.body.appendChild(statusEl);
    }
  }

  function readCount() {
    var el = document.querySelector(SHOWING) || document.querySelector(TOTAL);
    return el ? clean(el.textContent) : '';
  }

  function say(text) {
    if (!statusEl || !text) { return; }
    statusEl.textContent = '';
    window.setTimeout(function () { statusEl.textContent = text; }, 150);
  }

  function queueMessage(text) {
    pending = { text: text, at: Date.now(), countTouched: false };
  }

  var lastCount = '';

  // Speak once the results have updated AND focus has settled (so focus speech can't cut it off).
  function flushMessage(force) {
    var now = readCount();
    if (pending) {
      var waited = Date.now() - pending.at;
      if (!force && (!pending.countTouched || focusLost()) && waited < 3000) { return; }
      say(clean(pending.text + ' ' + now));
      pending = null;
    } else if (now && now !== lastCount && lastCount) {
      say(now);                              // count changed for another reason (e.g. sort)
    }
    lastCount = now;
  }

  /* ---------- 2. focus plan (shared by every case) ---------- */
  var plan   = null;   // { at, fromChip, rendered(), findTarget() }
  var timers = [];

  function disarm() {
    plan = null;
    while (timers.length) { window.clearTimeout(timers.pop()); }
  }

  function arm(p) {
    disarm();
    p.at = Date.now();
    plan = p;
    $.each(RETRIES, function (i, ms) { timers.push(window.setTimeout(tick, ms)); });
    timers.push(window.setTimeout(function () { disarm(); flushMessage(true); }, ARM_MS));
  }

  function tryRestore() {
    if (!plan || !plan.rendered()) { return; }
    // Field changes: only act once the re-render has dropped focus to <body>.
    // Chip / Clear all: always land once. With NVDA in browse mode, system focus is often NOT
    // on the chip the user activated (NVDA doesn't move it by default), so "focus lost" never
    // happens and the virtual cursor would jump to the top of the page.
    if (!focusLost() && !(plan.force && !plan.landed)) { return; }
    var el = plan.findTarget.call(plan);
    if (el) {
      el.focus();
      if (document.activeElement === el) { plan.landed = true; }
    }
  }

  // Remember a field so it can be found again after the theme replaces it.
  function keyFor(el) {
    var form = el.form || $(el).closest('form')[0];
    var same = $(form).find('input, select').filter(function () {
      return this.type === el.type && (this.name || '') === (el.name || '');
    }).get();
    return { id: el.id, formId: form && form.id, name: el.name || '', type: el.type, index: same.indexOf(el) };
  }

  function resolve(key) {
    if (key.id) { return document.getElementById(key.id); }   // ids contain dots — no CSS #id
    var form = key.formId && document.getElementById(key.formId);
    if (!form) { return null; }
    return $(form).find('input, select').filter(function () {
      return this.type === key.type && (this.name || '') === key.name;
    }).get(key.index) || null;
  }

  // Case A — a filter field changed: keep focus on that field — or, if the user has already
  // tabbed on to another filter field (e.g. Min price -> Max price), on that one.
  function armField(el) {
    arm({
      field: true,
      key: keyFor(el),
      rendered: function () { return true; },
      findTarget: function () { var t = resolve(this.key); return visible(t) ? t : null; }
    });
  }

  // Case B — a chip was removed: same slot in the list (next chip), else previous, else title.
  function armChip(chip) {
    var sel   = $(chip).is(MOBILE_CHIP) ? MOBILE_CHIP : DESKTOP_CHIP;
    var list  = visibleChips(sel);
    var i     = Math.max(list.indexOf(chip), 0);
    var names = list.map(chipName);
    var order = names.slice(i + 1).concat(names.slice(0, i).reverse());
    var form  = $(chip).closest('form')[0] || document.getElementById('desktop-filters-form');

    arm({
      fromChip: true,
      force: true,
      rendered: function () { return !chip.isConnected || !visible(chip); },
      findTarget: function () {
        for (var k = 0; k < order.length; k++) {
          var next = findChip(sel, order[k]);
          if (next) { return next; }
        }
        return visibleChips(sel).length ? null : titleOf(form);   // null = still settling
      }
    });
    queueMessage(names[i] + ' filter removed.');
  }

  // Case C — "Clear all": keep focus on the panel title.
  function armClearAll(btn) {
    var form = $(btn).closest('form')[0] || document.getElementById('desktop-filters-form');
    arm({
      fromChip: true,
      force: true,
      rendered: function () { return !btn.isConnected || !visible(btn); },
      findTarget: function () { return titleOf(form); }
    });
    queueMessage('All filters cleared.');
  }

  function describeChange(el) {
    if (el.type === 'checkbox' || el.type === 'radio') {
      return fieldName(el) + ' filter ' + (el.checked ? 'applied.' : 'removed.');
    }
    var $range = $(el).closest('price-range, .price-range');
    if ($range.length) {
      var cur = clean($range.find('.input-prefix__value').first().text()) || '$';
      var n = $range.find('input[type="number"]');
      var lo = n.eq(0).val() || n.eq(0).attr('placeholder') || '0';
      var hi = n.eq(1).val() || n.eq(1).attr('placeholder') || '';
      return 'Price filter updated: ' + cur + lo + ' to ' + cur + hi + '.';
    }
    return 'Filter updated.';
  }

  /* ---------- 3. semantics (re-applied after every re-render) ---------- */

  // Chips. The theme renders each desktop chip as <label for="<checkbox id>">, which makes it a
  // SECOND label of the checkbox: NVDA then reads the checkbox as
  // "Remove filter: In stock In stock (4) check box", and activating the chip through the
  // accessibility API runs label activation, which moves focus onto the checkbox.
  // Moving "for" to data-a11y-for breaks that association; the click handler toggles the box.
  // Runs synchronously from the observer so a fresh chip never keeps "for" for long.
  function applyChips() {
    $(ANY_CHIP).filter(':not([' + CHIP_MARK + '])').each(function () {
      var name = chipName(this);
      if (!name) { return; }
      var forId = this.getAttribute('for');
      if (forId) {
        this.setAttribute('data-a11y-for', forId);
        this.removeAttribute('for');
      }
      if (this.tagName !== 'BUTTON' && this.tagName !== 'A') {
        this.setAttribute('role', 'button');
        this.setAttribute('tabindex', '0');
      }
      this.setAttribute('aria-label', 'Remove filter: ' + name);
      this.setAttribute(CHIP_MARK, '1');
      $(this).find(CROSS).attr('aria-hidden', 'true');
    });
  }

  function applySemantics() {
    applyChips();

    // Filter groups -> role="group" named by their toggle ("Size", "Brand"…)
    $(FORMS).find('.collection__filter-group > button.collection__filter-group-name[aria-controls]').each(function () {
      var panel = document.getElementById(this.getAttribute('aria-controls'));
      if (!panel || panel.getAttribute('role')) { return; }
      if (!this.id) { this.id = this.getAttribute('aria-controls') + '-label'; }
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-labelledby', this.id);
    });

    // Price: "From"/"To" appears twice each — give distinct names; sliders speak currency.
    $(FORMS).find('price-range, .price-range').each(function () {
      var cur = clean($(this).find('.input-prefix__value').first().text()) || '$';
      var r = $(this).find('input[type="range"]');
      var n = $(this).find('input[type="number"]');
      r.eq(0).attr('aria-label', 'Minimum price');
      r.eq(1).attr('aria-label', 'Maximum price');
      n.eq(0).attr('aria-label', 'Minimum price (' + cur + ')');
      n.eq(1).attr('aria-label', 'Maximum price (' + cur + ')');
      r.each(function () { this.setAttribute('aria-valuetext', cur + this.value); });
    });

    // Swatches: real text name instead of aria-label on a <label> (same marker as ada-pro-max,
    // so the two never double up).
    $(SWATCH_LABEL + ':not([data-a11y-swatch-name])').each(function () {
      var $l = $(this);
      var input = $l.closest('.color-swatch').find('input')[0];
      var name = clean($l.attr('aria-label')) || clean(input && input.value);
      if (!name) { return; }
      $l.append($('<span class="visually-hidden"></span>').text(name))
        .attr('data-a11y-swatch-name', name).removeAttr('aria-label');
    });
  }

  function injectCss() {
    if (document.getElementById('bk-filters-a11y-css')) { return; }
    $('<style id="bk-filters-a11y-css">').text(
      // The swatch checkbox is opacity:0 / width:0, so show its focus on the visible swatch.
      '.color-swatch__radio:focus-visible + .color-swatch__item,' +
      '.color-swatch__radio.is-kbd-focus + .color-swatch__item{outline:2px solid #1A5FB4;outline-offset:2px}' +
      '.collection__active-filter-item:focus-visible,' + TITLE.split(', ').join('[tabindex="-1"]:focus,') + '[tabindex="-1"]:focus' +
      '{outline:2px solid #1A5FB4;outline-offset:2px}'
    ).appendTo('head');
  }

  /* ---------- 4. activation ---------- */
  // Returns true when the chip was handled here (a checkbox chip); false = let the theme act
  // (e.g. a price chip or a mobile chip that removes the filter through its own handler).
  function activateChip(chip) {
    armChip(chip);
    var id  = chip.getAttribute('data-a11y-for') || chip.getAttribute('for');
    var box = id ? document.getElementById(id) : null;        // ids contain dots — no CSS #id
    if (!box) { return false; }
    box.click();   // toggles the checkbox -> "change" -> theme re-filters; focus is not moved
    return true;
  }

  // One debounced pass after DOM changes: re-apply semantics, restore focus, then speak.
  function tick() {
    applySemantics();
    tryRestore();
    flushMessage(false);
  }

  function init() {
    if (!document.querySelector(FORMS)) { return; }   // not a filtered collection page

    injectCss();
    ensureStatus();

    // Take over from the old filter blocks in ada-pro-max.js. Deferred with setTimeout(0) so it
    // runs after EVERY jQuery ready handler — including old blocks that appear later in the file.
    window.setTimeout(function () {
      $(document).off('change', OLD_CONTROL)        // Bug 105 (focus back to checkbox)
                 .off('click', OLD_CHIP)            // old chip block
                 .off('keydown', OLD_CHIP);
      $('[id="' + OLD_STATUS + '"]').remove();       // Bug 106 live region
    }, 0);
    applySemantics();
    lastCount = readCount();

    // Field changes: keep focus on the field and queue the confirmation.
    $(document).on('change.bkFilters', FIELDS, function () {
      if (plan && plan.fromChip && Date.now() - plan.at < 1500) { return; }  // chip/clear owns it
      armField(this);
      queueMessage(describeChange(this));
    });

    // Follow the user: if they move to another filter field before the re-render lands,
    // restore to that field instead of pulling them back.
    $(document).on('focusin.bkFilters', FIELDS, function () {
      if (plan && plan.field) { plan.key = keyFor(this); }
    });

    // Slider value text follows the thumb.
    $(document).on('input.bkFilters', FORMS.split(', ').map(function (f) { return f + ' input[type="range"]'; }).join(', '), function () {
      var cur = clean($(this).closest('price-range, .price-range').find('.input-prefix__value').first().text()) || '$';
      this.setAttribute('aria-valuetext', cur + this.value);
    });

    // Window capture = runs before anything on document, so no other chip handler can interfere.
    window.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) { return; }

      var chip = t.closest(ANY_CHIP);
      if (chip) {
        applyChips();                                  // make sure "for" is already gone
        if (activateChip(chip)) {
          // Checkbox chip: we toggled the box ourselves; stop label activation and old handlers.
          e.preventDefault();
          e.stopPropagation();
        }
        return;                                        // other chips: the theme removes them
      }

      var clear = t.closest(CLEAR_ALL);
      if (clear) { armClearAll(clear); }
    }, true);

    window.addEventListener('keydown', function (e) {
      var t = e.target;
      if (!t || !t.matches) { return; }
      var isEnter = e.key === 'Enter';
      var isSpace = e.key === ' ' || e.key === 'Spacebar';

      // Chips that are not native buttons: Enter and Space fire a click (handled above).
      if (t.matches(ANY_CHIP) && t.tagName !== 'BUTTON' && t.tagName !== 'A' && (isEnter || isSpace)) {
        e.preventDefault();
        e.stopPropagation();
        t.click();
        return;
      }

      // Filter checkboxes / swatches / switches: Enter toggles (Space is native).
      if (isEnter && t.matches(CHECKBOX) && $(t).closest(FORMS).length) {
        e.preventDefault();
        e.stopPropagation();
        t.click();
      }
    }, true);

    // One observer for everything.
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function (records) {
        applyChips();                                  // synchronous: strip "for" immediately
        if (pending) {
          for (var i = 0; i < records.length; i++) {
            var n = records[i].target;
            var el = n.nodeType === 1 ? n : n.parentNode;
            if (el && el.closest && el.closest(SHOWING + ', ' + TOTAL)) { pending.countTouched = true; break; }
          }
        }
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; tick(); }, 60);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  $(init);
}(jQuery));



/*! focus-not-obscured
 * focus-not-obscured.js — BidetKing (Warehouse v4), site-wide
 * WCAG 2.4.11 Focus Not Obscured (Minimum) / 2.4.12 (Enhanced)
 *
 * Problem: the header group is position:sticky (197px tall at ~1000px wide, the nav wraps onto a
 * second row). When focus moves BACKWARD (Shift+Tab), the browser only scrolls if the element is
 * outside the viewport. An element sitting at y=29–47 counts as "in view", so nothing scrolls and
 * the sticky header covers it (reproduced: "Display products as list/grid" buttons at top=29 under
 * a header ending at 197). Fixed bars at the bottom (Shopify cookie banner, preview bar) do the
 * same when moving forward.
 *
 * Fix:
 *  1. CSS scroll-padding on <html>, kept equal to the live sticky-header height, so the browser's
 *     own focus scrolling already leaves room for the header.
 *  2. After every keyboard focus move, hit-test the focused element. If a fixed/sticky layer that
 *     does not contain it is painted over it (top or bottom), scroll just enough to reveal it with
 *     a margin for the focus ring. Pointer focus is left alone.
 * Load after jQuery, on every page:
 *   <script src="{{ 'focus-not-obscured.js' | asset_url }}" defer="defer"></script>
 */
(function ($) {
  'use strict';

  if (window.__bkFocusNotObscured) { return; }
  window.__bkFocusNotObscured = true;

  var HEADER = '.shopify-section-group-header-group';   // Warehouse header group (sticky)
  var GAP    = 12;                                      // room for the 2–3px focus ring + breathing space
  var lastPointer = 0;

  /* ---------- 1. scroll-padding that follows the real header height ---------- */
  function stickyHeaderHeight() {
    var h = 0;
    $(HEADER).each(function () {
      var cs = window.getComputedStyle(this);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && this.getClientRects().length) {
        h = Math.max(h, this.getBoundingClientRect().height);
      }
    });
    return Math.round(h);
  }

  function updatePadding() {
    document.documentElement.style.setProperty('--bk-sticky-top', stickyHeaderHeight() + 'px');
  }

  function injectCss() {
    if (document.getElementById('bk-focus-visible-css')) { return; }
    $('<style id="bk-focus-visible-css">').text(
      'html{scroll-padding-top:calc(var(--bk-sticky-top,0px) + ' + GAP + 'px);' +
      'scroll-padding-bottom:' + GAP + 'px}'
    ).appendTo('head');
  }

  /* ---------- 2. hit-test safety net ---------- */
  function isOverlay(el) {
    var cs = window.getComputedStyle(el);
    return (cs.position === 'fixed' || cs.position === 'sticky') &&
           cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0;
  }

  // Walk up from a hit element to the fixed/sticky layer it belongs to (if any).
  function overlayFor(hit, focused) {
    for (var n = hit; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      if (n === focused || n.contains(focused) || focused.contains(n)) { return null; }
      if (isOverlay(n)) { return n; }
    }
    return null;
  }

  // The swatch checkboxes are 0×0 with the ring on the label — measure what is actually visible.
  function visibleBox(el) {
    var r = el.getBoundingClientRect();
    if ((r.width < 2 || r.height < 2) && el.labels && el.labels[0]) {
      r = el.labels[0].getBoundingClientRect();
    }
    return r;
  }

  function reveal(el) {
    if (!el || el === document.body || !el.getClientRects().length) { return; }
    var r = visibleBox(el);
    if (r.width === 0 && r.height === 0) { return; }

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth  || document.documentElement.clientWidth;
    var xs = [r.left + 4, r.left + r.width / 2, r.right - 4].map(function (x) {
      return Math.min(Math.max(x, 1), vw - 2);
    });
    var ys = [r.top + 2, r.top + r.height / 2, r.bottom - 2];

    var topLimit = 0;
    var bottomLimit = vh;

    xs.forEach(function (x) {
      ys.forEach(function (y) {
        if (y < 0 || y >= vh) { return; }
        var hits = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [document.elementFromPoint(x, y)];
        for (var i = 0; i < hits.length; i++) {
          var h = hits[i];
          if (!h || h === el || el.contains(h) || h.contains(el)) { break; }   // reached the element itself
          var layer = overlayFor(h, el);
          if (!layer) { continue; }
          var lr = layer.getBoundingClientRect();
          if (lr.top <= vh / 2 && lr.bottom < vh * 0.75) { topLimit = Math.max(topLimit, lr.bottom); }
          else if (lr.top > vh / 4)                      { bottomLimit = Math.min(bottomLimit, lr.top); }
        }
      });
    });

    var delta = 0;
    if (r.top < topLimit + GAP) {
      delta = r.top - topLimit - GAP;                                 // scroll up
    } else if (r.bottom > bottomLimit - GAP) {
      delta = Math.min(r.bottom - bottomLimit + GAP,                  // scroll down…
                       r.top - topLimit - GAP);                       // …but never under the header
    }
    if (delta) { window.scrollBy(0, delta); }
  }

  /* ---------- wiring ---------- */
  function init() {
    injectCss();
    updatePadding();

    $(window).on('resize.bkFocus orientationchange.bkFocus', updatePadding);
    if (window.ResizeObserver) {
      $(HEADER).each(function () { new ResizeObserver(updatePadding).observe(this); });
    }

    // Only keyboard-driven focus: a click already shows the user where they are.
    document.addEventListener('pointerdown', function () { lastPointer = Date.now(); }, true);
    document.addEventListener('mousedown',   function () { lastPointer = Date.now(); }, true);

    document.addEventListener('focusin', function (e) {
      if (Date.now() - lastPointer < 400) { return; }
      var el = e.target;
      // Let the browser (and any script) finish its own scroll first, then correct it.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (document.activeElement === el) { reveal(el); }
        });
      });
    }, true);
  }

  $(init);
}(jQuery));


/*! product-gallery-zoom-fix
 * product-gallery-zoom-fix.js — BidetKing product pages (Warehouse v4)
 * Load after jQuery and ada-pro-max.js:
 *   <script src="{{ 'product-gallery-zoom-fix.js' | asset_url }}" defer="defer"></script>
 *
 * 1. "View full-size image" opened an EMPTY overlay.                         WCAG 2.1.1
 *    ada-wave.js runs  $("#a11y-zoom-dialog div").remove()  shortly after load (to silence a
 *    WAVE flag on the empty <img>), which deletes the dialog's image container. The button still
 *    opens the overlay, but only the Close button is inside it. This file opens its own dialog
 *    (#bk-zoom-dialog) and builds the image only while it is open, so nothing empty sits in the
 *    DOM for WAVE to flag and nothing for ada-wave.js to delete.
 *    Dialog: role="dialog", aria-modal, named by the product image's alt, focus trapped,
 *    Escape / Close / backdrop close, focus returns to the button.
 *
 * 2. Tab order didn't match the layout, so after picking a thumbnail Tab never reached the button.
 *                                                                          WCAG 2.4.3, 1.3.2
 *    At ≥1000px the gallery is  flex-direction: row-reverse  — the thumbnails SHOW on the left but
 *    come AFTER the main image and the button in the DOM. The script moves the thumbnail column
 *    in front of the image at ≥1000px (and switches the row to normal order so it looks the same),
 *    and puts it back below 1000px, where the thumbnails sit under the image.
 *
 * 3. The thumbnails are one tab stop (roving tabindex). Arrow keys move between them, Home/End jump
 *    to the ends, Enter or Space shows the image. So: pick an image -> Tab -> "View full-size image".
 *
 * 4. YouTube iframes in slides that are NOT showing were still in the tab order (between the
 *    thumbnails and the button). Only the showing slide's iframe is focusable now.
 */
(function ($) {
  'use strict';

  if (window.__bkGalleryZoomFix) { return; }
  window.__bkGalleryZoomFix = true;

  var GALLERY   = '.product-gallery--with-thumbnails';
  var CAROUSEL  = '.product-gallery__carousel-wrapper';
  var THUMB_COL = '.scroller';                          // wraps .product-gallery__thumbnail-list
  var THUMB     = 'a.product-gallery__thumbnail';
  var SELECTED_THUMB = 'is-nav-selected';
  var SLIDE     = '.product-gallery__carousel-item';
  var SELECTED  = '.product-gallery__carousel-item.is-selected';
  var IMAGE     = 'img.product-gallery__image';
  var BUTTON_ID = 'a11y-zoom-button';                   // button created by ada-pro-max.js
  var DLG_ID    = 'bk-zoom-dialog';
  var DESKTOP   = window.matchMedia ? window.matchMedia('(min-width: 1000px)') : null;

  /* ---------- CSS ---------- */
  function injectCss() {
    if (document.getElementById('bk-gallery-zoom-css')) { return; }
    $('<style id="bk-gallery-zoom-css">').text(
      '@media screen and (min-width:1000px){' + GALLERY + '.bk-dom-order{flex-direction:row}}' +
      '#' + DLG_ID + '{position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;' +
        'background:rgba(0,0,0,.85);padding:3.5rem 1rem 1rem}' +
      '#' + DLG_ID + '[hidden]{display:none!important}' +
      '#' + DLG_ID + ' .bk-zoom-figure{max-width:94vw;max-height:calc(100vh - 5rem);overflow:auto;background:#fff;margin:0}' +
      '#' + DLG_ID + ' .bk-zoom-figure:focus-visible{outline:3px solid #fff;outline-offset:2px}' +
      '#' + DLG_ID + ' img{display:block;max-width:none;height:auto}' +
      '#' + DLG_ID + ' .bk-zoom-close{position:absolute;top:1rem;right:1rem;padding:.4em .9em;border:2px solid #fff;' +
        'background:#354561;color:#fff;font:inherit;cursor:pointer;border-radius:3px}' +
      '#' + DLG_ID + ' .bk-zoom-close:focus-visible{outline:3px solid #fff;outline-offset:2px}'
    ).appendTo('head');
  }

  /* ---------- 1. zoom dialog ---------- */
  var dialog, closeBtn, opener = null;

  function buildDialog() {
    dialog = document.createElement('div');
    dialog.id = DLG_ID;
    dialog.hidden = true;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Full-size product image');

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'bk-zoom-close';
    closeBtn.textContent = 'Close';
    dialog.appendChild(closeBtn);
    document.body.appendChild(dialog);

    closeBtn.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) { closeDialog(); } });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); closeDialog(); return; }
      if (e.key !== 'Tab') { return; }
      var stops = [dialog.querySelector('.bk-zoom-figure'), closeBtn].filter(Boolean);
      var i = stops.indexOf(document.activeElement);
      var next = e.shiftKey ? (i <= 0 ? stops.length - 1 : i - 1) : (i === stops.length - 1 ? 0 : i + 1);
      e.preventDefault();
      stops[next].focus();
    });
  }

  function currentImage() {
    var slide = document.querySelector(SELECTED);
    return slide ? slide.querySelector(IMAGE) : null;
  }

  function openDialog(fromEl) {
    var img = currentImage();
    if (!img) { return; }
    var alt = $.trim(img.getAttribute('alt') || '');

    // Built on open, removed on close: no empty <img> left in the page.
    var figure = document.createElement('figure');
    figure.className = 'bk-zoom-figure';
    figure.setAttribute('tabindex', '0');                 // lets keyboard users scroll a large image
    figure.setAttribute('aria-label', alt ? alt + ' (full size, scroll with arrow keys)' : 'Full-size image, scroll with arrow keys');
    var big = document.createElement('img');
    big.alt = alt;
    big.src = img.getAttribute('data-zoom') || img.currentSrc || img.src;
    figure.appendChild(big);
    dialog.insertBefore(figure, closeBtn);

    dialog.setAttribute('aria-label', alt ? 'Full-size image: ' + alt : 'Full-size product image');
    opener = fromEl || document.activeElement;
    dialog.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeDialog() {
    if (!dialog || dialog.hidden) { return; }
    dialog.hidden = true;
    $(dialog).find('.bk-zoom-figure').remove();
    document.documentElement.style.overflow = '';
    var back = opener && opener.isConnected ? opener : document.getElementById(BUTTON_ID);
    if (back) { back.focus(); }
    opener = null;
  }

  /* ---------- 2. DOM order matches the visual order ---------- */
  function syncOrder() {
    $(GALLERY).each(function () {
      var gallery  = this;
      var carousel = $(gallery).children(CAROUSEL)[0];
      var thumbs   = $(gallery).children(THUMB_COL)[0];
      if (!carousel || !thumbs) { return; }
      var desktop = DESKTOP ? DESKTOP.matches : window.innerWidth >= 1000;
      if (desktop && thumbs.nextElementSibling !== carousel) {
        gallery.insertBefore(thumbs, carousel);            // thumbnails first (they show on the left)
        gallery.classList.add('bk-dom-order');
      } else if (!desktop && carousel.nextElementSibling !== thumbs) {
        gallery.insertBefore(thumbs, carousel.nextSibling); // thumbnails after the image (they show below)
        gallery.classList.remove('bk-dom-order');
      }
    });
  }

  /* ---------- 3. thumbnails: one tab stop, arrow keys ---------- */
  function thumbs() { return $(THUMB).filter(function () { return this.getClientRects().length; }).get(); }

  function syncThumbTabindex() {
    var list = thumbs();
    if (!list.length) { return; }
    var current = list.filter(function (t) { return t.classList.contains(SELECTED_THUMB); })[0] || list[0];
    // Keep the tab stop on whichever thumbnail has focus, so arrowing doesn't lose it.
    if (list.indexOf(document.activeElement) !== -1) { current = document.activeElement; }
    list.forEach(function (t) { t.setAttribute('tabindex', t === current ? '0' : '-1'); });
  }

  function onThumbKey(e) {
    var list = thumbs();
    var i = list.indexOf(this);
    if (i === -1) { return; }
    var next = null;
    switch (e.key) {
      case 'ArrowDown': case 'ArrowRight': next = list[Math.min(i + 1, list.length - 1)]; break;
      case 'ArrowUp':   case 'ArrowLeft':  next = list[Math.max(i - 1, 0)]; break;
      case 'Home': next = list[0]; break;
      case 'End':  next = list[list.length - 1]; break;
      case ' ': case 'Spacebar':
        e.preventDefault();
        this.click();                                      // links don't react to Space natively
        return;
      default: return;
    }
    e.preventDefault();
    list.forEach(function (t) { t.setAttribute('tabindex', t === next ? '0' : '-1'); });
    next.focus();
    if (next.scrollIntoView) { next.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
  }

  /* ---------- 4. iframes in hidden slides out of the tab order ---------- */
  function syncSlideFocusables() {
    $(SLIDE).each(function () {
      var showing = this.classList.contains('is-selected');
      $(this).find('iframe, video').each(function () {
        if (showing) { this.removeAttribute('tabindex'); } else { this.setAttribute('tabindex', '-1'); }
      });
    });
  }

  /* ---------- wiring ---------- */
  function sync() {
    syncOrder();
    syncThumbTabindex();
    syncSlideFocusables();
  }

  function init() {
    if (!document.querySelector(SLIDE)) { return; }       // not a product page
    injectCss();
    buildDialog();
    sync();

    // Take over the "View full-size image" button (window capture runs before its own listener,
    // which would open the emptied #a11y-zoom-dialog).
    window.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('#' + BUTTON_ID);
      if (!btn) { return; }
      e.preventDefault();
      e.stopPropagation();
      openDialog(btn);
    }, true);

    $(document).on('keydown.bkGallery', THUMB, onThumbKey);

    if (DESKTOP) {
      if (DESKTOP.addEventListener) { DESKTOP.addEventListener('change', syncOrder); }
      else if (DESKTOP.addListener) { DESKTOP.addListener(syncOrder); }
    }

    // Slide / thumbnail selection is class-driven; re-sync when it changes.
    var root = document.querySelector('.product-gallery') || document.body;
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) { return; }
        queued = true;
        window.setTimeout(function () { queued = false; syncThumbTabindex(); syncSlideFocusables(); }, 60);
      }).observe(root, { attributes: true, subtree: true, attributeFilter: ['class'], childList: true });
    }
  }

  $(init);
}(jQuery));


/*! product-quantity-announce
 * product-quantity-announce.js — BidetKing product page + quick view (Warehouse v4)
 * WCAG 4.1.3 Status Messages
 *
 * Problem: the product-form quantity picker (<quantity-picker> in form[action="/cart/add"]) is
 * updated by theme.js (_onIncrease / _onDecrease write the new value into the input and fire
 * "change"), but nothing is announced. Focus stays on the +/- button, so a screen reader user
 * hears only "Increase quantity, button" and never the new number. Verified: Enter and Space on
 * "Increase quantity" took the value 1 -> 2 -> 3 with no live-region update anywhere on the page.
 * (The mini cart and the cart page already announce through #cart-live-region, so they are
 * left alone here.)
 *
 * Fix: one polite status region. After each +/- press, once the theme has written the value:
 *   "Quantity 3"                                  (increase / decrease)
 *   "Quantity 1. Minimum quantity is 1."          (decrease pressed at the minimum)
 *   "Quantity 10. Maximum quantity is 10."        (increase pressed at a max, if one is set)
 * Typing in the field is not announced — the field itself is read back while editing.
 *
 * Load after jQuery:
 *   <script src="{{ 'product-quantity-announce.js' | asset_url }}" defer="defer"></script>
 */
(function ($) {
  'use strict';

  if (window.__bkQtyAnnounce) { return; }
  window.__bkQtyAnnounce = true;

  var PICKER    = 'quantity-picker, .quantity-selector';
  var BUTTON    = '[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]';
  var INPUT     = 'input.quantity-selector__value, input[name="quantity"]';
  var SKIP      = '#mini-cart, .mini-cart, tr.line-item, .line-item';   // already announced elsewhere
  var STATUS_ID = 'bk-qty-status';

  var status = null;
  var timer  = null;

  function ensureStatus() {
    status = document.getElementById(STATUS_ID);
    if (status) { return; }
    status = document.createElement('div');
    status.id = STATUS_ID;
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    document.body.appendChild(status);
  }

  // Clear, then set: the same text twice in a row (e.g. two presses at the minimum) is re-read.
  function say(text) {
    ensureStatus();
    window.clearTimeout(timer);
    status.textContent = '';
    timer = window.setTimeout(function () { status.textContent = text; }, 100);
  }

  function num(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? null : n;
  }

  function onPress(btn) {
    var picker = btn.closest(PICKER);
    if (!picker || picker.closest(SKIP)) { return; }
    var input = picker.querySelector(INPUT);
    if (!input) { return; }

    var before = num(input.value);
    var isDecrease = btn.getAttribute('data-action') === 'decrease-picker-quantity';

    // Let theme.js write the new value first (it runs in the same click, after this listener).
    window.setTimeout(function () {
      var after = num(input.value);
      if (after === null) { return; }
      var min = num(input.getAttribute('min'));
      var max = num(input.getAttribute('max'));
      var msg = 'Quantity ' + after;

      if (after === before) {
        if (isDecrease && min !== null && after <= min)  { msg += '. Minimum quantity is ' + min + '.'; }
        else if (!isDecrease && max !== null && after >= max) { msg += '. Maximum quantity is ' + max + '.'; }
      }
      say(msg);
    }, 0);
  }

  function init() {
    if (!document.querySelector(PICKER)) { return; }
    ensureStatus();

    // Capture phase: record the value BEFORE the theme's (delegated) handler changes it.
    // Keyboard Enter/Space on a <button> fires this same click event.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest(BUTTON);
      if (btn) { onPress(btn); }
    }, true);
  }

  $(init);
}(jQuery));



/*! menu-parent-link-keyboard
 * menu-parent-link-keyboard.js — BidetKing desktop mega menu (tmenu + ada.js toggles)
 *
 * Each top-level item is two tab stops: the parent link ("Bidet Seats") and the chevron button
 * ("Expand Bidet Seats submenu"). When the SAME page is already offered inside the submenu
 * ("View All Bidet Seats"), the parent link is a redundant stop for keyboard users. This removes
 * it from the tab order (tabindex="-1") and from the accessibility tree (aria-hidden="true") —
 * the same treatment ada.js already gives Brands / Research, whose parent links go nowhere.
 * Mouse users can still click the parent link.
 *
 * A parent link is only hidden when the submenu has a link to the same URL whose text makes that
 * clear: it contains the parent's name, or says "View all" / "Shop all".
 *   Bidet Seats    -> hidden ("View All Bidet Seats")
 *   Sale & Offers  -> hidden ("View All Sale Items")
 *   Bidet Toilet Combos -> kept: the only same-URL link is the "BidetKing" brand tile, which does
 *                          not tell a keyboard user it leads to all combos
 *   Non-Electric Bidets, Accessories, Support -> kept: no same-URL link in the submenu
 *
 * Submenus are rendered lazily by tmenu (ada.js pre-renders them), so this re-checks whenever
 * the menu changes. Load after jQuery and ada.js:
 *   <script src="{{ 'menu-parent-link-keyboard.js' | asset_url }}" defer="defer"></script>
 */
(function ($) {
  'use strict';

  if (window.__bkMenuParentLinks) { return; }
  window.__bkMenuParentLinks = true;

  var ROOT   = '.tmenu_app_desktop .tmenu_item--root';
  var TOGGLE = ':scope > button.tmenu-a11y-toggle';
  var MARK   = 'data-bk-parent-hidden';

  function path(href) {
    if (!href || /^javascript:/i.test(href) || href === '#') { return null; }
    try { return new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/'; }
    catch (e) { return null; }
  }

  function clean(s) { return $.trim(String(s || '').replace(/\s+/g, ' ')).toLowerCase(); }

  function check(li) {
    if (li.hasAttribute(MARK)) { return; }
    var btn  = li.querySelector(TOGGLE);
    var link = li.querySelector(':scope > a.tmenu_item_link');
    if (!btn || !link || link.getAttribute('tabindex') === '-1') { return; }   // toggle-only already

    var sub = document.getElementById(btn.getAttribute('aria-controls'));
    if (!sub || !sub.querySelector('a[href]')) { return; }                     // not rendered yet

    var target = path(link.getAttribute('href'));
    var name   = clean(($(link).find('.tmenu_item_text').text()) || link.textContent);
    if (!target) { li.setAttribute(MARK, 'no'); return; }

    var equivalent = $(sub).find('a[href]').filter(function () {
      if (path(this.getAttribute('href')) !== target) { return false; }
      var t = clean(this.textContent || this.getAttribute('aria-label'));
      return t.indexOf(name) !== -1 || /\b(view|shop) all\b/.test(t);
    })[0];

    if (equivalent) {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
      li.setAttribute(MARK, 'yes');
    } else {
      li.setAttribute(MARK, 'no');
    }
  }

  function scan() {
    var pending = 0;
    $(ROOT).each(function () {
      check(this);
      if (!this.hasAttribute(MARK) && this.querySelector(TOGGLE)) { pending++; }
    });
    return pending;
  }

  function init() {
    var menu = document.querySelector('.tmenu_app_desktop');
    if (!menu) { return; }
    if (!scan()) { return; }
    if (!window.MutationObserver) { return; }
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) { return; }
      queued = true;
      window.setTimeout(function () {
        queued = false;
        if (!scan()) { mo.disconnect(); }                // every item decided — stop watching
      }, 150);
    });
    mo.observe(menu, { childList: true, subtree: true });
  }

  $(init);
}(jQuery));
